import Vue from "vue"
const API_LIST = {
  //根据searchId查询单个的检索方案
  searchQuerySearchPlanById: {
    method: "post",
    url: "/search/querySearchPlanById",
    config: {},
  },
  //根据extractId查询单个的提取方案
  extractQueryExtractLinkById: {
    method: "post",
    url: "/extract/queryExtractLinkById",
    config: {},
  },
  //新增用户权限记录
  menuRecordAddMenuRecord: {
    method: "post",
    url: "/menuRecord/addMenuRecord",
    config: {},
  },
  //查询常用功能
  menuRecordQueryConstantRecord: {
    method: "post",
    url: "/menuRecord/queryConstantRecord",
    config: {},
  },
  //查询历史记录
  menuRecordQueryHisRecord: {
    method: "post",
    url: "/menuRecord/queryHisRecord",
    config: {},
  },
  // 流程图
  penetrateAllInfo: {
    method: "post",
    url: "/penetrate/penetrateAllInfo",
    config: {},
  },
  // 获取登录验证码
  getLoginCode: {
    method: "get",
    url: "/Login/verificationcode",
    config: {
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
    },
  },
  // 用户登录
  userLogin: {
    method: "post",
    url: "/Login/login",
    config: {},
  },
  // 登录////
  loginAcquireOrm: {
    method: "post",
    url: "/Login/acquireOrm",
    config: {},
  },
  // 用户退登前操作
  deleteUserBillNum: {
    method: "post",
    url: "/extract/deleteUserBillNum",
    config: {},
  },
  // 用户退登
  loginOut: {
    method: "post",
    url: "/Login/logout",
    config: {},
  },

  // 获取字典类别
  getDictionariesCate: {
    method: "get",
    url: "/dict/querytype",
    config: {},
  },

  // 新增字典数据
  addDictionariesData: {
    method: "post",
    url: "/dict/add",
    config: {},
  },

  // 字典分页查询
  getDictionariesList: {
    method: "post",
    url: "/dict/query",
    config: {},
  },
  // 查询我的待办的总数量
  homeQueryTaskNumber: {
    method: "post",
    url: "/desystask/queryTaskNumber",
    config: {
      noPassJur: true,
    },
  },
  // 查询S审核任务
  homeQueryAuditTask: {
    method: "post",
    url: "/desystask/queryAuditTask",
    config: {
      noPassJur: true,
    },
  },
  // 查询S待办事项
  homeQueryMyNeed: {
    method: "post",
    url: "/desystask/queryMyNeed",
    config: {
      noPassJur: true,
    },
  },
  // 查询S追踪任务
  homeQueryMyTracking: {
    method: "post",
    url: "/desystask/queryMyTracking",
    config: {
      noPassJur: true,
    },
  },
  // 查询我的已完成
  homeQueryFinish: {
    method: "post",
    url: "/desystask/queryFinish",
    config: {
      noPassJur: true,
    },
  },
  // 查询近效期数量
  homeQueryJxqCount: {
    method: "post",
    url: "/desystask/queryJxqCount",
    config: {
      noPassJur: true,
    },
  },
  // 查询效期预警
  homeQueryXqyjCount: {
    method: "post",
    url: "/desystask/queryXqyjCount",
    config: {
      noPassJur: true,
    },
  },
  // 查询超时
  homeQueryOuttime: {
    method: "post",
    url: "/desystask/queryOuttime",
    config: {
      noPassJur: true,
    },
  },
  // 查询滞销
  homeQueryZxCount: {
    method: "post",
    url: "/desystask/queryZxCount",
    config: {
      noPassJur: true,
    },
  },
  // 查询缺货
  homeQueryQhCount: {
    method: "post",
    url: "/desystask/queryOutstock",
    config: {
      noPassJur: true,
    },
  },
  // 读取公告
  homeAddReader: {
    method: "post",
    url: "/publicNotice/addReader",
    config: {},
  },
  // 编辑数据字典
  setDictionariesData: {
    method: "post",
    url: "/dict/modify",
    config: {},
  },

  // 删除数据字典
  delDictionariesData: {
    method: "post",
    url: "/dict/delete",
    config: {},
  },

  // 根据获取字典项，传递单个id列表
  getCateDictionariesData: {
    method: "post",
    url: "/dict/queryOneType",
    config: {},
  },

  //查询当前用户的订阅信息
  queryUserSubscribeData: {
    method: "post",
    url: "/subscribe/queryUserSubscribeData",
    config: {},
  },
  //设置当前用户的订阅信息
  setSubscribeStatus: {
    method: "post",
    url: "/subscribe/setSubscribeStatus",
    config: {},
  },
  //查询当前用户的板块订阅信息
  getSubscribePlate: {
    method: "post",
    url: "/subscribe/getPlate",
    config: {},
  },

  //首页获取任务头部数据
  getQueryTaskCount: {
    method: "post",
    url: "/desystask/queryTaskCount",
    config: {},
  },
  // 首页任务面板获取数据
  getQueryTaskByType: {
    method: "post",
    url: "/desystask/queryTaskByType",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询近30天所有任务信息
  getQueryAllTask: {
    method: "post",
    url: "/desystask/queryAllTask",
    config: {},
  },

  // 首页查询本周出入库数据
  getQueryInOutData: {
    method: "post",
    url: "/desystask/queryInOutData",
    config: {},
  },

  // 首页查询本月任务信息
  getQueryTaskData: {
    method: "post",
    url: "/desystask/queryTaskData",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 首页查询指定时间任务信息
  getQueryTaskDataByDate: {
    method: "post",
    url: "/desystask/queryTaskDataByDate",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首页修改任务状态
  updateTaskStatus: {
    method: "post",
    url: "/desystask/updateTaskStatus",
    config: {},
  },
  // 自定义新增任务
  desystaskAddTask: {
    method: "post",
    url: "/desystask/addTask",
    config: {},
  },

  // 首页查询预警信息
  getQueryWarnCount: {
    method: "post",
    url: "/desystask/queryWarnCount",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增办公用品
  addOfficeSupplies: {
    method: "post",
    url: "/officeSupplies/add",
    config: {},
  },

  // 查询办公用品
  getOfficeSuppliesList: {
    method: "post",
    url: "/officeSupplies/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除办公用品
  delOfficeSuppliesList: {
    method: "post",
    url: "/officeSupplies/delete",
    config: {},
  },

  // 修改办公用品
  editOfficeSupplies: {
    method: "post",
    url: "/officeSupplies/modify",
    config: {},
  },

  // 新增组织分类
  addOrganizationType: {
    method: "post",
    url: "/Organization/addgroup",
    config: {},
  },

  // 组织分类查询
  getOrganizationType: {
    method: "post",
    url: "/Organization/queryGroup",
    config: {},
  },

  // 删除组织分类
  delOrganizationType: {
    method: "post",
    url: "/Organization/deletegroup",
    config: {},
  },

  // 修改组织分类
  setOrganizationType: {
    method: "post",
    url: "/Organization/modifygroup",
    config: {},
  },

  // 获取全部组织
  getALLOrg: {
    method: "get",
    url: "/Organization/queryAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增组织
  addOrganization: {
    method: "post",
    url: "/Organization/add",
    config: {},
  },

  // 组织列表查询
  getOrganization: {
    method: "post",
    url: "/Organization/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除组织信息
  delOrganization: {
    method: "post",
    url: "/Organization/delete",
    config: {},
  },

  // 修改组织信息
  setOrganization: {
    method: "post",
    url: "/Organization/modify",
    config: {},
  },
  // 设置组织范围
  setOrmScope: {
    method: "post",
    url: "/Organization/setOrmScope",
    config: {},
  },

  // 获取部门信息
  getDepartmentList: {
    method: "post",
    url: "/Department/query",
    config: {},
  },

  // 获取所有部门信息
  getAllDepartmentList: {
    method: "post",
    url: "/Department/queryAll",
    config: {},
  },

  // 新增部门信息
  addDepartment: {
    method: "post",
    url: "/Department/add",
    config: {},
  },

  // 编辑部门信息
  editDepartment: {
    method: "post",
    url: "/Department/modify",
    config: {},
  },

  // 删除部门信息
  delDepartment: {
    method: "post",
    url: "/Department/delete",
    config: {},
  },

  // 修改部门状态
  setDepartmentStatus: {
    method: "post",
    url: "/Department/stop",
    config: {},
  },

  // 获取人员列表
  getUserList: {
    method: "post",
    url: "/Operator/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增人员
  addUser: {
    method: "post",
    url: "/Operator/add",
    config: {},
  },

  // 编辑人员
  editUser: {
    method: "post",
    url: "/Operator/modify",
    config: {},
  },

  // 删除人员
  delUser: {
    method: "post",
    url: "/Operator/delete",
    config: {},
  },

  // 修改人员状态
  setUserStatus: {
    method: "post",
    url: "/Operator/stop",
    config: {},
  },

  // 人员分组查询
  userGroupList: {
    method: "post",
    url: "/Operator/groupquery",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除人员分组
  delUserGroup: {
    method: "post",
    url: "/Operator/deletegroup",
    config: {},
  },

  // 新增人员分组
  addUserGroup: {
    method: "post",
    url: "/Operator/addgroup",
    config: {},
  },

  // 修改人员分组
  editUserGroup: {
    method: "post",
    url: "/Operator/modifygroup",
    config: {},
  },
  // 组件权限列表
  desysModulequeryModule: {
    method: "post",
    url: "/desysModule/queryModule",
    config: {},
  },
  // 已设置组件权限
  desysModulequeryUserjurisdiction: {
    method: "post",
    url: "/desysModule/queryUserjurisdiction",
    config: {},
  },
  // 设置组件权限
  desysModulesetUserjurisdiction: {
    method: "post",
    url: "/desysModule/setUserjurisdiction",
    config: {},
  },

  // 获取所有权限
  getJurisdictionList: {
    method: "post",
    url: "/Jurisdiction/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增权限信息
  addJurisdictionList: {
    method: "post",
    url: "/Jurisdiction/jurisAdd",
    config: {},
  },

  // 新增编辑信息
  setJurisdictionList: {
    method: "post",
    url: "/Jurisdiction/jurisUpdate",
    config: {},
  },

  // 获取权限模板
  getJurisdictionTemplate: {
    method: "get",
    url: "/Jurisdiction/querytemplate",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询组织列表
  OrganizationqueryCurrentOrm: {
    method: "post",
    url: "/Organization/queryCurrentOrm",
    config: {},
  },
  // 数据备份
  OrganizationbackUpOrmData: {
    method: "post",
    url: "/Organization/backUpOrmData",
    config: {},
  },
  // 数据备份查询
  OrganizationqueryBackUpOrmData: {
    method: "post",
    url: "/Organization/queryBackUpOrmData",
    config: {},
  },

  // 新增权限模板
  addJurisdictionTemplate: {
    method: "post",
    url: "/Jurisdiction/addtemplate",
    config: {},
  },

  // 修改权限模板
  setJurisdictionTemplate: {
    method: "post",
    url: "/Jurisdiction/modifyTemplate",
    config: {},
  },

  // 删除权限模板
  delJurisdictionTemplate: {
    method: "post",
    url: "/Jurisdiction/deletetemplate",
    config: {},
  },

  // 停用/启用组织
  setOrganizationStatus: {
    method: "post",
    url: "/Organization/stop",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取所有组织分组
  getOrganizationAllGroup: {
    method: "get",
    url: "/Organization/queryGroupAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 设置组织分组
  settingOrganizationGroup: {
    method: "post",
    url: "/Organization/group",
    config: {},
  },

  // 新增车辆信息
  addCarInfo: {
    method: "post",
    url: "/Vehicle/add",
    config: {},
  },

  // 编辑车辆信息
  editCarInfo: {
    method: "post",
    url: "/Vehicle/modify",
    config: {},
  },

  // 获取车辆列表
  getCarList: {
    method: "post",
    url: "/Vehicle/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除车辆列表
  delCarList: {
    method: "post",
    url: "/Vehicle/delete",
    config: {},
  },

  // 更新用户在线时间
  setUserLine: {
    method: "post",
    url: "/Login/online",
    config: {
      noPassJur: true,
    },
  },

  // 获取用户权限
  getUserJurisdiction: {
    method: "post",
    url: "/Jurisdiction/personquery",
    config: {},
  },

  // 保存用户权限
  saveUserJurisdiction: {
    method: "post",
    url: "/Jurisdiction/personsave",
    config: {},
  },

  // 收藏菜单
  collectionMenu: {
    method: "post",
    url: "/Jurisdiction/enshrineMenu",
    config: {},
  },

  // 查询用户收藏的菜单
  getUserMenu: {
    method: "post",
    url: "/Jurisdiction/queryEnshrineMenu",
    config: {},
  },

  // 获取菜单可配置项
  getMenuSetupList: {
    method: "post",
    url: "/jurconfig/jur",
    config: {},
  },

  // 获取可定制的菜单列表
  getYesCustomMenuList: {
    method: "post",
    url: "/Jurisdiction/customQuery",
    config: {},
  },

  // 获取可定制的菜单列表
  getFieldSelectList: {
    method: "get",
    url: "/jurconfig/options",
    config: {},
  },

  // 修改字段配置项
  setFieldSelec: {
    method: "post",
    url: "/jurconfig/modify",
    config: {},
  },

  // 获取库房列表
  getStorageRoom: {
    method: "post",
    url: "/StorageRoom/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取可用库房列表
  getUsableStorageRoom: {
    method: "post",
    url: "/StorageRoom",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库房信息
  addStorageRoom: {
    method: "post",
    url: "/StorageRoom/add",
    config: {},
  },

  // 修改库房信息
  setStorageRoom: {
    method: "post",
    url: "/StorageRoom/modify",
    config: {},
  },

  // 删除库房信息
  delStorageRoom: {
    method: "post",
    url: "/StorageRoom/delete",
    config: {},
  },

  // 修改库房状态
  setStorageRoomStatus: {
    method: "post",
    url: "/StorageRoom/stop",
    config: {},
  },

  // 获取装车单记录
  transportdocQuery: {
    method: "post",
    url: "/transportdoc/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增装车单
  transportdocAdd: {
    method: "post",
    url: "/transportdoc/add",
    config: {},
  },
  // 删除装车单
  transportdocDelete: {
    method: "post",
    url: "/transportdoc/delete",
    config: {},
  },
  // 获取装车已记账销售记账单
  transportdocQueryOrder: {
    method: "post",
    url: "/transportdoc/queryOrder",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取卸车单登记表
  unloadQuery: {
    method: "post",
    url: "/unload/queryReceive",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取卸车单记录
  unloadRecordQuery: {
    method: "post",
    url: "/unload/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增卸车单
  unloadAdd: {
    method: "post",
    url: "/unload/add",
    config: {},
  },
  // 删除卸车单
  unloadDelete: {
    method: "post",
    url: "/unload/delete",
    config: {},
  },
  // 获取卸车采购订单单
  unloadQueryOrder: {
    method: "post",
    url: "/unload/queryOrder",
    config: {},
  },

  // 获取油卡管理信息
  gascardQuery: {
    method: "post",
    url: "/gascard/query",
    config: {},
  },
  // 新增油卡信息
  gascardAdd: {
    method: "post",
    url: "/gascard/add",
    config: {},
  },
  // 修改油卡信息
  gascardUpdate: {
    method: "post",
    url: "/gascard/update",
    config: {},
  },
  // 删除油卡信息
  gascardDelete: {
    method: "post",
    url: "/gascard/delete",
    config: {},
  },

  // 获取油卡加油记录
  cardrecordQuery: {
    method: "post",
    url: "/cardrecord/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加加油卡加油记录
  cardrecordAdd: {
    method: "post",
    url: "/cardrecord/add",
    config: {},
  },
  // 删除加油卡加油记录
  cardrecordDelete: {
    method: "post",
    url: "/cardrecord/delete",
    config: {},
  },

  // 获取油卡充值记录
  chargerecordQuery: {
    method: "post",
    url: "/chargerecord/query",
    config: {},
  },
  // 添加加油卡充值记录
  chargerecordAddMoney: {
    method: "post",
    url: "/chargerecord/addmoney",
    config: {},
  },
  // 删除加油卡充值记录
  chargerecordDelete: {
    method: "post",
    url: "/chargerecord/delete",
    config: {},
  },
  // 修改电子面单状态
  chargekdnStatus: {
    method: "post",
    url: "/shipPlan/alreadyPrint",
    config: {},
  },
  // 查询快递鸟轨迹
  queryKdnTrace: {
    method: "post",
    url: "/shipPlan/queryKdnTrace",
    config: {},
  },
  //提取采购业务结算主信息
  extractPsaccountMaster: {
    method: "post",
    url: "/psdocuments/extractPsaccountMaster",
    config: {},
  },
  //提取采购业务结算明细信息
  extractPsaccountDetail: {
    method: "post",
    url: "/psdocuments/extractPsaccountDetail",
    config: {},
  },

  // 获取采购发票初始信息
  psdocumentQueryInit: {
    method: "post",
    url: "/psdocuments/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询采购发票订单信息
  psdocumentsQueryDetail: {
    method: "post",
    url: "/psdocuments/queryDetail",
    config: {},
  },
  // 新增采购发票
  psdocumentsAdd: {
    method: "post",
    url: "/psdocuments/add",
    config: {},
  },
  // 删除采购发票
  psdocumentsDelete: {
    method: "post",
    url: "/psdocuments/delete",
    config: {},
  },
  psdocumentsZuoFei: {
    method: "post",
    url: "/psdocuments/cancellationBill",
    config: {},
  },
  //采购发票红冲
  psdocumentsRedRushBill: {
    method: "post",
    url: "/psdocuments/redRushBill",
    config: {},
  },
  // 提交采购发票
  psdocumentsSubmit: {
    method: "post",
    url: "/psdocuments/submit",
    config: {},
  },

  // 获取采购发票审核信息
  psdocumentQueryTask: {
    method: "post",
    url: "/psdocuments/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购发票历史信息
  psdocumentQueryHis: {
    method: "post",
    url: "/psdocuments/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //修改发票上传的图片
  psdocumentupFpimg: {
    method: "post",
    url: "/psdocuments/upFpimg",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //修改采购发票
  psdocumentsUpdate: {
    method: "post",
    url: "/psdocuments/update",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //提取供应商费用登记
  psdocumentsextractSmfr: {
    method: "post",
    url: "/psdocuments/extractSmfr",
    config: {},
  },
  //采购发票历史---取消认证
  psdocumentscancelauth: {
    method: "post",
    url: "/psdocuments/cancelauth",
    config: {},
  },
  //提取销售业务结算主信息
  extractSudocumentsMaster: {
    method: "post",
    url: "/sudocuments/extractSuaccountMaster",
    config: {},
  },
  //提取销售业务结算明细信息
  extractSudocumentsDetail: {
    method: "post",
    url: "/sudocuments/extractSuaccountDetail",
    config: {},
  },
  //提取开票信息主信息
  extractSudrawbill: {
    method: "post",
    url: "/sudrawbill/extractSudrawbill",
    config: {},
  },
  //提取开票信息明细信息
  extractDetail: {
    method: "post",
    url: "/sudrawbill/extractDetail",
    config: {},
  },
  //提取的发票信息新增为销售发票信息
  saveBillRegist: {
    method: "post",
    url: "/sudocuments/saveBillRegist",
    config: {},
  },
  // 获取销售发票初始信息
  sudocumentsQueryInit: {
    method: "post",
    url: "/sudocuments/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售发票订单信息
  sudocumentsQueryDetail: {
    method: "post",
    url: "/sudocuments/queryDetail",
    config: {},
  },
  // 修改销售发票号
  sudocumentSupdateFph: {
    method: "post",
    url: "/sudocuments/updateFph",
    config: {},
  },
  // 新增销售发票
  sudocumentsAdd: {
    method: "post",
    url: "/sudocuments/add",
    config: {},
  },
  // 删除销售发票
  sudocumentsDelete: {
    method: "post",
    url: "/sudocuments/delete",
    config: {},
  },
  // 作废销售发票
  sudocumentsZuoFei: {
    method: "post",
    url: "/sudocuments/cancellationBill",
    config: {},
  },
  // 红冲销售发票
  sudocumentsRedRushBill: {
    method: "post",
    url: "/sudocuments/redRushBill",
    config: {},
  },
  // 提交销售发票
  sudocumentsSubmit: {
    method: "post",
    url: "/sudocuments/submit",
    config: {},
  },

  // 获取销售发票审核信息
  sudocumentsQueryTask: {
    method: "post",
    url: "/sudocuments/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售发票历史信息
  sudocumentsQueryHis: {
    method: "post",
    url: "/sudocuments/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售发票上传的图片
  sudocumentsupFpimg: {
    method: "post",
    url: "/sudocuments/upFpimg",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 提取费用登记主信息
  sudocumentsextractFeeMaster: {
    method: "post",
    url: "/sudocuments/extractFeeMaster",
    config: {},
  },
  // 查询销售开票
  sudrawbillInit: {
    method: "post",
    url: "/sudrawbill/queryInit",
    config: {},
  },
  // 新增销售开票
  sudrawbillAdd: {
    method: "post",
    url: "/sudrawbill/add",
    config: {},
  },
  // 修改销售开票
  sudrawbillUpdate: {
    method: "post",
    url: "/sudrawbill/update",
    config: {},
  },
  // 删除销售开票
  sudrawbillDelete: {
    method: "post",
    url: "/sudrawbill/delete",
    config: {},
  },
  // 提交销售开票
  sudrawbillSubmit: {
    method: "post",
    url: "/sudrawbill/submit",
    config: {},
  },
  // 查询销售开票审核
  sudrawbillTask: {
    method: "post",
    url: "/sudrawbill/queryTask",
    config: {},
  },
  // 查询销售开票历史
  sudrawbillHis: {
    method: "post",
    url: "/sudrawbill/queryHis",
    config: {},
  },

  // 获取货主
  getCarOwnerList: {
    method: "post",
    url: "/CargoOwner/query",
    config: {},
  },

  // 新增货主
  addCarOwner: {
    method: "post",
    url: "/CargoOwner/add",
    config: {},
  },

  // 编辑货主
  editCarOwner: {
    method: "post",
    url: "/CargoOwner/modify",
    config: {},
  },

  // 删除货主
  delCarOwner: {
    method: "post",
    url: "/CargoOwner/delete",
    config: {},
  },

  // 修改货主状态
  setCarOwnerStatus: {
    method: "post",
    url: "/CargoOwner/stop",
    config: {},
  },
  // 货主级别查询
  queryCoLevel: {
    method: "post",
    url: "/CargoOwner/queryCoLevel",
    config: {},
  },
  // 修改货主级别
  updateLevel: {
    method: "post",
    url: "/CargoOwner/updateLevel",
    config: {},
  },

  // 获取业务商品
  getBusinessGoods: {
    method: "post",
    url: "/BusinessGood/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 维护编码
  BusinessGoodbindGoodSpid: {
    method: "post",
    url: "/BusinessGood/bindGoodSpid",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取价格维护商品列表
  queryGoodsMaintain: {
    method: "post",
    url: "/BusinessGood/queryGoodsMaintain",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 保存价格维护商品
  updateGoodsPrice: {
    method: "post",
    url: "/BusinessGood/updateGoodsPrice",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询价格维护信息
  queryGoodsAttr: {
    method: "post",
    url: "/BusinessGood/queryGoodsAttr",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改价格维护信息
  updateGoodsAttr: {
    method: "post",
    url: "/BusinessGood/updateGoodsAttr",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 最低售价审核列表
  queryLowestpricechange: {
    method: "post",
    url: "/BusinessGood/queryLowestpricechange",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 最低售价审核
  auditLowestPrice: {
    method: "post",
    url: "/BusinessGood/auditLowestPrice",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 设备设施使用信息
  emusequery: {
    method: "post",
    url: "/emuse/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 设备设施使用新增
  emuseadd: {
    method: "post",
    url: "/emuse/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 设备设施使用修改
  emuseupdate: {
    method: "post",
    url: "/emuse/update",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 设备设施使用删除
  emusedelete: {
    method: "post",
    url: "/emuse/delete",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 校验首营商品
  GSPgoodscheckRepeatGoods: {
    method: "post",
    url: "/GSPgoods/checkRepeatGoods",
    config: {},
  },
  // OCR识别商品证照信息
  GSPgoodsocrRecognition: {
    method: "post",
    url: "/GSPgoods/ocrRecognition",
    config: {},
  },
  //查询结果
  GSPgoodsQueryOcrResultList: {
    method: "post",
    url: "/GSPgoods/queryOcrResultList",
    config: {},
  },
  // 匹配结果
  GSPgoodsMatchResult: {
    method: "post",
    url: "/GSPgoods/matchResult",
    config: {},
  },
  // 验证业务商品
  fromrulecheckGoodsLicense: {
    method: "post",
    url: "/fromrule/checkGoodsLicense",
    config: {},
  },
  // 新增业务商品
  addBusinessGoods: {
    method: "post",
    url: "/BusinessGood/add",
    config: {},
  },

  // 修改业务商品
  setBusinessGoods: {
    method: "post",
    url: "/BusinessGood/modify",
    config: {},
  },

  // 删除业务商品
  delBusinessGoods: {
    method: "post",
    url: "/BusinessGood/delete",
    config: {},
  },

  // 修改业务商品状态
  setBusinessGoodsStatus: {
    method: "post",
    url: "/BusinessGood/modifyStatus",
    config: {},
  },

  // 拷贝业务商品
  copyBusinessGoods: {
    method: "post",
    url: "/BusinessGood/copy",
    config: {},
  },
  // 业务商品调价
  cusinessGoodsTunePrice: {
    method: "post",
    url: "/BusinessGood/tunePrice",
    config: {},
  },
  // 业务商品调税
  cusinessGoodsTuneTax: {
    method: "post",
    url: "/BusinessGood/tuneTax",
    config: {},
  },
  // 导入价格修改
  importGoodsMaintain: {
    method: "post",
    url: "/BusinessGood/importGoodsMaintain",
    config: {},
  },
  //批量维护注册证号
  BusinessGoodupdateRegistno: {
    method: "post",
    url: "/BusinessGood/updateRegistno",
    config: {},
  },
  // 业务商品拦截
  fromruleCheckGoodsLicense: {
    method: "post",
    url: "/fromrule/checkGoodsLicense",
    config: {},
  },
  // 拦截
  fromrulecheckRgapplyRule: {
    method: "post",
    url: "/fromrule/checkRgapplyRule",
    config: {},
  },

  // 获取所有可用库房
  getAllStorageRoom: {
    method: "post",
    url: "/StorageRoom/usable",
    config: {},
  },
  // 首营商品可用库房
  getGspStorageRoom: {
    method: "post",
    url: "/StorageRoom/usInput",
    config: {},
  },
  // 上传凭证
  registerUploadImg: {
    method: "post",
    url: "/register/uploadImg",
    config: {},
  },
  // 获取生产范围/经营范围
  queryScopeByType: {
    method: "post",
    url: "/dictscope/queryScopeByType",
    config: {},
  },
  // 获取生产范围/经营范围 -------首营商品,商品
  queryScopeByTypeByOrm: {
    method: "post",
    url: "/dictscope/queryScopeByTypeByOrm",
    config: {},
  },
  // 获取字典部分数据
  getPartDictionariesData: {
    method: "post",
    url: "/dict/getItemByTypeList",
    config: {},
  },

  // 边界预警设置
  getWarningSetting: {
    method: "post",
    url: "/WarningSet/query",
    config: {},
  },

  // 修改边界预警设置
  setWarningSetting: {
    method: "post",
    url: "/WarningSet/modify",
    config: {},
  },

  // 修改边界预警设置状态
  setWarningSettingStatus: {
    method: "post",
    url: "/WarningSet/stop",
    config: {},
  },

  // 获取业务商品期初录入数据
  getBusinessGoodsEntry: {
    method: "post",
    url: "/BGBeginInput/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增业务商品期初录入数据
  addBusinessGoodsEntry: {
    method: "post",
    url: "/BGBeginInput/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询可用货主
  getUsableCargoOwner: {
    method: "get",
    url: "/CargoOwner/usable",
    config: {},
  },

  // 获取小数点设置信息
  getFloatNumber: {
    method: "get",
    url: "/sys/queryDigits",
    config: {},
  },

  // 获取原料产品
  getRawProduct: {
    method: "post",
    url: "/rawmat/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增原料产品
  addRawProduct: {
    method: "post",
    url: "/rawmat/add",
    config: {},
  },

  // 编辑原料产品
  editRawProduct: {
    method: "post",
    url: "/rawmat/modify",
    config: {},
  },

  // 删除原料产品
  delRawProduct: {
    method: "post",
    url: "/rawmat/delete",
    config: {},
  },

  // 获取设施设备
  getEquipment: {
    method: "post",
    url: "/facilitiesmast/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增取设施设备
  addEquipment: {
    method: "post",
    url: "/facilitiesmast/add",
    config: {},
  },

  // 编辑取设施设备
  editEquipment: {
    method: "post",
    url: "/facilitiesmast/modify",
    config: {},
  },

  // 删除取设施设备
  delEquipment: {
    method: "post",
    url: "/facilitiesmast/delete",
    config: {},
  },

  // 新增供货商
  addSupplier: {
    method: "post",
    url: "/supplier/add",
    config: {},
  },
  // 查询供货商证件照信息
  querySupplierInfo: {
    method: "post",
    url: "/supplier/querySupLicences",
    config: {},
  },
  // 修改供货商
  editSupplier: {
    method: "post",
    url: "/supplier/modify",
    config: {},
  },

  // 删除供货商
  delSupplier: {
    method: "post",
    url: "/supplier/delete",
    config: {},
  },

  // 修改供货商状态
  setSupplierStatus: {
    method: "post",
    url: "/supplier/modifyState",
    config: {},
  },

  // 获取供货商列表
  getSupplier: {
    method: "post",
    url: "/supplier/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 拷贝供货商
  copySupplier: {
    method: "post",
    url: "/supplier/copy",
    config: {},
  },

  // 获取供货商地址
  getSupplierAddress: {
    method: "post",
    url: "/supplier/adrr_query",
    config: {},
  },

  // 新增供货商地址
  addSupplierAddress: {
    method: "post",
    url: "/supplier/adrr_add",
    config: {},
  },

  // 修改供货商地址
  editSupplierAddress: {
    method: "post",
    url: "/supplier/adrr_modify",
    config: {},
  },

  // 删除供货商地址
  delSupplierAddress: {
    method: "post",
    url: "/supplier/adrr_delete",
    config: {},
  },

  // 新增供货商银行信息
  addSupplierBank: {
    method: "post",
    url: "/supplier/bank_add",
    config: {},
  },

  // 删除供货商银行信息
  delSupplierBank: {
    method: "post",
    url: "/supplier/bank_delete",
    config: {},
  },

  // 修改供货商银行信息
  setSupplierBank: {
    method: "post",
    url: "/supplier/bank_modify",
    config: {},
  },

  // 新增供货商财务信息
  addSupplierFinance: {
    method: "post",
    url: "/supplier/fina_add",
    config: {},
  },

  // 编辑供货商财务信息
  setSupplierFinance: {
    method: "post",
    url: "/supplier/fina_modify",
    config: {},
  },

  // 删除供货商财务信息
  delSupplierFinance: {
    method: "post",
    url: "/supplier/fina_delete",
    config: {},
  },

  // 新增供货商证件信息
  addSupplierCertificates: {
    method: "post",
    url: "/supplier/lice_add",
    config: {},
  },

  // 编辑供货商证件信息
  setSupplierCertificates: {
    method: "post",
    url: "/supplier/lice_modify",
    config: {},
  },

  // 删除供货商证件信息
  delSupplierCertificates: {
    method: "post",
    url: "/supplier/lice_delete",
    config: {},
  },

  // 新增客户
  addCusmaster: {
    method: "post",
    url: "/cusmaster/add",
    config: {},
  },

  // 修改客户
  setCusmaster: {
    method: "post",
    url: "/cusmaster/modify",
    config: {},
  },
  // 查询客户信息
  queryCusmasterInfo: {
    method: "post",
    url: "cusmaster/queryDetail",
    config: {},
  },
  // 获取客户信息
  getCusmaster: {
    method: "post",
    url: "/cusmaster/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除客户
  delCusmaster: {
    method: "post",
    url: "/cusmaster/delete",
    config: {},
  },

  // 拷贝客户信息
  copyCusmaster: {
    method: "post",
    url: "/cusmaster/copy",
    config: {},
  },

  // 修改客户状态
  setCusmasterStatus: {
    method: "post",
    url: "/cusmaster/modifyState",
    config: {},
  },

  // 新增客户地址
  addCusmasterAddress: {
    method: "post",
    url: "/cusmaster/adrr_add",
    config: {},
  },

  // 修改客户地址
  setCusmasterAddress: {
    method: "post",
    url: "/cusmaster/adrr_modify",
    config: {},
  },

  // 删除客户地址
  delCusmasterAddress: {
    method: "post",
    url: "/cusmaster/adrr_delete",
    config: {},
  },

  // 新增客户银行信息
  addCusmasterBank: {
    method: "post",
    url: "/cusmaster/bank_add",
    config: {},
  },

  // 编辑客户银行信息
  setCusmasterBank: {
    method: "post",
    url: "/cusmaster/bank_modify",
    config: {},
  },

  // 删除客户银行信息
  delCusmasterBank: {
    method: "post",
    url: "/cusmaster/bank_delete",
    config: {},
  },

  // 新增客户财务信息
  addCusmasterFinance: {
    method: "post",
    url: "/cusmaster/fina_add",
    config: {},
  },

  // 修改客户财务信息
  setCusmasterFinance: {
    method: "post",
    url: "/cusmaster/fina_modify",
    config: {},
  },

  // 删除客户财务信息
  delCusmasterFinance: {
    method: "post",
    url: "/cusmaster/fina_delete",
    config: {},
  },

  // 新增客户证照信息
  addCusmasterCertificates: {
    method: "post",
    url: "/cusmaster/lice_add",
    config: {},
  },

  // 编辑客户证照信息
  editCusmasterCertificates: {
    method: "post",
    url: "/cusmaster/lice_modify",
    config: {},
  },

  // 删除客户证照信息
  delCusmasterCertificates: {
    method: "post",
    url: "/cusmaster/lice_delete",
    config: {},
  },
  // 维护开票信息
  updateInvoiceInfo: {
    method: "post",
    url: "/cusmaster/updateInvoiceInfo",
    config: {},
  },
  // 查询所有证照类型
  getAllLicensetype: {
    method: "post",
    url: "/licensetype/queryAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增采购合同
  addContract: {
    method: "post",
    url: "/contract/add",
    config: {},
  },

  // 修改采购合同
  editContract: {
    method: "post",
    url: "/contract/modifyContract",
    config: {},
  },

  // 获取采购合同
  getContract: {
    method: "post",
    url: "/contract/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购合同-重新计算
  contractresetContractFinish: {
    method: "post",
    url: "/contract/resetContractFinish",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 登记采购合同
  regContract: {
    method: "post",
    url: "/contract/RegContract",
    config: {},
  },

  // 删除采购合同
  delContract: {
    method: "post",
    url: "/contract/delete",
    config: {},
  },

  // 获取特殊人员
  getSpecialUser: {
    method: "post",
    url: "/Operator/queryByIdentity",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取特殊商品
  getSpecialGoods: {
    method: "post",
    url: "/BusinessGood/queryMainInfo",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 删除合同详情
  delContractDetails: {
    method: "post",
    url: "/contract/deleteDetail",
    config: {},
  },

  // 新增合同详情
  addContractDetails: {
    method: "post",
    url: "/contract/addDetail",
    config: {},
  },

  // 修改合同详情
  editContractDetails: {
    method: "post",
    url: "/contract/modifyDetail",
    config: {},
  },

  // 新增合同附件
  addContractFile: {
    method: "post",
    url: "/contract/addAnnexAlone",
    config: {},
  },

  // 编辑合同附件
  editContractFile: {
    method: "post",
    url: "/contract/modifyAnnexAlone",
    config: {},
  },

  // 删除合同附件
  delContractFile: {
    method: "post",
    url: "/contract/deleteAnnexAlone",
    config: {},
  },

  // 获取采购计划
  getPurchasePlan: {
    method: "post",
    url: "/pisplanorder/plan_query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购历史进价
  getQueryHisInPrice: {
    method: "post",
    url: "/pisplanorder/queryHisInPrice",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 保存查询采购计划
  savePurchasePlan: {
    method: "post",
    url: "/pisplanorder/quert_good",
    config: {},
  },
  // 生成采购计划
  pisplanorderPlanAdd: {
    method: "post",
    url: "/pisplanorder/plan_add",
    config: {},
  },

  // 删除采购计划
  delPurchasePlan: {
    method: "post",
    url: "/pisplanorder/plan_delete",
    config: {},
  },

  // 删除采购计划明细
  delPurchasePlanDetails: {
    method: "post",
    url: "/pisplanorder/plan_del",
    config: {},
  },

  // 编辑采购计划明细
  editPurchasePlanDetails: {
    method: "post",
    url: "/pisplanorder/plan_modify",
    config: {},
  },

  // 新增采购计划明细
  addPurchasePlanDetails: {
    method: "post",
    url: "/pisplanorder/plan_adddetail",
    config: {},
  },
  // 根据UDI查询采购订单明细
  queryOrderDetailByUdi: {
    method: "post",
    url: "/pisplanorder/queryOrderDetailByUdi",
    config: {},
  },

  // 采购计划转订单
  planToOrder: {
    method: "post",
    url: "/pisplanorder/transfer",
    config: {},
  },

  // 查询询价品种列表
  queryInquiryGoods: {
    method: "post",
    url: "/goodsInquiry/queryInquiryGoods",
    config: {},
  },
  // 审核查询询价品种列表
  queryInquiryGoodsByNum: {
    method: "post",
    url: "/goodlackmaster/queryInquiryGoodsByNum",
    config: {},
  },
  // 查询商品询价记录
  queryInquiryByPspdId: {
    method: "post",
    url: "/goodsInquiry/queryInquiryByPspdId",
    config: {},
  },
  // 加询价记录
  addGoodsInquiry: {
    method: "post",
    url: "/goodsInquiry/addInquiry",
    config: {},
  },
  // 提交询价记录
  submitGoodsInquiry: {
    method: "post",
    url: "/goodsInquiry/submit",
    config: {},
  },
  // 选择询价记录
  goodlackmasterChoose: {
    method: "post",
    url: "/goodlackmaster/chooseInquiry",
    config: {},
  },

  // 生成采购计划
  goodlackmasterGeneratePlan: {
    method: "post",
    url: "/goodlackmaster/generatePlan",
    config: {},
  },
  // 查询采购计划
  pisplanorderPlanQuery: {
    method: "post",
    url: "/pisplanorder/plan_query",
    config: {},
  },
  // 查询采购计划明细
  pisplanorderPlanQueryDetail: {
    method: "post",
    url: "/pisplanorder/plan_query_detail",
    config: {},
  },
  // 查询采购返利
  conrebateQueryInit: {
    method: "post",
    url: "/conrebate/queryInit",
    config: {},
  },
  // 新增采购返利
  conrebateAdd: {
    method: "post",
    url: "/conrebate/add",
    config: {},
  },
  // 删除采购返利
  conrebateDelete: {
    method: "post",
    url: "/conrebate/delete",
    config: {},
  },
  // 修改采购返利
  conrebateUpdate: {
    method: "post",
    url: "/conrebate/update",
    config: {},
  },
  // 提交采购返利
  conrebateSubmit: {
    method: "post",
    url: "/conrebate/submit",
    config: {},
  },
  // 查询采购返利待审核
  conrebateQueryTask: {
    method: "post",
    url: "/conrebate/queryTask",
    config: {},
  },
  // 查询采购合同审核列表
  contractQueryTask: {
    method: "post",
    url: "/contract/queryTask",
    config: {},
  },
  // 查询采购合同审核列表
  contractSubmit: {
    method: "post",
    url: "/contract/submit",
    config: {},
  },
  // 查询采购返利历史
  conrebateQueryHis: {
    method: "post",
    url: "/conrebate/queryHis",
    config: {},
  },

  // 查询单号
  goodlackmasterNum: {
    method: "post",
    url: "/goodlackmaster/queryNum",
    config: {},
  },

  // 获取本人采购订单
  getUserPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取包装信息
  getPacking: {
    method: "post",
    url: "/BusinessGood/package",
    config: {},
  },

  // 提取采购计划
  procurementPlanExtract: {
    method: "post",
    url: "/pisplanorder/order_extract",
    config: {},
  },

  // 新增采购订单
  addPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_add",
    config: {},
  },
  // 新增采购退货订单
  addQcRg: {
    method: "post",
    url: "/RgApply/addQcRg",
    config: {},
  },
  // 修改采购退货订单
  updatePurchaseOrder: {
    method: "post",
    url: "/RgApply/modifyQcRg",
    config: {},
  },
  // 新增采购控销
  addpscontrol: {
    method: "post",
    url: "/pscontrol/add",
    config: {},
  },
  // 修改采购控销
  updatepscontrol: {
    method: "post",
    url: "/pscontrol/update",
    config: {},
  },
  // 修改采购控销
  deletepscontrol: {
    method: "post",
    url: "/pscontrol/delete",
    config: {},
  },
  // 查询采购控销
  querypscontrol: {
    method: "post",
    url: "/pscontrol/query",
    config: {},
  },

  // 删除采购订单
  delPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_delete",
    config: {},
  },

  // 新增采购订单明细
  addPurchaseOrderDetails: {
    method: "post",
    url: "/pisplanorder/order_adddetail",
    config: {},
  },

  // 修改采购订单明细
  editPurchaseOrderDetails: {
    method: "post",
    url: "/pisplanorder/order_modify",
    config: {},
  },

  // 新增库存变更
  addCostChange: {
    method: "post",
    url: "/costChange/addCostChange",
    config: {},
  },

  // 删除库存变更
  deleteCostChange: {
    method: "post",
    url: "/costChange/deleteCostChange",
    config: {},
  },

  // 修改库存变更
  updateCostChange: {
    method: "post",
    url: "/costChange/updateCostChange",
    config: {},
  },

  // 提交库存变更审核
  costChangeSubmit: {
    method: "post",
    url: "/costChange/submit",
    config: {},
  },

  // 查询库存成本信息初始和驳回状态 (列表)
  querCostChangeInit: {
    method: "post",
    url: "/costChange/querCostChangeInit",
    config: {},
  },
  // 查询库存成本信息待审核状态 (审核)
  querCostChangeTask: {
    method: "post",
    url: "/costChange/querCostChangeTask",
    config: {},
  },
  // 查询库存成本信息审核成功状态 (历史)
  querCostChangeHistory: {
    method: "post",
    url: "/costChange/querCostChangeHistory",
    config: {},
  },
  // 查询汇总金额
  costChangeHzMoney: {
    method: "post",
    url: "/costChange/costChangeHzMoneyHis",
    config: {},
  },
  // 导入库存明细
  exportChangeDetail: {
    method: "post",
    url: "/costChange/exportChangeDetail",
    config: {},
  },
  // 修改采购订单明细
  editPurchaseOrderDetails: {
    method: "post",
    url: "/pisplanorder/order_modify",
    config: {},
  },

  // 删除采购订单明细
  delPurchaseOrderDetails: {
    method: "post",
    url: "/pisplanorder/order_del",
    config: {},
  },

  // 获取采购单历史
  getPurchaseOrderHistory: {
    method: "post",
    url: "/pisplanorder/order_his",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购订单历史---修改备注
  updatePsomRemark: {
    method: "post",
    url: "/pisplanorder/updatePsomRemark",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购订单回退
  puBackPuOrderGoBack: {
    method: "post",
    url: "/puBack/puOrderGoBack",
    config: {},
  },

  // 关闭采购订单
  closePurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_stop",
    config: {},
  },
  // 修改合同单号
  updateConNumber: {
    method: "post",
    url: "/pisplanorder/updateConNumber",
    config: {},
  },
  // 审核修改合同单号
  pisplanorderauditOrder: {
    method: "post",
    url: "/pisplanorder/auditOrder",
    config: {},
  },
  // 采购订单供货商证照-预警天数校验
  checkVendorLicense: {
    method: "post",
    url: "/fromrule/checkVendorLicense",
    config: {},
  },

  // 采购订单对方业务员委托书
  checkSalesLicense: {
    method: "post",
    url: "/fromrule/checkSalesLicense",
    config: {},
  },

  // 采购订单经营范围-生产范围-单品委托校验
  checkPurchasingScope: {
    method: "post",
    url: "/fromrule/checkPurchasingScope",
    config: {},
  },

  //采购验收验收数量和拒收数量不等于收货数量校验
  checkAcceptanceLicense: {
    method: "post",
    url: "/fromrule/checkAcceptanceLicense",
    config: {},
  },
  //采购验收扫码录入
  pscharesoudi: {
    method: "post",
    url: "/pscha/resoudi",
    config: {},
  },
  //查询默认抽检数量
  samplingRulesQueryCount: {
    method: "post",
    url: "samplingRules/queryCount",
    config: {},
  },
  //查询抽检数量提示
  samplingRulesQuerySamRule: {
    method: "post",
    url: "samplingRules/querySamRule",
    config: {},
  },
  //采购收货数量加拒收数量不能大于订单数量校验
  checkReceiptLicense: {
    method: "post",
    url: "/fromrule/checkReceiptLicense",
    config: {},
  },

  //销售订单客户证照-有效期校验
  checkCustomerSale: {
    method: "post",
    url: "/fromrule/checkCustomerSale",
    config: {},
  },

  // 销售订单合并经营范围-单品委托-单开类型校验
  checkScopeSaleMerge: {
    method: "post",
    url: "/fromrule/checkScopeSaleMerge",
    config: {},
  },
  // 销售订单合并经营范围-单品委托-单开类型校验
  checkSuMerge: {
    method: "post",
    url: "/fromrule/checkSuMerge",
    config: {},
  },
  //销售订单中选择物流公司拦截
  checkLogicvality: {
    method: "post",
    url: "/fromrule/checkLogicvality",
    config: {},
  },
  //销售订单货主校验
  checkSuComey: {
    method: "post",
    url: "/fromrule/checkSuComey",
    config: {},
  },
  //销售订单合同到期校验
  checkSuContract: {
    method: "post",
    url: "/fromrule/checkSuContract",
    config: {},
  },
  //销售订单对方业务员委托书
  checkSalesSale: {
    method: "post",
    url: "/fromrule/checkSalesSale",
    config: {},
  },
  //销售订单经营范围-单品委托校验
  checkScopeSale: {
    method: "post",
    url: "/fromrule/checkScopeSale",
    config: {},
  },
  //销售订单明细价格校验
  checkPrice: {
    method: "post",
    url: "/fromrule/checkPrice",
    config: {},
  },
  //采购订单明细价格校验
  puCheckPrice: {
    method: "post",
    url: "/fromrule/puCheckPrice",
    config: {},
  },
  //销售订单收货人委托书
  checkRecSalesSale: {
    method: "post",
    url: "/fromrule/checkRecSalesSale",
    config: {},
  },

  // 关闭采购详情
  closePurchaseOrderDetails: {
    method: "post",
    url: "/pisplanorder/orderdetail_close",
    config: {},
  },

  // 获取待提取的订单
  getNotExtractPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_queryaudit",
    config: {},
  },

  // 采购收货历史
  getPurchaseReceivingHistory: {
    method: "post",
    url: "/receive/query_his",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 采购收货审核任务
  getPurchaseReceivingTask: {
    method: "post",
    url: "/receive/query_task",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询待提取的采购单
  geNotExtractedtPurchaseOrder: {
    method: "post",
    url: "/receive/query_audit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购退货列表
  getPurchaseReturnList: {
    method: "post",
    url: "/RgApply/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货通知单
  getRgApplynoticesList: {
    method: "post",
    url: "/RgApplynotices/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增采购退货通知单
  addRgApplynotices: {
    method: "post",
    url: "/RgApplynotices/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购退货通知单待审核列表
  queryTaskRgApplynotices: {
    method: "post",
    url: "/RgApplynotices/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购退货通知单待审核历史列表
  queryHisRgApplynotices: {
    method: "post",
    url: "RgApplynotices/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 供应商
  getGoodLicenceRule: {
    method: "post",
    url: "GSPgoods/getGoodLicenceRule",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 供应商
  getSupLicenceRule: {
    method: "post",
    url: "gspSupplier/getSupLicenceRule",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 客户
  getCusLicenceRule: {
    method: "post",
    url: "gspCustomer/getCusLicenceRule",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改采购退货通知单
  modifyRgnoticeRgApplynotices: {
    method: "post",
    url: "/RgApplynotices/modifyRgnotice",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 提交
  submitRgnoticeRgApplynotices: {
    method: "post",
    url: "/RgApplynotices/submit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 删除采购退货通知单
  deleteNoticeRgApplynotices: {
    method: "post",
    url: "/RgApplynotices/deleteNotice",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货列表
  getforecastcostList: {
    method: "post",
    url: "/forecastcost/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取期初退货列表
  getQclnitnList: {
    method: "post",
    url: "/RgApply/queryQcInitData",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货审核通过列表
  getYesPurchaseReturnList: {
    method: "post",
    url: "/RgApply/queryAudit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货审核通过列表
  ReturnRepairqueryauthed: {
    method: "post",
    url: "/ReturnRepair/query_authed",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货审核通过列表
  ReturnRepairaddBill: {
    method: "post",
    url: "/ReturnRepair/addBill",
    config: {},
  },
  // 获取采购退货审核通过列表
  RrApplyqueryAuthed: {
    method: "post",
    url: "/RrApply/queryAuthed",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改期初销售退补价申请单
  RrApplymodifyQc: {
    method: "post",
    url: "/RrApply/modifyQc",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加期初销售退补申请单
  RrApplyaddQc: {
    method: "post",
    url: "/RrApply/addQc",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 删除期初销售退补申请单
  RrApplydeleteQc: {
    method: "post",
    url: "/RrApply/deleteQc",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询期初销售退补单待提交列表
  RrApplyqueryQcWait: {
    method: "post",
    url: "/RrApply/queryQcWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售退补计算的总金额
  RrApplyquerySumMoney: {
    method: "post",
    url: "/RrApply/querySumMoney",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceresetUdiState: {
    method: "post",
    url: "/udiTrace/resetUdiState",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 温度
  transportdocaddEndTem: {
    method: "post",
    url: "/transportdoc/addEndTem",
    config: {},
  },
  unloadqueryOrder: {
    method: "post",
    url: "/unload/queryOrder",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取采购退货任务
  getPurchaseReturnTask: {
    method: "post",
    url: "/RgApply/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购退货历史
  getPurchaseReturnHistory: {
    method: "post",
    url: "/RgApply/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 关闭采购退货
  closeRgapply: {
    method: "post",
    url: "/RgApply/closeRgapply",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购退货回退
  puBackPuRgapplyGoBack: {
    method: "post",
    url: "/puBack/puRgapplyGoBack",
    config: {},
  },
  // 采购退货通知单回退
  puRgnoticesGoBack: {
    method: "post",
    url: "/puBack/puRgnoticesGoBack",
    config: {},
  },
  // 新增采购退货
  addPurchaseReturn: {
    method: "post",
    url: "/RgApply/addRg",
    config: {},
  },

  // 修改采购退货
  setPurchaseReturn: {
    method: "post",
    url: "/RgApply/modifyRg",
    config: {},
  },
  // 删除采购退货
  delRgApplydeleteRg: {
    method: "post",
    url: "/RgApply/deleteRg",
    config: {},
  },

  // 删除采购期初退货
  delPurchaseReturn: {
    method: "post",
    url: "/RgApply/deleteQcRg",
    config: {},
  },

  // 提交采购退货
  submitPurchaseReturn: {
    method: "post",
    url: "/RgApply/submit",
    config: {},
  },
  // 查询库存采购退货
  RgApplyqueryStockWait: {
    method: "post",
    url: "/RgApply/queryStockWait",
    config: {},
  },
  // 添加库存采购退货
  RgApplyaddStockRg: {
    method: "post",
    url: "/RgApply/addStockRg",
    config: {},
  },
  // 修改库存采购退货
  RgApplymodifyStockRg: {
    method: "post",
    url: "/RgApply/modifyStockRg",
    config: {},
  },
  // 删除库存采购退货
  RgApplydeleteStockRg: {
    method: "post",
    url: "/RgApply/deleteStockRg",
    config: {},
  },
  // 导入采购退货明细
  exportReturnDetail: {
    method: "post",
    url: "/RgApply/exportReturnDetail",
    config: {},
  },
  // 导入失败下载失败原因
  exportStockReturnFail: {
    method: "post",
    url: "/RgApply/exportStockReturnFail",
    config: {},
  },
  // 新增预估成本管理
  addForecastCost: {
    method: "post",
    url: "/forecastcost/add",
    config: {},
  },
  // 删除预估成本管理
  delForecastCost: {
    method: "post",
    url: "/forecastcost/delete",
    config: {},
  },

  // 获取业务商品详情
  getBusinessGoodsDetails: {
    method: "post",
    url: "/BusinessGood/queryDetail",
    config: {},
  },
  // 查询单个业务商品实体（资料更改中的业务商品的首次购进单位）
  supplierqueryListByIds: {
    method: "post",
    url: "/supplier/queryListByIds",
    config: {},
  },

  // 复核验证
  reviewVerification: {
    method: "post",
    url: "/Login/checkVerify",
    config: {},
  },

  // 新增采购退货复核
  addPurchaseReturnReviewer: {
    method: "post",
    url: "/RgApply/saveRgbk",
    config: {},
  },

  // 提取采购退货订单
  extractPurchaseReturnOrder: {
    method: "post",
    url: "/RgApply/extractApply",
    config: {},
  },

  // 获取采购退货复核
  getPurchaseReturnReview: {
    method: "post",
    url: "/RgApply/queryRgbk",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购收货
  getPurchaseReceipt: {
    method: "post",
    url: "/receive/query_wait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增采购收货
  addPurchaseReceipt: {
    method: "post",
    url: "/receive/receiveing",
    config: {},
  },

  // 提取采购订单
  extractPurchaseOrder: {
    method: "post",
    url: "/receive/extract",
    config: {},
  },

  // 删除采购收货
  delPurchaseReceipt: {
    method: "post",
    url: "/receive/delete_master",
    config: {},
  },

  // 提交采购收货
  submitPurchaseReceipt: {
    method: "post",
    url: "/receive/submit",
    config: {},
  },

  // 删除采购收货明细
  delPurchaseReceiptDetails: {
    method: "post",
    url: "/receive/delete_detail",
    config: {},
  },

  // 编辑采购收货明细
  editPurchaseReceiptDetails: {
    method: "post",
    url: "/receive/modifyDetail",
    config: {},
  },

  // 获取采购收货验收
  getPurchaseAcceptance: {
    method: "post",
    url: "/pscha/querywait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购收货验收任务
  getPurchaseAcceptanceTask: {
    method: "post",
    url: "/pscha/querytask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购收货验收历史
  getPurchaseAcceptanceHigtory: {
    method: "post",
    url: "/pscha/queryhis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增采购收货验收
  addPurchaseAcceptance: {
    method: "post",
    url: "/pscha/add",
    config: {},
  },

  // 修改购收货验收
  setPurchaseAcceptance: {
    method: "post",
    url: "/pscha/modify",
    config: {},
  },

  // 删除采购收货验收
  delPurchaseAcceptance: {
    method: "post",
    url: "/pscha/delete_master",
    config: {},
  },

  // 删除采购收货验收明细
  delPurchaseAcceptanceDetails: {
    method: "post",
    url: "/pscha/delete_detail",
    config: {},
  },

  // 提交采购收货验收审核
  submitPurchaseAcceptance: {
    method: "post",
    url: "/pscha/submit",
    config: {},
  },

  // 提取采购收货单
  extractPurchaseReceipt: {
    method: "post",
    url: "/pscha/extract",
    config: {},
  },
  // 新增采购验收明细单
  pschaaddSplit: {
    method: "post",
    url: "/pscha/addSplit",
    config: {},
  },
  // 修改采购验收明细单
  pschamodifySplit: {
    method: "post",
    url: "/pscha/modifySplit",
    config: {},
  },
  // 查询待质量复查的数据
  pschaqueryWaitQuality: {
    method: "post",
    url: "/pscha/queryWaitQuality",
    config: {},
  },
  // 质量复查
  pschaquality: {
    method: "post",
    url: "/pscha/quality",
    config: {},
  },
  // 获取采购退补列表
  getPurchaseReimbursementList: {
    method: "post",
    url: "/ReturnRepair/query_wait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询待提交的期初采购退补价列表
  getPurchaseInitList: {
    method: "post",
    url: "/ReturnRepair/queryQcwait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购退补任务
  getPurchaseReimbursementTask: {
    method: "post",
    url: "/ReturnRepair/query_task",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取采购退补历史
  getPurchaseReimbursementHistory: {
    method: "post",
    url: "/ReturnRepair/query_his",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 采购退补回退
  puBackPuRrapplyGoBack: {
    method: "post",
    url: "/puBack/puRrapplyGoBack",
    config: {},
  },

  // 新增采购退补
  addPurchaseReimbursement: {
    method: "post",
    url: "/ReturnRepair/add",
    config: {},
  },
  // 新增期初退补
  addPurchaseInitment: {
    method: "post",
    url: "/ReturnRepair/addQc",
    config: {},
  },
  // 删除期初退补
  delPurchaseInitment: {
    method: "post",
    url: "/ReturnRepair/deleteQc",
    config: {},
  },

  // 修改期初退补
  setPurchaseInitment: {
    method: "post",
    url: "/ReturnRepair/modifyQc",
    config: {},
  },
  // 删除采购退补
  delPurchaseReimbursement: {
    method: "post",
    url: "/ReturnRepair/delete_master",
    config: {},
  },

  // 修改采购退补
  setPurchaseReimbursement: {
    method: "post",
    url: "/ReturnRepair/modify",
    config: {},
  },

  // 提取采购记账单 做退补
  extractPurchaseReimbursement: {
    method: "post",
    url: "/ReturnRepair/extract",
    config: {},
  },

  // 提交采购退补
  submitPurchaseReimbursement: {
    method: "post",
    url: "/ReturnRepair/submit",
    config: {},
  },

  // 提取记账单
  extractBookkeepingSheet: {
    method: "post",
    url: "/ReturnRepair/extract",
    config: {},
  },

  //获取销售复核辅助信息
  getWosupinfor: {
    method: "post",
    url: "/woApply/getWosupinfor",
    config: {},
  },
  //获取销售历史进价
  getqueryHisOutPrice: {
    method: "post",
    url: "/woApply/queryHisOutPrice",
    config: {},
  },

  // 获取销售订单
  getSalesOrder: {
    method: "post",
    url: "/woApply/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询合并销售出库申请单待提交列表
  queryMergeWait: {
    method: "post",
    url: "/woApply/queryMergeWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 复制销售订单
  copyOrder: {
    method: "post",
    url: "/woApply/copyOrder",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 复制采购订单
  pisplanorderCopyOrder: {
    method: "post",
    url: "/pisplanorder/copyOrder",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取调拨出库列表
  allotQueryList: {
    method: "post",
    url: "/allot/queryList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取调拨出库明细
  allotQueryDetail: {
    method: "post",
    url: "/allot/queryDetail",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取调拨出库客户列表
  allotQueryCmInfo: {
    method: "post",
    url: "/allot/queryCmInfo",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增调拨出库
  allotadd: {
    method: "post",
    url: "/allot/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改调拨出库
  allotupdate: {
    method: "post",
    url: "/allot/update",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 删除调拨出库
  allotdelete: {
    method: "post",
    url: "/allot/delete",
    config: {
      headers: {},
    },
  },
  // 提交调拨出库
  allotsubmit: {
    method: "post",
    url: "/allot/submit",
    config: {
      headers: {},
    },
  },
  //调拨出库待审核列表
  allotqueryTasks: {
    method: "post",
    url: "/allot/queryTasks",
    config: {
      headers: {},
    },
  },
  //调拨出库历史列表
  allotqueryHis: {
    method: "post",
    url: "/allot/queryHis",
    config: {
      headers: {},
    },
  },
  // 外部订单查询（汇总）
  orderpoolqueryWdtHisOrder: {
    method: "post",
    url: "/orderpool/queryWdtHisOrder",
    config: {},
  },
  // 外部订单查询
  getXOorderPoolList: {
    method: "post",
    url: "/orderpool/query",
    config: {},
  },
  // 关闭外部订单
  orderpoolClosePool: {
    method: "post",
    url: "/orderpool/closePool",
    config: {},
  },
  // 外部订单查询---汇总
  orderpoolqueryWebRetailOrder: {
    method: "post",
    url: "/orderpool/queryWebRetailOrder",
    config: {},
  },
  // 查询旺店通店铺名称
  orderpoolqueryWdtShopStore: {
    method: "post",
    url: "/orderpool/queryWdtShopStore",
    config: {},
  },
  // 明细取消确认列表
  getXOorderDetailList: {
    method: "post",
    url: "/canceldetail/query",
    config: {},
  },
  // 明细取消确认列表
  checkDetail: {
    method: "post",
    url: "/sudocuments/checkDetail",
    config: {},
  },
  // 明细取消确认
  getXOorderSureList: {
    method: "post",
    url: "/canceldetail/verify",
    config: {},
  },
  // 不良事件新增
  addBadness: {
    method: "post",
    url: "/badness/add",
    config: {},
  },
  // 不良事件修改
  updateBadness: {
    method: "post",
    url: "/badness/update",
    config: {},
  },
  // 不良事件删除
  deleteBadness: {
    method: "post",
    url: "/badness/delete",
    config: {},
  },
  // 不良事件列表
  queryBadness: {
    method: "post",
    url: "/badness/query",
    config: {},
  },
  // 查询药品不良反应/事件报告表
  ymbadqueryBad: {
    method: "post",
    url: "/ymbad/queryBad",
    config: {},
  },
  // 新增药品不良反应/事件报告表
  ymbadaddBad: {
    method: "post",
    url: "/ymbad/addBad",
    config: {},
  },
  // 修改药品不良反应/事件报告表
  ymbadupdBad: {
    method: "post",
    url: "/ymbad/updBad",
    config: {},
  },
  // 删除药品不良反应/事件报告表
  ymbaddelBad: {
    method: "post",
    url: "/ymbad/delBad",
    config: {},
  },
  // 查询群体不良
  ymbadqueryGroupBad: {
    method: "post",
    url: "/ymbad/queryGroupBad",
    config: {},
  },
  // 新增群体不良
  ymbadaddGroupBad: {
    method: "post",
    url: "/ymbad/addGroupBad",
    config: {},
  },
  // 修改群体不良
  ymbadupdGroupBad: {
    method: "post",
    url: "/ymbad/updGroupBad",
    config: {},
  },
  // 删除群体不良
  ymbaddelGroupBad: {
    method: "post",
    url: "/ymbad/delGroupBad",
    config: {},
  },
  // 外部订单明细
  orderpoolQueryDetail: {
    method: "post",
    url: "orderpool/queryDetail",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 线上零售订单明细
  orderpoolQueryWebRetailDetail: {
    method: "post",
    url: "orderpool/queryWebRetailDetail",
    config: {},
  },
  // 线上零售订单（重置初始化）
  orderpoolresetWebRetailInit: {
    method: "post",
    url: "orderpool/resetWebRetailInit",
    config: {},
  },
  // 线上零售订单明细(修改批号数量)
  orderpoolmodifyWebRetailDetail: {
    method: "post",
    url: "orderpool/modifyWebRetailDetail",
    config: {},
  },

  // 获取销售订单任务
  getSalesOrderTask: {
    method: "post",
    url: "/woApply/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售订单历史
  getSalesOrderHistory: {
    method: "post",
    url: "/woApply/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售订单历史---修改备注
  updateWoamRemark: {
    method: "post",
    url: "/woApply/updateWoamRemark",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 关闭销售订单
  closeWoapply: {
    method: "post",
    url: "/woApply/closeWoapply",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取销售订单历史
  queryBatchPrintList: {
    method: "post",
    url: "/woApply/queryBatchPrintList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改抵用金额
  updateoffsetMoney: {
    method: "post",
    url: "/feeticket/updateoffsetMoney",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 销售订单回退
  suBackSuOrderGoBack: {
    method: "post",
    url: "/suBack/suOrderGoBack",
    config: {},
  },

  // 新增销售订单(合并) 添加合并销售出库订单
  addSalesOrderMerge: {
    method: "post",
    url: "/woApply/addMerge",
    config: {},
  },

  // 修改销售订单(合并) 修改合并销售出库单
  setSalesOrderMerge: {
    method: "post",
    url: "/woApply/updateMerge",
    config: {},
  },

  // 新增销售订单
  addSalesOrder: {
    method: "post",
    url: "/woApply/add",
    config: {},
  },
  // 新增合并销售订单
  woApplyaddByCoMerge: {
    method: "post",
    url: "/woApply/addByCoMerge",
    config: {},
  },

  // 修改销售订单
  setSalesOrder: {
    method: "post",
    url: "/woApply/modify",
    config: {},
  },

  // 删除销售订单
  delSalesOrder: {
    method: "post",
    url: "/woApply/delete",
    config: {},
  },
  // 删除合并销售出库订单
  deleteMerge: {
    method: "post",
    url: "/woApply/deleteMerge",
    config: {},
  },
  // 提交销售订单
  submitSalesOrder: {
    method: "post",
    url: "/woApply/submit",
    config: {},
  },

  // 修改销售订单辅助信息
  editSalesOrderInfo: {
    method: "post",
    url: "/woApply/updatePinfor",
    config: {},
  },

  // 删除销售订单明细
  delSalesOrderDetails: {
    method: "post",
    url: "/woApply/deleteDetail",
    config: {},
  },

  // 新增销售订单明细
  addSalesOrderDetails: {
    method: "post",
    url: "/woApply/addDetail",
    config: {},
  },

  // 查询销售一步出库
  querySuOneOutStock: {
    method: "post",
    url: "/woApply/querySuOneOutStock",
    config: {},
  },
  // 新增销售一步出库
  addSuOneOutStock: {
    method: "post",
    url: "/woApply/addSuOneOutStock",
    config: {},
  },

  // 修改销售订单明细
  setSalesOrderDetails: {
    method: "post",
    url: "/woApply/updateDetail",
    config: {},
  },

  // 获取业务商品库存
  getBusinessGoodsStock: {
    method: "post",
    url: "/bgStock/queryStock",
    config: {},
  },
  //查询批次价格策略
  bgStockqueryLotPrice: {
    method: "post",
    url: "/bgStock/queryLotPrice",
    config: {},
  },
  //删除批次价格策略
  bgStockdeleteLotPrice: {
    method: "post",
    url: "/bgStock/deleteLotPrice",
    config: {},
  },
  //增加批次价格策略
  bgStockaddLotPrice: {
    method: "post",
    url: "bgStock/addLotPrice",
    config: {},
  },

  // 获取特价申请
  getSpecialPriceApply: {
    method: "post",
    url: "/specialApply/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取特价申请任务
  getSpecialPriceApplyTask: {
    method: "post",
    url: "/specialApply/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取特价申请任务
  getSpecialPriceApplyHistory: {
    method: "post",
    url: "/specialApply/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增特价申请
  addSpecialPriceApply: {
    method: "post",
    url: "/specialApply/add",
    config: {},
  },

  // 修改特价申请
  setSpecialPriceApply: {
    method: "post",
    url: "/specialApply/modify",
    config: {},
  },

  // 删除特价申请
  delSpecialPriceApply: {
    method: "post",
    url: "/specialApply/delete",
    config: {},
  },

  // 提交特价申请
  submitSpecialPriceApply: {
    method: "post",
    url: "/specialApply/submit",
    config: {},
  },
  // 特价申请关闭
  closeSpecialPriceApply: {
    method: "post",
    url: "/specialApply/close",
    config: {},
  },

  // 获取缺货登记
  getShortageRegistration: {
    method: "post",
    url: "/woApply/queryLackRegister",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增缺货登记
  addShortageRegistration: {
    method: "post",
    url: "/woApply/addLackRegister",
    config: {},
  },

  // 修改缺货登记
  setShortageRegistration: {
    method: "post",
    url: "/woApply/modifyLackRegister",
    config: {},
  },

  // 删除缺货登记
  delShortageRegistration: {
    method: "post",
    url: "/woApply/deleteLackRegister",
    config: {},
  },


  //-*---------------------
  // 新增缺货登记
  woApplyaddBatchLack: {
    method: "post",
    url: "/woApply/addBatchLack",
    config: {},
  },
  // 关闭缺货
  openShortageRegistration: {
    method: "post",
    url: "/woApply/stopRegister",
    config: {},
  },

  // 获取促销策略
  getPromotionStrategy: {
    method: "post",
    url: "/promotion/queryPromotion",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增促销策略
  addPromotionStrategy: {
    method: "post",
    url: "/promotion/addPromotion",
    config: {},
  },

  // 修改促销策略
  setPromotionStrategy: {
    method: "post",
    url: "/promotion/modifyPromotion",
    config: {},
  },

  // 删除促销策略
  delPromotionStrategy: {
    method: "post",
    url: "/promotion/deletePromotion",
    config: {},
  },

  // 新增促销策略详情
  addPromotionStrategyDetails: {
    method: "post",
    url: "/promotion/addDetail",
    config: {},
  },

  // 修改促销策略详情
  setPromotionStrategyDetails: {
    method: "post",
    url: "/promotion/modifyDetail",
    config: {},
  },

  // 删除促销策略
  delPromotionStrategyDetails: {
    method: "post",
    url: "/promotion/deleteDetail",
    config: {},
  },

  // 获取销售复核
  getSalesReview: {
    method: "post",
    url: "/WoRecheck/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增销售复核
  addSalesReview: {
    method: "post",
    url: "/WoRecheck/add",
    config: {},
  },

  // 提取销售单
  extractSalesReview: {
    method: "post",
    url: "/WoRecheck/extract",
    config: {},
  },

  // 删除销售复核
  delSalesReview: {
    method: "post",
    url: "/WoRecheck/delete",
    config: {},
  },

  // 待提取的销售单
  notExtractSalesOrder: {
    method: "post",
    url: "/woApply/queryAudit",
    config: {},
  },

  // 新增销售复核明细
  addSalesReviewDetails: {
    method: "post",
    url: "/WoRecheck/addDetail",
    config: {},
  },

  // 修改销售复核明细
  setSalesReviewDetails: {
    method: "post",
    url: "/WoRecheck/modifyDetail",
    config: {},
  },

  // 删除销售复核明细
  delSalesReviewDetails: {
    method: "post",
    url: "/WoRecheck/deleteDetail",
    config: {},
  },
  // 销售批量复核查询
  queryWaitCheck: {
    method: "post",
    url: "/WoRecheck/queryWaitCheck",
    config: {},
  },
  // 批量复核
  batchAdd: {
    method: "post",
    url: "/WoRecheck/batchAdd",
    config: {},
  },
  // 获取销售退回列表
  getSalesReturnList: {
    method: "post",
    url: "/ReturnGoods/queryapply_wait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售退货记账信息
  rgbkAccountQuery: {
    method: "post",
    url: "rgbkAccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取期初销售退回列表
  getInitReturnList: {
    method: "post",
    url: "/ReturnGoods/queryapplyQcwait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //  新增期初销售退回
  addInitReturnList: {
    method: "post",
    url: "/ReturnGoods/addQc",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //  修改期初销售退回
  editInitReturnList: {
    method: "post",
    url: "/ReturnGoods/modifyQx",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //  删除期初销售退回
  deleteInitReturnList: {
    method: "post",
    url: "/ReturnGoods/deleteQc",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退回审核任务
  getSalesReturnTask: {
    method: "post",
    url: "/ReturnGoods/queryapply_task",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退货历史
  getSalesReturnHistory: {
    method: "post",
    url: "/ReturnGoods/queryapply_his",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 关闭销售退货
  closeRgapply: {
    method: "post",
    url: "/ReturnGoods/closeRgapply",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售退回回退
  suBackSuRgapplyGoBack: {
    method: "post",
    url: "/suBack/suRgapplyGoBack",
    config: {},
  },

  // 新增销售退回
  addSalesReturn: {
    method: "post",
    url: "/ReturnGoods/add",
    config: {},
  },

  // 删除销售退回
  delSalesReturn: {
    method: "post",
    url: "/ReturnGoods/delete",
    config: {},
  },

  // 修改销售退回
  setSalesReturn: {
    method: "post",
    url: "/ReturnGoods/modify",
    config: {},
  },

  // 提交销售退回
  submitSalesReturn: {
    method: "post",
    url: "/ReturnGoods/submit",
    config: {},
  },
  transportdocqueryOrder: {
    method: "post",
    url: "/transportdoc/queryOrder",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 冷链
  transportdocquerydetail: {
    method: "post",
    url: "/transportdoc/querydetail",
    config: {},
  },
  // 提取销售出库单
  extractSalesOrder: {
    method: "post",
    url: "/ReturnGoods/extract_wobke",
    config: {},
  },

  // 获取销售出库单
  getSalesBookkeeping: {
    method: "post",
    url: "/wobke/query",
    config: {},
  },
  // 新增销售出库记账
  addSalesBookkeeping: {
    method: "post",
    url: "/wobke/add",
    config: {},
  },

  // 提取销售退回申请
  extractSalesReturnInfo: {
    method: "post",
    url: "/ReturnGoods/extract_apply",
    config: {},
  },

  //获取销售退货收货辅助信息
  getDesuRgApplySupInfo: {
    method: "post",
    url: "/returnRego/getDesuRgApplySupInfo",
    config: {},
  },

  // 获取销售退货验收列表
  getSalesReturnCheckList: {
    method: "post",
    url: "/surgcha/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退货验收任务
  getSalesReturnCheckTask: {
    method: "post",
    url: "/surgcha/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退货验收历史
  getSalesReturnCheckHistory: {
    method: "post",
    url: "/surgcha/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售退货上下架列表
  getSalesQueryWaitUp: {
    method: "post",
    url: "/suListing/queryListing",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售退货上下架列表
  getSalesAdd: {
    method: "post",
    url: "/suListing/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 上架
  getSalesUpdateWaitUp: {
    method: "post",
    url: "/surgcha/updateWaitUp",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 上架提交
  getSalesSubmitWaitUp: {
    method: "post",
    url: "/surgcha/submitWaitUp",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取销售记账列表
  getSalesReturnAccountList: {
    method: "post",
    url: "/rgbkAccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取销售记账列表
  surgchaqueryRecd: {
    method: "post",
    url: "/surgcha/queryRecd",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 批量添加销售退货记账
  rgbkAccountadd: {
    method: "post",
    url: "/rgbkAccount/add",
    config: {},
  },
  // 设置销售记账列表
  setSalesReturnAccount: {
    method: "post",
    url: "/rgbkAccount/add",
    config: {},
  },
  // 查询销售结算申请历史
  getSalesSettlementList: {
    method: "post",
    url: "/suSettleApply/queryList",
    config: {},
  },
  // 查询销售结算申请列表
  getSuSettleApplyQueryInit: {
    method: "post",
    url: "/suSettleApply/queryInit",
    config: {},
  },
  // 查询销售逐单结算列表
  getQuerySuaccountOrderBy: {
    method: "post",
    url: "/suSettleAccount/querySuaccountOrderBy",
    config: {},
  },
  // 批量销售逐单结算
  getOrderByOrdedrAccount: {
    method: "post",
    url: "/suSettleAccount/orderByOrdedrAccount",
    config: {},
  },
  // 查询电商逐单结算列表
  querySuElectronicOrderBy: {
    method: "post",
    url: "/suSettleAccount/querySuElectronicOrderBy",
    config: {},
  },
  // 电商逐单结算列表(导入)
  suSettleAccountupload: {
    method: "post",
    url: "/suSettleAccount/upload",
    config: {
      "Content-Type": "multipart/form-data",
    },
  },
  // 欠条登记
  suSettleAccountupdateIsIou: {
    method: "post",
    url: "/suSettleAccount/updateIsIou",
    config: {},
  },
  // 新增销售结算申请
  addSalesSettlementApply: {
    method: "post",
    url: "/suSettleApply/add",
    config: {},
  },
  // 删除销售结算申请
  delSalesSettlementApply: {
    method: "post",
    url: "/suSettleApply/delete",
    config: {},
  },
  // 查询提交销售结算
  getSuSettleApplyQuery: {
    method: "post",
    url: "/suSettleApply/querySubmit",
    config: {},
  },
  // 销售结算批量记账
  getSuSettleApplybatchadd: {
    method: "post",
    url: "/suSettleAccount/batchadd",
    config: {},
  },
  // 提交销售结算申请
  subSalesSettlementApply: {
    method: "post",
    url: "/suSettleApply/submit",
    config: {},
  },
  // 查询销售结算记账提取方案
  getSalesSettlementKeepExtract: {
    method: "post",
    url: "/suSettleApply/querySubmit",
    config: {},
  },
  // 销售结算申请回退
  suSettleApplyreback: {
    method: "post",
    url: "/suSettleApply/reback",
    config: {},
  },
  // 查询销售结算记账
  getSalesSettlementKeep: {
    method: "post",
    url: "/suSettleAccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询预收结算
  getQuerySuNoSettle: {
    method: "post",
    url: "/suSettleAccount/querySuNoSettle",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增预收结算
  getAddPreAccount: {
    method: "post",
    url: "/suSettleAccount/addPreAccount",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增销售结算记账
  addSalesSettlementKeep: {
    method: "post",
    url: "/suSettleAccount/add",
    config: {},
  },
  // 修改销售结算记账备注
  suSettleAccountRemark: {
    method: "post",
    url: "/suSettleAccount/updateRemark",
    config: {},
  },
  // 查询结算明细
  suSettleAccountquerySettleDetail: {
    method: "post",
    url: "/suSettleAccount/querySettleDetail",
    config: {},
  },
  // 新增销售退回验收
  addSalesReturnCheck: {
    method: "post",
    url: "/surgcha/add",
    config: {},
  },

  // 修改销售退回验收
  setSalesReturnCheck: {
    method: "post",
    url: "/surgcha/modify",
    config: {},
  },

  // 删除销售退回验收
  delSakesReturnCheck: {
    method: "post",
    url: "/surgcha/delete",
    config: {},
  },

  // 提交销售退货验收
  submitSakesReturnCheck: {
    method: "post",
    url: "/surgcha/submit",
    config: {},
  },

  // 销售退货验收列表
  salesReturnAcceptance: {
    method: "post",
    url: "/ReturnGoods/accept",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售退货验收历史
  salesReturnAcceptance: {
    method: "post",
    url: "/surgcha/queryHis",
    config: {},
  },

  // 获取销售退补价列表
  getSalesReimbursementList: {
    method: "post",
    url: "/RrApply/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 销售退补批量打印查询
  RrApplyqueryBatchPrintList: {
    method: "post",
    url: "/RrApply/queryBatchPrintList",
    config: {},
  },
  // 比例销售退补--查询
  wobkequeryWobkList: {
    method: "post",
    url: "/wobke/queryWobkList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 比例销售退补--新增
  RrApplyaddWhole: {
    method: "post",
    url: "/RrApply/addWhole",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取销售退补价任务
  getSalesReimbursementTask: {
    method: "post",
    url: "/RrApply/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退补价历史
  getSalesReimbursementHistory: {
    method: "post",
    url: "/RrApply/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 销售退补回退
  suBackSuRRapplyGoBack: {
    method: "post",
    url: "/suBack/suRRapplyGoBack",
    config: {},
  },

  // 新增销售退补价
  addSalesReimbursement: {
    method: "post",
    url: "/RrApply/add",
    config: {},
  },

  // 修改销售退补价
  setSalesReimbursement: {
    method: "post",
    url: "/RrApply/modify",
    config: {},
  },

  // 删除销售退补价
  delSalesReimbursement: {
    method: "post",
    url: "/RrApply/delete",
    config: {},
  },

  // 提交销售退补价
  submitSalesReimbursement: {
    method: "post",
    url: "/RrApply/submit",
    config: {},
  },

  // 查询销售退补价记账
  getSalesAccount: {
    method: "post",
    url: "/RrApply/queryaccount",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售退补价记账
  RrApplyqueryAuthed: {
    method: "post",
    url: "RrApply/queryAuthed",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增销售退补价记账
  addSalesAccount: {
    method: "post",
    url: "/RrApply/addaccount",
    config: {},
  },
  // 提取销售记账单
  extractSalesBookkeeping: {
    method: "post",
    url: "/RrApply/extract",
    config: {},
  },
  // 查询销售预收款查询
  getSalePayList: {
    method: "post",
    url: "/preregister/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增销售预收款查询
  addSalesPayment: {
    method: "post",
    url: "/preregister/add",
    config: {},
  },
  // 修改销售预收款备注
  preregisterUpdateRemark: {
    method: "post",
    url: "/preregister/updateRemark",
    config: {},
  },
  // 获取限销品分组
  getLimitGoodsGroup: {
    method: "post",
    url: "/SalesRestriction/query_sgvgroup",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增限销品分组
  addLimitGoodsGroup: {
    method: "post",
    url: "/SalesRestriction/add_sgvgroup",
    config: {},
  },

  // 修改限销品分组
  setLimitGoodsGroup: {
    method: "post",
    url: "/SalesRestriction/modify_sgvgroup",
    config: {},
  },

  // 删除限销品分组
  delLimitGoodsGroup: {
    method: "post",
    url: "/SalesRestriction/delete_sgvgroup",
    config: {},
  },

  // 修改限销品分组状态
  setLimitGoodsGroupState: {
    method: "post",
    url: "/SalesRestriction/stop_sgvggroup",
    config: {},
  },

  // 修改限销品状态
  setLimitGoodsState: {
    method: "post",
    url: "/SalesRestriction/stop_sgvdetail",
    config: {},
  },

  // 新增限销品
  addLimitGoods: {
    method: "post",
    url: "/SalesRestriction/add_sgvdetail",
    config: {},
  },

  // 修改限销品
  setLimitGoods: {
    method: "post",
    url: "/SalesRestriction/modify_sgvdetail",
    config: {},
  },

  // 删除限销品
  delLimitGoods: {
    method: "post",
    url: "/SalesRestriction/delete_sgvdetail",
    config: {},
  },

  // 获取客户策略分组
  getCustomersStrategyGroup: {
    method: "post",
    url: "/cusGroup/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增客户策略分组
  addCustomersStrategyGroup: {
    method: "post",
    url: "/cusGroup/add",
    config: {},
  },

  // 修改客户策略分组
  setCustomersStrategyGroup: {
    method: "post",
    url: "/cusGroup/update",
    config: {},
  },

  // 删除客户策略分组
  deltCustomersStrategyGroup: {
    method: "post",
    url: "/cusGroup/delete",
    config: {},
  },

  // 获取策略客户
  getStrategyCustomers: {
    method: "post",
    url: "/cusGroup/queryRel",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增策略客户
  addStrategyCustomers: {
    method: "post",
    url: "/cusGroup/addRel",
    config: {},
  },

  // 修改策略客户
  setStrategyCustomers: {
    method: "post",
    url: "/cusGroup/updateRel",
    config: {},
  },

  // 删除策略客户
  delStrategyCustomers: {
    method: "post",
    url: "/cusGroup/deleteRel",
    config: {},
  },

  // 获取库存缺损列表
  getStorageRoomLossList: {
    method: "post",
    url: "/loss/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存缺损任务
  getStorageRoomLossTask: {
    method: "post",
    url: "/loss/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存缺损历史
  getStorageRoomLossHistory: {
    method: "post",
    url: "/loss/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库存缺损
  addStorageRoomLoss: {
    method: "post",
    url: "/loss/add",
    config: {},
  },

  // 修改库存缺损
  setStorageRoomLoss: {
    method: "post",
    url: "/loss/modifyMaster",
    config: {},
  },

  // 删除库存缺损
  delStorageRoomLoss: {
    method: "post",
    url: "/loss/delete",
    config: {},
  },

  // 提交库存缺损
  lossSubmitAudit: {
    method: "post",
    url: "/loss/submitAudit",
    config: {},
  },
  // 获取库存移库
  getStorageRoomRelocation: {
    method: "post",
    url: "/move/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库存移库
  addStorageRoomRelocation: {
    method: "post",
    url: "/move/add",
    config: {},
  },

  // 修改库存移库
  setStorageRoomRelocation: {
    method: "post",
    url: "/move/modifyMaster",
    config: {},
  },

  // 删除库存移库
  delStorageRoomRelocation: {
    method: "post",
    url: "/move/delete",
    config: {},
  },
  // 库存移库一步--查询
  movequeryOneStepHis: {
    method: "post",
    url: "/move/queryOneStepHis",
    config: {},
  },
  // 库存移库一步--新增
  moveoneStepAdd: {
    method: "post",
    url: "/move/oneStepAdd",
    config: {},
  },
  // 待上架移库明细查询列表
  movequeryWdtUpHis: {
    method: "post",
    url: "/move/queryWdtUpHis",
    config: {},
  },
  // 待上架移库明细--上架
  movewdtUp: {
    method: "post",
    url: "/move/wdtUp",
    config: {},
  },
  // 获取权限申请
  getAuthorityApplyList: {
    method: "post",
    url: "/power/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取权限申请详情
  powerqueryDetail: {
    method: "post",
    url: "/power/queryDetail",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取权限申请任务
  getAuthorityApplyTask: {
    method: "post",
    url: "/power/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取权限申请历史
  getAuthorityApplyHistory: {
    method: "post",
    url: "/power/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增权限申请
  addAuthorityApply: {
    method: "post",
    url: "/power/add",
    config: {},
  },

  // 修改权限申请
  setAuthorityApply: {
    method: "post",
    url: "/power/modify",
    config: {},
  },

  // 删除权限申请
  delAuthorityApply: {
    method: "post",
    url: "/power/delete",
    config: {},
  },

  // 提交权限申请
  submitAuthorityApply: {
    method: "post",
    url: "/power/submitAudit",
    config: {},
  },

  // 上传流程XML数据
  sendXmlData: {
    method: "post",
    url: "/processDefinition/addDeploymentByString",
    config: {},
  },

  // 获取流程XML数据
  getXmlData: {
    method: "post",
    url: "/processDefinition/getDefinitionXML",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取流程列表
  getProcessList: {
    method: "post",
    url: "/processDefinition/getDefinitions",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取范围管理列表
  getDictscopeQueryScopeAll: {
    method: "post",
    url: "/dictscope/queryScopeAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加范围管理
  dictscopeAddScope: {
    method: "post",
    url: "/dictscope/addScope",
    config: {},
  },
  // 修改范围管理
  dictscopeUpdateScope: {
    method: "post",
    url: "/dictscope/updateScope",
    config: {},
  },
  // 删除范围管理
  dictscopeDeleteScope: {
    method: "post",
    url: "/dictscope/deleteScope",
    config: {},
  },

  // 获取人员组织
  getUserOrg: {
    method: "post",
    url: "/Operator/query_operOrg",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 设置人员组织
  settingUserOrg: {
    method: "post",
    url: "/Operator/operOrg",
    config: {},
  },

  // 获取采购商品
  getPurchaseGoods: {
    method: "post",
    url: "/pisplanorder/quert_good",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 按销量生成采购计划
  addAutoPurchasePlanOne: {
    method: "post",
    url: "/pisplanorder/plan_gen",
    config: {},
  },

  // 修改采购订单
  setPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/modify_pisorder",
    config: {},
  },

  // 提交采购订单审核
  submitPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_submit",
    config: {},
  },

  // 获取审核订单
  getReviewPurchaseOrder: {
    method: "post",
    url: "/pisplanorder/order_queryaudit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取审核订单任务
  getReviewPurchaseOrderTask: {
    method: "post",
    url: "/pisplanorder/order_task",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 提交任务审核
  addTaskReview: {
    method: "post",
    url: "/process/audit",
    config: {},
  },
  // 提交任务审核
  stopscheckStop: {
    method: "post",
    url: "/stops/checkStop",
    config: {},
  },

  // 获取审核历史
  getTaskReviewHistory: {
    method: "post",
    url: "/process/auditHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取不合格登记任务
  getUnqualifiedRegisterTask: {
    method: "post",
    url: "/RegUnqua/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取不合格登记历史
  getUnqualifiedRegisterHistory: {
    method: "post",
    url: "/RegUnqua/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取不合格登记列表
  getUnqualifiedRegister: {
    method: "post",
    url: "/RegUnqua/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增不合格登记列表
  addUnqualifiedRegister: {
    method: "post",
    url: "/RegUnqua/add",
    config: {},
  },

  // 修改不合格登记列表
  setUnqualifiedRegister: {
    method: "post",
    url: "/RegUnqua/update",
    config: {},
  },

  // 删除不合格登记列表
  delUnqualifiedRegister: {
    method: "post",
    url: "/RegUnqua/delete",
    config: {},
  },

  // 提交不合格登记审核
  submitUnqualifiedRegister: {
    method: "post",
    url: "/RegUnqua/submitAudit",
    config: {},
  },

  // 获取不合格登记待提取
  getUnqualifiedRegisterNot: {
    method: "post",
    url: "/RegUnqua/queryAuditPass",
    config: {},
  },

  // 获取不合格报损
  getUnqualifiedDamage: {
    method: "post",
    url: "/Lossunqua/queryInit",
    config: {},
  },

  // 新增报损
  addUnqualifiedDamage: {
    method: "post",
    url: "/Lossunqua/add",
    config: {},
  },

  // 修改报损
  setUnqualifiedDamage: {
    method: "post",
    url: "/Lossunqua/modify",
    config: {},
  },

  // 删除报损
  delUnqualifiedDamage: {
    method: "post",
    url: "/Lossunqua/delete",
    config: {},
  },

  // 报损审核任务
  getUnqualifiedDamageTask: {
    method: "post",
    url: "/Lossunqua/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 提交报损审核
  submitUnqualifiedDamage: {
    method: "post",
    url: "/Lossunqua/submitTask",
    config: {},
  },

  // 查询报损历史
  getUnqualifiedDamageHistory: {
    method: "post",
    url: "/Lossunqua/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取不合格报损待提取
  getUnqualifiedDamageNot: {
    method: "post",
    url: "/Lossunqua/queryAuditPass",
    config: {},
  },

  // 获取不合格销毁
  getUnqualifiedDestruction: {
    method: "post",
    url: "/Desunqua/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增销毁
  addUnqualifiedDestruction: {
    method: "post",
    url: "/Desunqua/add",
    config: {},
  },

  // 修改销毁
  setUnqualifiedDestruction: {
    method: "post",
    url: "/Desunqua/update",
    config: {},
  },

  // 删除销毁
  delUnqualifiedDestruction: {
    method: "post",
    url: "/Desunqua/delete",
    config: {},
  },

  // 销毁审核任务
  getUnqualifiedDestructionTask: {
    method: "post",
    url: "/Desunqua/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 提交销毁审核
  submitUnqualifiedDestruction: {
    method: "post",
    url: "/Desunqua/submitAudit",
    config: {},
  },

  // 查询销毁历史
  getUnqualifiedDestructionHistory: {
    method: "post",
    url: "/Desunqua/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取商品相对于的策略
  getGoodsStrategy: {
    method: "post",
    url: "/bgStock/queryStrategy",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取商品相对于的赠品
  getGoodsGifts: {
    method: "post",
    url: "/woApply/checkGift",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 检测库存商品最低价
  getGoodsSockPrice: {
    method: "post",
    url: "/specialApply/checkMinPrice",
    config: {},
  },

  // 新增首营商品
  addFirstGoods: {
    method: "post",
    url: "/GSPgoods/add",
    config: {},
  },
  // 查询首营商品信息
  queryFirstGoodsInfo: {
    method: "post",
    url: "GSPgoods/queryDetail",
    config: {},
  },
  // 修改首营商品
  setFirstGoods: {
    method: "post",
    url: "/GSPgoods/modify",
    config: {},
  },
  // 修改识别商品任务
  GSPgoodsDeleteTask: {
    method: "post",
    url: "/GSPgoods/deleteTask",
    config: {},
  },

  // 提交首营商品
  submitFirstGoods: {
    method: "post",
    url: "/GSPgoods/submitAudit",
    config: {},
  },

  // 删除首营商品
  delFirstGoods: {
    method: "post",
    url: "/GSPgoods/delete",
    config: {},
  },

  // 批量删除首营商品
  delFirstGoodsList: {
    method: "post",
    url: "/GSPgoods/deleteList",
    config: {},
  },

  // 获取首营商品列表
  getFirstGoodsList: {
    method: "post",
    url: "/GSPgoods/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取首营商品待审核任务
  getFirstGoodsTask: {
    method: "post",
    url: "/GSPgoods/querytask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营商品待审核并提交
  getFirstauditModify: {
    method: "post",
    url: "/GSPgoods/auditModify",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取首营商品历史
  getFirstGoodsHistory: {
    method: "post",
    url: "/GSPgoods/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营商品回退
  getFirstGoodsGoBack: {
    method: "post",
    url: "/GSPgoods/goBack",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增首营供货商
  addFirstSupplier: {
    method: "post",
    url: "/gspSupplier/add",
    config: {},
  },
  // 查询首营供货商信息
  queryFirstSupplier: {
    method: "post",
    url: "/gspSupplier/queryDetail",
    config: {},
  },
  // 修改首营供货商
  setFirstSupplier: {
    method: "post",
    url: "/gspSupplier/update",
    config: {},
  },

  // 删除首营供货商
  delFirstSupplier: {
    method: "post",
    url: "/gspSupplier/delete",
    config: {},
  },

  // 提交首营供货商
  submitFirstSupplier: {
    method: "post",
    url: "/gspSupplier/submitAudit",
    config: {},
  },

  // 获取首营供货商未审核列表
  getFirstSupplierList: {
    method: "post",
    url: "/gspSupplier/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取首营供货商审核任务
  getFirstSupplierTask: {
    method: "post",
    url: "/gspSupplier/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营供货商审核修改
  gspSupplierauditUpdate: {
    method: "post",
    url: "/gspSupplier/auditUpdate",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取首营供货商历史
  getFirstSupplierHistory: {
    method: "post",
    url: "/gspSupplier/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取首营供货商回退
  getFirstSupplierGoBack: {
    method: "post",
    url: "/gspSupplier/goBack",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营客户列表
  getFirstCustomerList: {
    method: "post",
    url: "/gspCustomer/queryInit",
    config: {},
  },
  // 查询首营客户信息
  queryFirstCustomerInfo: {
    method: "post",
    url: "/gspCustomer/queryDetail",
    config: {},
  },
  // 首营客户任务
  getFirstCustomerTask: {
    method: "post",
    url: "/gspCustomer/queryTask",
    config: {},
  },
  // 首营客户审核修改
  gspCustomerauditModify: {
    method: "post",
    url: "/gspCustomer/auditModify",
    config: {},
  },

  // 首营客户历史
  getFirstCustomerHistory: {
    method: "post",
    url: "/gspCustomer/queryHis",
    config: {},
  },

  // 新增首营客户
  addFirstCustomer: {
    method: "post",
    url: "/gspCustomer/add",
    config: {},
  },

  // 修改首营客户
  setFirstCustomer: {
    method: "post",
    url: "/gspCustomer/modify",
    config: {},
  },

  // 删除首营客户
  delFirstCustomer: {
    method: "post",
    url: "/gspCustomer/delete",
    config: {},
  },

  // 提交首营客户
  submitFirstCustomer: {
    method: "post",
    url: "/gspCustomer/submitAudit",
    config: {},
  },

  // 获取养护计划列表
  getMaintenancePlanList: {
    method: "post",
    url: "/curingPlan/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  addMaintenancePlanList: {
    method: "post",
    url: "/curingPlan/addcuringplan",
    config: {},
  },
  ediutMaintenancePlanList: {
    method: "post",
    url: "/curingPlan/updatecuringplan",
    config: {},
  },
  delectMaintenancePlan: {
    method: "post",
    url: "/curingPlan/deletecuringplan",
    config: {},
  },
  // 完成养护计划列表
  submitMaintenancePlan: {
    method: "post",
    url: "/curingPlan/completeMaintenance",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增召回通知
  addRecallNotice: {
    method: "post",
    url: "/recallnotice/add",
    config: {},
  },

  // 修改召回通知
  setRecallNotice: {
    method: "post",
    url: "/recallnotice/modify",
    config: {},
  },

  // 删除召回通知
  delRecallNotice: {
    method: "post",
    url: "/recallnotice/delete",
    config: {},
  },

  // 提交召回通知
  submitRecallNotice: {
    method: "post",
    url: "/recallnotice/submitAudit",
    config: {},
  },

  // 获取召回通知列表
  getRecallNoticeList: {
    method: "post",
    url: "/recallnotice/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取召回通知任务
  getRecallNoticeTask: {
    method: "post",
    url: "/recallnotice/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取召回通知历史
  getRecallNoticeHistory: {
    method: "post",
    url: "/recallnotice/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取召回登记
  getRecallRegistrationList: {
    method: "post",
    url: "/recallregister/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增召回登记
  addRecallRegistration: {
    method: "post",
    url: "/recallregister/add",
    config: {},
  },

  // 删除召回登记
  delRecallRegistration: {
    method: "post",
    url: "/recallregister/delete",
    config: {},
  },

  // 查询可召回的通知单
  getRecallYesNotice: {
    method: "post",
    url: "/recallnotice/canRegistered",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取停售列表
  getStopSellingList: {
    method: "post",
    url: "/stops/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 解除停售
  stopsReleaseStop: {
    method: "post",
    url: "/stops/releaseStop",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 解除停售记录
  stopsQueryReleaseHis: {
    method: "post",
    url: "/stops/queryReleaseHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取质量复查记录
  getStopReList: {
    method: "post",
    url: "/stops/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 质量复查审核列表
  qualityReviewList: {
    method: "post",
    url: "/stops/qualityReviewList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取可以被解除的停售列表
  getYesStopSellingList: {
    method: "post",
    url: "/stops/queryMayRelieve",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取停售审核任务
  getStopSellingTask: {
    method: "post",
    url: "/stops/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取停售历史
  getStopSellingHistory: {
    method: "post",
    url: "/stops/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增停售信息
  addStopSelling: {
    method: "post",
    url: "/stops/add",
    config: {},
  },

  // 修改停售信息
  setStopSelling: {
    method: "post",
    url: "/stops/update",
    config: {},
  },

  // 删除停售信息
  delStopSelling: {
    method: "post",
    url: "/stops/delete",
    config: {},
  },

  // 提交停售信息
  submitStopSelling: {
    method: "post",
    url: "/stops/submitAudit",
    config: {},
  },

  // 获取解除停售列表
  getRemoveStopSellingList: {
    method: "post",
    url: "/relieves/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取解除停售审核任务
  getRemoveStopSellingTask: {
    method: "post",
    url: "/relieves/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取解除停售历史
  getRemoveStopSellingHistory: {
    method: "post",
    url: "/relieves/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增解除停售
  addRemoveStopSelling: {
    method: "post",
    url: "/relieves/add",
    config: {},
  },

  // 删除解除停售
  delRemoveStopSelling: {
    method: "post",
    url: "/relieves/delete",
    config: {},
  },

  // 提交解除停售
  submitRemoveStopSelling: {
    method: "post",
    url: "/relieves/submitAudit",
    config: {},
  },

  // 获取资料变更列表
  getDataChangeList: {
    method: "post",
    url: "/gspChange/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取资料变更任务
  getDataChangeTask: {
    method: "post",
    url: "/gspChange/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取资料变更历史
  getDataChangeHistory: {
    method: "post",
    url: "/gspChange/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增资料变更信息
  addDataChange: {
    method: "post",
    url: "/gspChange/add",
    config: {},
  },

  // 修改资料变更信息
  setDataChange: {
    method: "post",
    url: "/gspChange/update",
    config: {},
  },

  // 删除资料变更信息
  delDataChange: {
    method: "post",
    url: "/gspChange/delete",
    config: {},
  },

  // 提交资料变更信息
  submitDataChange: {
    method: "post",
    url: "/gspChange/submitAudit",
    config: {},
  },
  // 新增客户资料变更信息（新）
  gspChangeaddChange: {
    method: "post",
    url: "/gspChange/addChangeCm",
    config: {},
  },
  // 新增供应商资料变更信息（新）
  gspChangeaddChangeSupp: {
    method: "post",
    url: "/gspChange/addChangeSupp",
    config: {},
  },
  // 新增商品资料变更信息（新）
  gspChangeaddChangeGood: {
    method: "post",
    url: "/gspChange/addChangeGood",
    config: {},
  },
  // 查询资料变更信息（新）
  gspChangequeryChangeInfo: {
    method: "post",
    url: "/gspChange/queryChangeInfo",
    config: {},
  },
  // 查询客户资料变更信息（新）
  gspChangequeryChangeInfoDetail: {
    method: "post",
    url: "/gspChange/queryChangeInfoDetail",
    config: {},
  },
  // 删除资料变更信息（新）
  gspChangedeleteChangeInfo: {
    method: "post",
    url: "/gspChange/deleteChangeInfo",
    config: {},
  },
  // 更新资料变更信息（新）
  gspChangeupdateChangeInfo: {
    method: "post",
    url: "/gspChange/updateChangeInfo",
    config: {},
  },
  // 查询委托书信息（新）
  gspChangequeryDeAuthLetter: {
    method: "post",
    url: "/gspChange/queryDeAuthLetter",
    config: {},
  },
  // 新增委托书信息（新）
  gspChangeaddChangeSalesPlicence: {
    method: "post",
    url: "/gspChange/addChangeSalesPlicence",
    config: {},
  },
  // 查询委托书变更信息（新）
  gspChangequeryChangeSalesPlicence: {
    method: "post",
    url: "/gspChange/queryChangeSalesPlicence",
    config: {},
  },
  // 库存报溢列表
  getStockOverflowList: {
    method: "post",
    url: "/overflow/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 库存报溢任务
  getStockOverflowTask: {
    method: "post",
    url: "/overflow/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 库存报溢历史
  getStockOverflowHistory: {
    method: "post",
    url: "/overflow/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库存报溢
  addStockOverflow: {
    method: "post",
    url: "/overflow/add",
    config: {},
  },

  // 修改库存报溢
  setStockOverflow: {
    method: "post",
    url: "/overflow/modify",
    config: {},
  },

  // 删除库存报溢
  delStockOverflow: {
    method: "post",
    url: "/overflow/delete",
    config: {},
  },

  // 提交库存报溢
  submitStockOverflow: {
    method: "post",
    url: "/overflow/submitAudit",
    config: {},
  },

  // 获取库存移库列表
  getStockMoveList: {
    method: "post",
    url: "/move/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存移库任务
  getStockMoveTask: {
    method: "post",
    url: "/move/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存移库任务
  getStockMoveHistory: {
    method: "post",
    url: "/move/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询库存移库历史
  queryHisMaster: {
    method: "post",
    url: "/move/queryHisMaster",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增库存移库
  addStockMove: {
    method: "post",
    url: "/move/add",
    config: {},
  },

  // 修改库存移库
  setStockMove: {
    method: "post",
    url: "/move/modifyMaster",
    config: {},
  },

  // 删除库存移库
  delStockMove: {
    method: "post",
    url: "/move/delete",
    config: {},
  },

  // 提交库存移库
  submitStockMove: {
    method: "post",
    url: "/move/submitAudit",
    config: {},
  },

  // 获取采购记账单-退补价用
  getPurchaseListOrder: {
    method: "post",
    url: "/psaccount/query",
    config: {},
  },

  // 获取采购记账单-退货时候用
  getPurchaseListOrderTwo: {
    method: "post",
    url: "/psaccount/queryAll",
    config: {},
  },
  // 获取采购记账单-退货时候用
  pschaqueryAuthed: {
    method: "post",
    url: "/pscha/queryAuthed",
    config: {},
  },
  // 获取采购上架列表查询
  pschaqueryWaitUp: {
    method: "post",
    url: "/puListing/queryListing",
    config: {},
  },
  // 获取采购上架列表新增
  pschaupdateAdd: {
    method: "post",
    url: "/puListing/add",
    config: {},
  },
  // 获取采购上架列表提交
  pschasubmitWaitUp: {
    method: "post",
    url: "/pscha/submitWaitUp",
    config: {},
  },
  // 提取采购记账单
  extractPurchaseListOrder: {
    method: "post",
    url: "/RgApply/extract",
    config: {},
  },

  // 获取库存属性调整列表
  getAttributeAdjustmentList: {
    method: "post",
    url: "/Attribute/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存属性调整任务
  getAttributeAdjustmentTask: {
    method: "post",
    url: "/Attribute/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存属性调整历史
  getAttributeAdjustmentHistory: {
    method: "post",
    url: "/Attribute/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库存属性调整
  addAttributeAdjustment: {
    method: "post",
    url: "/Attribute/add",
    config: {},
  },

  // 修改库存属性调整
  setAttributeAdjustment: {
    method: "post",
    url: "/Attribute/modify",
    config: {},
  },

  // 删除库存属性调整
  delAttributeAdjustment: {
    method: "post",
    url: "/Attribute/delete",
    config: {},
  },

  // 提交库存属性调整
  submitAttributeAdjustment: {
    method: "post",
    url: "/Attribute/submitAudit",
    config: {},
  },

  // 获取库存盘点计划
  getStockLnventoryPlan: {
    method: "post",
    url: "/invplan/queryInvPlan",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存盘点任务
  getStockLnventoryTask: {
    method: "post",
    url: "/invplan/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存盘点历史
  getStockLnventoryHistory: {
    method: "post",
    url: "/invplan/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存盘点驳回
  getStockLnventoryReject: {
    method: "post",
    url: "/invplan/queryBack",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 生成库存盘点计划
  createStockLnventoryPlan: {
    method: "post",
    url: "/invplan/genInvplan",
    config: {},
  },

  // 修改库存盘点计划
  setStockLnventoryPlan: {
    method: "post",
    url: "/invplan/modifyInvPlan",
    config: {},
  },
  // 完成库存盘点计划
  invplanfinishInvPlan: {
    method: "post",
    url: "/invplan/finishInvPlan",
    config: {},
  },

  // 删除库存盘点计划
  delStockLnventoryPlan: {
    method: "post",
    url: "/invplan/delete",
    config: {},
  },

  // 提交库存盘点计划
  submitStockLnventoryPlan: {
    method: "post",
    url: "/invplan/submitAudit",
    config: {},
  },
  // 提交库存盘点
  submitStorageRoomLoss: {
    method: "post",
    url: "/invplan/submitCheck",
    config: {},
  },
  // 提交核对
  submittorage: {
    method: "post",
    url: "/invplan/referCheck",
    config: {},
  },
  // 查询待核对库存盘点计划
  queryCheckInvPlanRoomLoss: {
    method: "post",
    url: "/invplan/queryCheckInvPlan",
    config: {},
  },
  // 获取库存上下限列表
  getStockLimitList: {
    method: "post",
    url: "/limit/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增库存上下限
  addStockLimit: {
    method: "post",
    url: "/limit/add",
    config: {},
  },

  // 删除库存上下限
  delStockLimit: {
    method: "post",
    url: "/limit/delete",
    config: {},
  },

  // 修改库存上下限
  setStockLimit: {
    method: "post",
    url: "/limit/update",
    config: {},
  },
  // 导出库存上下限
  limitExportDetail: {
    method: "post",
    url: "/limit/exportDetail",
    config: {},
  },
  // 获取销售退货收货列表
  getSalesReceivingList: {
    method: "post",
    url: "/returnRego/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退货收货任务
  getSalesReceivingTask: {
    method: "post",
    url: "/returnRego/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取销售退货收货历史
  getSalesReceivingHistory: {
    method: "post",
    url: "/returnRego/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增销售退货收货
  addSalesReceiving: {
    method: "post",
    url: "/returnRego/add",
    config: {},
  },

  // 修改销售退货收货
  setSalesReceiving: {
    method: "post",
    url: "/returnRego/modify",
    config: {},
  },

  // 删除销售退货收货
  delSalesReceiving: {
    method: "post",
    url: "/returnRego/delete",
    config: {},
  },

  // 提交销售退货收货完成
  submitSalesReceiving: {
    method: "post",
    url: "/returnRego/submit",
    config: {},
  },
  // 查询待提交销售退回通知单列表
  querywaitReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/querywait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增销售退回通知单
  addtReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/add",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改销售退回通知单
  modifyReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/modify",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 删除销售退回通知单
  deleteReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/delete",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 提交销售退回通知单审核
  submitReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/submit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询销售退回通知单任务待审核列表
  querytaskReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/querytask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询销售退回通知单历史列表
  queryhisReturnGoodsNotices: {
    method: "post",
    url: "/ReturnGoodsNotices/queryhis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 退回销售退回通知单历史列表
  suRgnoticesGoBack: {
    method: "post",
    url: "/suBack/suRgnoticesGoBack",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 提取销售退货单
  extractSalesReturnOrder: {
    method: "post",
    url: "/returnRego/extract",
    config: {},
  },

  // 获取销售退货审核通过的列表
  getSalesReturnOrderYesList: {
    method: "post",
    url: "/ReturnGoods/queryapply_audit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取审核通过的销售退货收货列表
  getSalesReturnReceivingYesList: {
    method: "post",
    url: "/returnRego/queryAudit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 提取销售退货收货单
  extractSalesReturnReceivingOrder: {
    method: "post",
    url: "/surgcha/extract",
    config: {},
  },

  // 获取近效期预警
  getNewTimeWaring: {
    method: "post",
    url: "/wsuWaring/queryNearlyEff",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取滞销预警
  getUnsalableWaring: {
    method: "post",
    url: "/wsuWaring/queryUnsalable",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取业务员列表
  getSalesmanList: {
    method: "post",
    url: "/counterpartySalesman/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增对方业务员信息
  addSalesmanInfo: {
    method: "post",
    url: "/counterpartySalesman/add",
    config: {},
  },

  // 修改对方业务员信息
  setSalesmanInfo: {
    method: "post",
    url: "/counterpartySalesman/update",
    config: {},
  },
  // 删除对方业务员信息
  delSalesmanInfo: {
    method: "post",
    url: "/counterpartySalesman/delete",
    config: {},
  },

  // 修改业务员状态
  setSalesmanStatus: {
    method: "post",
    url: "/counterpartySalesman/stop",
    config: {},
  },

  // 获取单位下可用的业务员
  getUnitSalesmanList: {
    method: "post",
    url: "/counterpartySalesman/queryByUnit",
    config: {},
  },
  // 新增委托信息
  addLicense: {
    method: "post",
    url: "/counterpartySalesman/addLicense",
    config: {},
  },
  // 修改委托信息
  modifyLicense: {
    method: "post",
    url: "/counterpartySalesman/modifyLicense",
    config: {},
  },
  // 删除委托信息
  deleteLicense: {
    method: "post",
    url: "/counterpartySalesman/deleteLicense",
    config: {},
  },

  // 新增对方人员单位
  addUserUnit: {
    method: "post",
    url: "/counterpartySalesman/addUnit",
    config: {},
  },

  // 修改对方人员单位
  setUserUnit: {
    method: "post",
    url: "/counterpartySalesman/updateUnit",
    config: {},
  },

  // 获取价格策略分组
  getPriceStrategyGroup: {
    method: "post",
    url: "/price/queryPriceLevensList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增价格策略分组
  addPriceStrategyGroup: {
    method: "post",
    url: "/price/add_group",
    config: {},
  },

  // 修改价格策略分组
  setPriceStrategyGroup: {
    method: "post",
    url: "/price/modify_group",
    config: {},
  },

  // 删除价格策略分组
  delPriceStrategyGroup: {
    method: "post",
    url: "/price/delete_group",
    config: {},
  },

  // 获取价格策略
  getPriceStrategy: {
    method: "post",
    url: "/price/queryPriceLevens",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增价格策略
  addPriceStrategy: {
    method: "post",
    url: "/price/addPricelevens",
    config: {},
  },

  // 修改价格策略
  setPriceStrategy: {
    method: "post",
    url: "/price/updatePricelevens",
    config: {},
  },

  // 删除价格策略
  delPriceStrategy: {
    method: "post",
    url: "/price/deletePricelevens",
    config: {},
  },

  // 获取限销策略分组
  getRestrictionStrategyGroup: {
    method: "post",
    url: "/SalesRestriction/query_sgvgroup",
    config: {},
  },

  // 新增限销策略分组
  addRestrictionStrategyGroup: {
    method: "post",
    url: "/SalesRestriction/add_sgvgroup",
    config: {},
  },

  // 修改限销策略分组
  setRestrictionStrategyGroup: {
    method: "post",
    url: "/SalesRestriction/modify_sgvgroup",
    config: {},
  },

  // 删除限销策略分组
  delRestrictionStrategyGroup: {
    method: "post",
    url: "/SalesRestriction/delete_sgvgroup",
    config: {},
  },

  // 获取限销策略
  getRestrictionStrategy: {
    method: "post",
    url: "/SalesRestriction/query_sgvdetil",
    config: {},
  },

  // 新增限销策略
  addRestrictionStrategy: {
    method: "post",
    url: "/SalesRestriction/add_sgvdetail",
    config: {},
  },
  // 新增限销范围
  addGoodsscopeLimit: {
    method: "post",
    url: "/goodsscopeLimit/add",
    config: {},
  },
  // 修改限销范围
  updateGoodsscopeLimit: {
    method: "post",
    url: "/goodsscopeLimit/update",
    config: {},
  },
  // 删除限销范围
  deleteGoodsscopeLimit: {
    method: "post",
    url: "/goodsscopeLimit/delete",
    config: {},
  },
  // 查询限销范围
  queryGoodsscopeLimit: {
    method: "post",
    url: "/goodsscopeLimit/query",
    config: {},
  },
  // 修改限销策略
  setRestrictionStrategy: {
    method: "post",
    url: "/SalesRestriction/modify_sgvdetail",
    config: {},
  },

  // 删除限销策略
  delRestrictionStrategy: {
    method: "post",
    url: "/SalesRestriction/delete_sgvdetail",
    config: {},
  },
  // 查询限销商品分类
  goodsClassLimitQuery: {
    method: "post",
    url: "/goodsClassLimit/query",
    config: {},
  },
  // 新增限销商品分类
  goodsClassLimitAdd: {
    method: "post",
    url: "/goodsClassLimit/add",
    config: {},
  },
  // 修改限销商品分类
  goodsClassLimitUpdate: {
    method: "post",
    url: "/goodsClassLimit/update",
    config: {},
  },

  // 删除限销商品分类
  goodsClassLimitDelete: {
    method: "post",
    url: "/goodsClassLimit/delete",
    config: {},
  },
  // 查询限销商品超量申请列表
  overApplicationQuery: {
    method: "post",
    url: "/overApplication/query",
    config: {},
  },
  // 新增限销商品超量申请列表
  overApplicationAdd: {
    method: "post",
    url: "/overApplication/add",
    config: {},
  },
  // 修改限销商品超量申请列表
  overApplicationUpdate: {
    method: "post",
    url: "/overApplication/update",
    config: {},
  },
  // 删除限销商品超量申请列表
  overApplicationDelete: {
    method: "post",
    url: "/overApplication/delete",
    config: {},
  },
  // 提交限销商品超量申请列表
  overApplicationSubmit: {
    method: "post",
    url: "/overApplication/submit",
    config: {},
  },
  // 查询待审核限销商品超量申请列表
  overApplicationQueryTask: {
    method: "post",
    url: "/overApplication/queryTask",
    config: {},
  },
  // 查询历史限销商品超量列表
  overApplicationQueryHis: {
    method: "post",
    url: "/overApplication/queryHis",
    config: {},
  },
  // 获取期初记账
  getInitBookkeeping: {
    method: "post",
    url: "/beginAccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 新增期初记账
  addInitBookkeeping: {
    method: "post",
    url: "/beginAccount/addBegin",
    config: {},
  },
  // 采购记账
  getPsAccountList: {
    method: "post",
    url: "/psaccount/queryAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购新增
  addPsAccountList: {
    method: "post",
    url: "/psaccount/add",
    config: {},
  },
  // 采购退货记账
  getPsReturnAccountList: {
    method: "post",
    url: "/RgApply/queryBill",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  RgApplyqueryAudit: {
    method: "post",
    url: "/RgApply/queryAudit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 采购退货新增
  addPsReturnAccountList: {
    method: "post",
    url: "/RgApply/saveBill",
    config: {},
  },
  // 查询采购结算申请
  getPsSettlementList: {
    method: "post",
    url: "/psSettleApply/queryWait",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增采购结算申请
  addPsSettlementApply: {
    method: "post",
    url: "/psSettleApply/add",
    config: {},
  },
  // 删除采购结算申请
  delPsSettlementApply: {
    method: "post",
    url: "/psSettleApply/delete",
    config: {},
  },
  // 获取结算记账提取列表
  getPsSettlementExtractList: {
    method: "post",
    url: "/psSettleApply/queryPre",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加结算记账
  addPsSettlementKeep: {
    method: "post",
    url: "/psSettleAccount/add",
    config: {},
  },
  // 查询结算记账
  getPsSettlementKeepList: {
    method: "post",
    url: "/psSettleAccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 提交采购结算申请审核
  subPsSettlementApply: {
    method: "post",
    url: "/psSettleApply/submit",
    config: {},
  },
  // 查询采购结算历史
  getPsSettlementHistoryList: {
    method: "post",
    url: "/psSettleApply/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询采购结算审核任务
  getPsSettlementTaskList: {
    method: "post",
    url: "/psSettleApply/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询预付款申请单
  getPaymentApplyList: {
    method: "post",
    url: "/preApply/querypreApply",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  }, // 查询预付款申请单
  queryRkRecordList: {
    method: "post",
    url: "acceptsettlement/queryRkRecordList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询预付款申请单
  querySuaccountList: {
    method: "post",
    url: "/acceptsettlement/querySuaccountList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查看明细
  querySuaccountDetailList: {
    method: "post",
    url: "/acceptsettlement/querySuaccountDetailList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  queryWaitPre: {
    method: "post",
    url: "register/queryWaitPre",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询预付款申请单
  queryWaitpsAccount: {
    method: "post",
    url: "register/queryWaitpsAccount",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增预付款结算单
  addPreSettle: {
    method: "post",
    url: "/register/addPreSettle",
    config: {},
  },
  // 查询明细
  queryPsaccountDetailList: {
    method: "post",
    url: "/register/queryPsaccountDetailList",
    config: {},
  },
  // 查询拦截规则
  queryOrmRule: {
    method: "post",
    url: "/fromrule/queryOrmRule",
    config: {},
  },
  // 新增预付款申请单
  addPaymentApply: {
    method: "post",
    url: "/preApply/addPreApply",
    config: {},
  },
  // 修改预付款申请单
  upDatePaymentApply: {
    method: "post",
    url: "/preApply/updatePreApply",
    config: {},
  },
  // 删除预付款申请单
  delPaymentApply: {
    method: "post",
    url: "/preApply/deletePreApply",
    config: {},
  },
  // 提交预付款申请单
  subPaymentApply: {
    method: "post",
    url: "/preApply/submit",
    config: {},
  },
  // // 销售退补审核
  // rrApplyCheck: {
  // 	method: 'post',
  // 	url: '/RrApply/check',
  // 	config: {}
  // },

  // 提交预付款申请单
  subPaymentApply: {
    method: "post",
    url: "/preApply/submit",
    config: {},
  },

  // 查询待审核的采购预付款申请单
  preApplyQueryTask: {
    method: "post",
    url: "/preApply/queryTask",
    config: {},
  },
  // 查询审核通过的采购预付款申请单
  preApplyQueryHis: {
    method: "post",
    url: "/preApply/queryHis",
    config: {},
  },
  // 查询审核通过的采购预付款申请单
  preApplyQueryAudit: {
    method: "post",
    url: "/preApply/queryAudit",
    config: {},
  },

  // 根据Id获取表单打印方案
  getPrintPlanById: {
    method: "post",
    url: "/printsolutions/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  //  查询所有打印方案分类
  getPrintPlan: {
    method: "post",
    url: "Jurisdiction/printQuery",
    config: {},
  },

  // 查询所有报表查询方案
  getReportFormData: {
    method: "post",
    url: "/reportPlan/getReportPlan",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 查询对应报表实体数据
  getReportDataById: {
    method: "post",
    url: "/reportPlan/queryReportPlanEntityVo",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 批量修改单位
  batchUpdateUnit: {
    method: "post",
    url: "/flowtemp/batchUpdateUnit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // + Vue.prototype.$printData.printSource

  // 查询设备养护信息
  getGspYhList: {
    method: "post",
    url: "/emcuring/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增设备养护信息
  addGspYhInfo: {
    method: "post",
    url: "/emcuring/add",
    config: {},
  },
  // 修改设备养护信息
  updateGspYhInfo: {
    method: "post",
    url: "/emcuring/modify",
    config: {},
  },
  // 删除设备养护信息
  delGspYhInfo: {
    method: "post",
    url: "/emcuring/delete",
    config: {},
  },

  // 查询设备维修信息
  getGspWxList: {
    method: "post",
    url: "/emrepair/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增设备维修信息
  addGspWxInfo: {
    method: "post",
    url: "/emrepair/add",
    config: {},
  },
  // 修改设备维修信息
  updateGspWxInfo: {
    method: "post",
    url: "/emrepair/modify",
    config: {},
  },
  // 删除设备维修信息
  delGspWxInfo: {
    method: "post",
    url: "/emrepair/delete",
    config: {},
  },

  // 查询设备报废信息
  getGspBfList: {
    method: "post",
    url: "/emscrap/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增设备报废信息
  addGspBfInfo: {
    method: "post",
    url: "/emscrap/add",
    config: {},
  },
  // 删除设备报废信息
  delGspBfInfo: {
    method: "post",
    url: "/emscrap/delete",
    config: {},
  },

  // 查询设备报台账信息
  getGspTzList: {
    method: "post",
    url: "/emaccount/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 新增设备台账信息
  addGspTzInfo: {
    method: "post",
    url: "/emaccount/add",
    config: {},
  },
  // 删除设备台账信息
  delGspTzInfo: {
    method: "post",
    url: "/emaccount/delete",
    config: {},
  },

  // 穿透 获取数据
  getPenetrateData: {
    method: "post",
    url: "/penetrate/penetrateInfo",
    config: {},
  },

  // 获取办公物品采购列表
  getPurchaseQueryInit: {
    method: "post",
    url: "/purchase/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加办公物品采购申请
  purchaseAdd: {
    method: "post",
    url: "/purchase/add",
    config: {},
  },
  // 修改办公物品采购申请
  purchaseUpdate: {
    method: "post",
    url: "/purchase/update",
    config: {},
  },
  // 提交办公物品采购申请
  purchaseSubmit: {
    method: "post",
    url: "/purchase/submit",
    config: {},
  },
  // 删除办公物品采购申请
  purchaseDelete: {
    method: "post",
    url: "/purchase/delete",
    config: {},
  },
  // 获取办公物品采购审核
  getPurchaseQueryTask: {
    method: "post",
    url: "/purchase/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取办公物品采购历史
  getPurchaseQueryHis: {
    method: "post",
    url: "/purchase/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取办公物品领用列表
  getGuseQueryInit: {
    method: "post",
    url: "/guse/queryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加办公物品领用申请
  guseAdd: {
    method: "post",
    url: "/guse/add",
    config: {},
  },
  // 修改办公物品领用申请
  guseUpdate: {
    method: "post",
    url: "/guse/update",
    config: {},
  },
  // 提交办公物品领用申请
  guseSubmit: {
    method: "post",
    url: "/guse/submit",
    config: {},
  },
  // 删除办公物品领用申请
  guseDelete: {
    method: "post",
    url: "/guse/delete",
    config: {},
  },
  // 获取办公物品领用审核
  getGuseQueryTask: {
    method: "post",
    url: "/guse/queryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取办公物品领用历史
  getGuseQueryHis: {
    method: "post",
    url: "/guse/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取请假列表
  getStaffLeaveQuery: {
    method: "post",
    url: "/staffLeave/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加请假申请
  staffLeaveAdd: {
    method: "post",
    url: "/staffLeave/add",
    config: {},
  },
  // 修改请假申请
  staffLeaveUpdate: {
    method: "post",
    url: "/staffLeave/update",
    config: {},
  },
  // 提交请假申请
  staffLeaveSubmitAudit: {
    method: "post",
    url: "/staffLeave/submitAudit",
    config: {},
  },
  // 删除请假申请
  staffLeaveDelete: {
    method: "post",
    url: "/staffLeave/delete",
    config: {},
  },
  // 获取请假审核
  getStaffLeaveQueryLeaveTask: {
    method: "post",
    url: "/staffLeave/queryLeaveTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取请假历史
  getStaffLeaveQueryLeaveHis: {
    method: "post",
    url: "/staffLeave/queryLeaveHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取访客登记
  getVisitorQuery: {
    method: "post",
    url: "/visitor/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加访客登记
  visitorAdd: {
    method: "post",
    url: "/visitor/add",
    config: {},
  },
  // 删除访客登记
  visitorDelete: {
    method: "post",
    url: "/visitor/delete",
    config: {},
  },

  // 获取入职申请列表
  getPensonelQueryEntryInit: {
    method: "post",
    url: "/pensonel/queryEntryInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加入职申请
  pensonelAddEntry: {
    method: "post",
    url: "/pensonel/addEntry",
    config: {},
  },
  // 修改入职申请
  pensonelUpdateEntry: {
    method: "post",
    url: "/pensonel/updateEntry",
    config: {},
  },
  // 删除入职申请
  pensonelDeleteEntry: {
    method: "post",
    url: "/pensonel/deleteEntry",
    config: {},
  },
  // 提交入职申请
  pensonelSubmitEntry: {
    method: "post",
    url: "/pensonel/submitEntry",
    config: {},
  },
  // 获取入职申请审核
  getPensonelQueryEntryTask: {
    method: "post",
    url: "/pensonel/queryEntryTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取入职申请历史
  getPensonelQueryEntryHis: {
    method: "post",
    url: "/pensonel/queryEntryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取离职申请列表
  getPensonelQueryQuitInit: {
    method: "post",
    url: "/pensonel/queryQuitInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加离职申请
  pensonelAddQuit: {
    method: "post",
    url: "/pensonel/addQuit",
    config: {},
  },
  // 修改离职申请
  pensonelUpdateQuit: {
    method: "post",
    url: "/pensonel/updateQuit",
    config: {},
  },
  // 删除离职申请
  pensonelDeleteQuit: {
    method: "post",
    url: "/pensonel/deleteQuit",
    config: {},
  },
  // 提交离职申请
  pensonelSubmitQuit: {
    method: "post",
    url: "/pensonel/submitQuit",
    config: {},
  },
  // 获取离职申请审核
  getPensonelQueryQuitTask: {
    method: "post",
    url: "/pensonel/queryQuitTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取离职申请历史
  getPensonelQueryQuitHis: {
    method: "post",
    url: "/pensonel/queryQuitHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取调岗申请列表
  getPensonelQueryTransferInit: {
    method: "post",
    url: "/pensonel/queryTransferInit",
    cconfig: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加调岗申请
  pensonelAddTransfer: {
    method: "post",
    url: "/pensonel/addTransfer",
    config: {},
  },
  // 修改调岗申请
  pensonelUpdateTransfer: {
    method: "post",
    url: "/pensonel/updateTransfer",
    config: {},
  },
  // 删除调岗申请
  pensonelDeleteTransfer: {
    method: "post",
    url: "/pensonel/deleteTransfer",
    config: {},
  },
  // 提交调岗申请
  pensonelSubmitTransfer: {
    method: "post",
    url: "/pensonel/submitTransfer",
    config: {},
  },
  // 获取调岗申请审核
  getPensonelQueryTransferTask: {
    method: "post",
    url: "/pensonel/queryTransferTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取调岗申请历史
  getPensonelQueryTransferHis: {
    method: "post",
    url: "/pensonel/queryTransferHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取办公车辆列表
  getVehuseQuery: {
    method: "post",
    url: "/vehuse/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加办公车辆
  vehuseAdd: {
    method: "post",
    url: "/vehuse/add",
    config: {},
  },
  // 修改办公车辆
  vehuseUpdate: {
    method: "post",
    url: "/vehuse/update",
    config: {},
  },
  // 删除办公车辆
  vehuseDelete: {
    method: "post",
    url: "/vehuse/delete",
    config: {},
  },
  // 提交办公车辆
  vehuseSubmitAudit: {
    method: "post",
    url: "/vehuse/submitAudit",
    config: {},
  },
  // 获取办公车辆审核
  getVehuseQueryVehuseTask: {
    method: "post",
    url: "/vehuse/queryVehuseTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取办公车辆历史
  getVehuseQueryVehuseHis: {
    method: "post",
    url: "/vehuse/queryVehuseHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取出差列表
  getTravelQuery: {
    method: "post",
    url: "/travel/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加出差
  travelAdd: {
    method: "post",
    url: "/travel/add",
    config: {},
  },
  // 修改出差
  travelUpdate: {
    method: "post",
    url: "/travel/update",
    config: {},
  },
  // 删除出差
  travelDelete: {
    method: "post",
    url: "/travel/delete",
    config: {},
  },
  // 提交出差
  travelSubmitAudit: {
    method: "post",
    url: "/travel/submitAudit",
    config: {},
  },
  // 获取出差审核
  getTravelQueryLeaveTask: {
    method: "post",
    url: "/travel/queryLeaveTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取出差历史
  getTravelQueryLeaveHis: {
    method: "post",
    url: "/travel/queryLeaveHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取报销列表
  getBurseQuery: {
    method: "post",
    url: "/burse/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加报销
  burseAdd: {
    method: "post",
    url: "/burse/add",
    config: {},
  },
  // 修改报销
  burseUpdate: {
    method: "post",
    url: "/burse/update",
    config: {},
  },
  // 删除报销
  burseDelete: {
    method: "post",
    url: "/burse/delete",
    config: {},
  },
  // 提交报销
  burseSubmitAudit: {
    method: "post",
    url: "/burse/submitAudit",
    config: {},
  },
  // 获取报销审核
  getBurseQueryLeaveTask: {
    method: "post",
    url: "/burse/queryLeaveTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取报销历史
  getBurseQueryLeaveHis: {
    method: "post",
    url: "/burse/queryLeaveHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 配送车辆证照
  vehicleLicencequery: {
    method: "post",
    url: "/vehicleLicence/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 配送车辆证照添加
  vehicleLicenceadd: {
    method: "post",
    url: "/vehicleLicence/add",
    config: {},
  },
  // 配送车辆证照修改
  vehicleLicencemodify: {
    method: "post",
    url: "vehicleLicence/modify",
    config: {},
  },
  // 配送车辆证照删除
  vehicleLicencedelete: {
    method: "post",
    url: "/vehicleLicence/delete",
    config: {},
  },
  // 配送车辆维修
  vehicleRepairquery: {
    method: "post",
    url: "/vehicleRepair/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 配送车辆维修添加
  vehicleRepairadd: {
    method: "post",
    url: "/vehicleRepair/add",
    config: {},
  },
  // 配送车辆维修删除
  vehicleRepairdelete: {
    method: "post",
    url: "/vehicleRepair/delete",
    config: {},
  },
  // 配送车辆维修修改
  vehicleRepairmodify: {
    method: "post",
    url: "/vehicleRepair/modify",
    config: {},
  },
  // 配送车辆保养
  vehicleCuringquery: {
    method: "post",
    url: "/vehicleCuring/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 配送车辆保养添加
  vehicleCuringadd: {
    method: "post",
    url: "/vehicleCuring/add",
    config: {},
  },
  // 配送车辆保养删除
  vehicleCuringdelete: {
    method: "post",
    url: "/vehicleCuring/delete",
    config: {},
  },
  // 配送车辆保养修改
  vehicleCuringmodify: {
    method: "post",
    url: "/vehicleCuring/modify",
    config: {},
  },
  // 配送车辆保险
  vehicleInsurequery: {
    method: "post",
    url: "/vehicleInsure/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 配送车辆保险添加
  vehicleInsureadd: {
    method: "post",
    url: "/vehicleInsure/add",
    config: {},
  },

  // 配送车辆保险编辑
  vehicleInsuremodify: {
    method: "post",
    url: "/vehicleInsure/modify",
    config: {},
  },
  // 配送车辆保险delete
  vehicleInsuredelete: {
    method: "post",
    url: "/vehicleInsure/delete",
    config: {},
  },
  // 首营商品审核
  BusinessGoodqueryLicenceNoteTask: {
    method: "post",
    url: "/BusinessGood/queryLicenceNoteTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营商品审核
  BusinessGoodqueryLicenceNoteHistory: {
    method: "post",
    url: "/BusinessGood/queryLicenceNoteHistory",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 首营商品审核
  gspSupplierquerySupplierLicenseTask: {
    method: "post",
    url: "/gspSupplier/querySupplierLicenseTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营商品审核
  gspSupplierquerySupplierLicenseHistory: {
    method: "post",
    url: "/gspSupplier/querySupplierLicenseHistory",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营客户审核
  gspCustomerqueryCuslicenceLinfonoteTask: {
    method: "post",
    url: "/gspCustomer/queryCuslicenceLinfonoteTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营客户历史
  gspCustomerqueryCuslicenceLinfonoteHistory: {
    method: "post",
    url: "/gspCustomer/queryCuslicenceLinfonoteHistory",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 首营客户回退
  gspCustomergoBack: {
    method: "post",
    url: "/gspCustomer/goBack",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取单位授信列表
  getUnitCreditQueryUnitCreditInit: {
    method: "post",
    url: "/unitCredit/queryUnitCreditInit",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 添加单位授信
  unitCreditAddUnitCredit: {
    method: "post",
    url: "/unitCredit/addUnitCredit",
    config: {},
  },
  // 修改单位授信
  unitCreditUpdateUnitCredit: {
    method: "post",
    url: "/unitCredit/updateUnitCredit",
    config: {},
  },
  // 删除单位授信
  unitCreditDeleteUnitCredit: {
    method: "post",
    url: "/unitCredit/deleteUnitCredit",
    config: {},
  },
  // 提交单位授信
  unitCreditSubmitAudit: {
    method: "post",
    url: "/unitCredit/submitAudit",
    config: {},
  },
  // 获取单位授信审核
  getUnitCreditQueryUnitCreditTask: {
    method: "post",
    url: "/unitCredit/queryUnitCreditTask",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 获取单位授信历史
  getUnitCreditQueryUnitCreditHis: {
    method: "post",
    url: "/unitCredit/queryUnitCreditHistory",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取养护提醒
  getCuringPlanCuringWarn: {
    method: "post",
    url: "/curingPlan/curingWarn",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取证照阈值管理
  getLicenseWarnQueryAll: {
    method: "post",
    url: "/licenseWarn/queryAll",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 修改证照阈值管理
  licenseWarnUpdateLicenseWarn: {
    method: "post",
    url: "/licenseWarn/updateLicenseWarn",
    config: {},
  },

  // 获取库存流水信息
  queryStockTurnover: {
    method: "post",
    url: "/stockStatistics/queryStockTurnover",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取历史库存信息
  statisticsQueryStockHistory: {
    method: "post",
    url: "/stockStatistics/queryStockHistory",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取库存周转分析
  statisticsQueryStockTurnRate: {
    method: "post",
    url: "/stockStatistics/queryStockTurnRate",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取回执管理列表
  receiptQueryReceipt: {
    method: "post",
    url: "/receipt/queryReceipt",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  // 登记回执
  receiptRegisterReceipt: {
    method: "post",
    url: "/receipt/registerReceipt",
    config: {},
  },
  // 临时延长回执
  receiptPostponeReceipt: {
    method: "post",
    url: "/receipt/postponeReceipt",
    config: {},
  },

  // 获取所有APP权限
  getAllAppJurisdiction: {
    method: "get",
    url: "/jurisdiction/mobile/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取人员对应所有APP权限
  getOneAppJurisdiction: {
    method: "post",
    url: "/jurisdiction/mobile/person/query",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 保存人员设置的APP权限
  saveAppJurisdiction: {
    method: "post",
    url: "/jurisdiction/mobile/person/save",
    config: {},
  },

  // 获取顶级homePage
  getHomePage: {
    method: "post",
    url: "/jurconfig/getHomePage",
    config: {},
  },
  // 提取方案首营客户信息
  cusmasterqueryMpcus: {
    method: "post",
    url: "/cusmaster/queryMpcus",
    config: {},
  },
  // 提取方案首营客户信息明细
  cusmasterqueryMpcusInfo: {
    method: "post",
    url: "/cusmaster/queryMpcusInfo",
    config: {},
  },
  // 提取方案之前验证是否已经提取
  checkIsExtract: {
    method: "post",
    url: "/extract/confirm",
    config: {},
  },
  // 提取方案之前验证是否已经提取
  curingPlanaddPeriod: {
    method: "post",
    url: "/curingPlan/addPeriod",
    config: {},
  },
  // 提取方案之前验证是否已经提取
  curingPlanqueryPeriod: {
    method: "post",
    url: "/curingPlan/queryPeriod",
    config: {},
  },
  // 获取用户绑定单位信息
  userUnitqueryUserExistUnit: {
    method: "post",
    url: "/userUnit/queryUserExistUnit",
    config: {},
  },
  // 获取用户没有绑定单位信息
  userUnitqueryUserNoExistUnit: {
    method: "post",
    url: "/userUnit/queryUserNoExistUnit",
    config: {},
  },
  // 添加移除单位信息
  userUnitsetUserUnitData: {
    method: "post",
    url: "/userUnit/setUserUnitData",
    config: {},
  },

  // 三方单位查询
  descibUnitSelect: {
    method: "post",
    url: "/descibUnit/select",
    config: {},
  },
  // 三方单位添加
  descibUnitAdd: {
    method: "post",
    url: "/descibUnit/add",
    config: {},
  },
  // 三方单位修改
  descibUnitUpdate: {
    method: "post",
    url: "/descibUnit/update",
    config: {},
  },
  // 三方单位删除
  descibUnitDelete: {
    method: "post",
    url: "/descibUnit/delete",
    config: {},
  },

  // 三方银行查询
  descibBankSelect: {
    method: "post",
    url: "/descibBank/select",
    config: {},
  },
  // 三方银行添加
  descibBankAdd: {
    method: "post",
    url: "/descibBank/add",
    config: {},
  },
  // 三方银行修改
  descibBankUpdate: {
    method: "post",
    url: "/descibBank/update",
    config: {},
  },
  // 三方银行删除
  descibBankDelete: {
    method: "post",
    url: "/descibBank/delete",
    config: {},
  },

  // 商品
  // 获取用户没绑定的商品信息
  userGoodsqueryUserNoExistGoods: {
    method: "post",
    url: "/userGoods/queryUserNoExistGoods",
    config: {},
  },
  // 获取用户绑定的商品信息
  userGoodsqueryUserExistGoods: {
    method: "post",
    url: "/userGoods/queryUserExistGoods",
    config: {},
  },
  // 添加移除商品信息
  userGoodssetUserGoodsData: {
    method: "get",
    url: "/userGoods/setUserGoodsData",
    config: {},
  },
  // 业务员
  //对方业务员导出
  // 查询货主不包含的业务员
  couserqueryNoUser: {
    method: "post",
    url: "/couser/queryNoUser",
    config: {},
  },
  // 获取用户绑定的商品信息
  couserqueryUser: {
    method: "post",
    url: "/couser/queryUser",
    config: {},
  },
  // 添加移除商品信息
  couseradd: {
    method: "post",
    url: "/couser/add",
    config: {},
  },
  // 货主

  // 查询业务员不包含的货主
  userCargoownerqueryNoCoId: {
    method: "post",
    url: "/userCargoowner/queryNoCoId",
    config: {},
  },
  // 查询业务员包含的货主
  userCargoownerqueryCoId: {
    method: "post",
    url: "/userCargoowner/queryCoId",
    config: {},
  },

  //
  userCargoowneradd: {
    method: "post",
    url: "/userCargoowner/add",
    config: {},
  },

  // 提交注册码
  subRegCode: {
    method: "post",
    url: "/sysRegister/register",
    config: {},
  },

  // 文件管理查询
  queryFileList: {
    method: "post",
    url: "/psaccount/queryDetail",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询明细id下的文件列表
  queryFileListByIds: {
    method: "post",
    url: "/psaccount/queryDetailFile",
    config: {},
  },

  // 提交上传文件信息
  subFileInfo: {
    method: "post",
    url: "/psaccount/addDetailFile",
    config: {},
  },

  // 删除上传的文件
  delFile: {
    method: "post",
    url: "/psaccount/deleteDetailFile",
    config: {},
  },

  // 下载上传的文件
  downFile: {
    method: "post",
    url: "/psaccount/downDetailFile",
    config: {},
  },

  // 查询销售文件列表
  querySalesFileList: {
    method: "post",
    url: "/wobke/querywoappDetail",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 查询销售文件列表byId
  querySalesFileListByIds: {
    method: "post",
    url: "/wobke/queryWarehousingFile",
    config: {},
  },
  // 查询销售文件列表byId
  querylicenceFileListByIds: {
    method: "post",
    url: "/wobke/querylicenceFile",
    config: {},
  },

  // 下载销售文件压缩包
  downFilePackage: {
    method: "post",
    url: "/wobke/downFileZip",
    config: {},
  },
  // 修改密码
  updatePwd: {
    method: "post",
    url: "/Login/updpwd",
    config: {},
  },

  // 查询业务员包含的货主
  getPersonTime: {
    method: "post",
    url: "/Login/online",
    config: {
      noPassJur: true,
    },
  },

  //公告查询
  getQueryNotices: {
    method: "post",
    url: "/publicNotice/queryNotices",
    config: {},
  },
  //头部公告查询
  getQueryShowNotices: {
    method: "post",
    url: "/publicNotice/queryShowNotices",
    config: {},
  },
  // 添加公告
  publicNoticeAdd: {
    method: "post",
    url: "/publicNotice/add",
    config: {},
  },
  //修改公告
  publicNoticeUpdate: {
    method: "post",
    url: "/publicNotice/update",
    config: {},
  },
  // 删除公告
  publicNoticeDelete: {
    method: "post",
    url: "/publicNotice/delete",
    config: {},
  },

  // 获取凭证方案原始数据
  getVoucherRawData: {
    method: "post",
    url: "/voucher/queryVoucherPlanMasterData",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取所有凭证方案
  getVoucherPlan: {
    method: "post",
    url: "/voucher/queryVoucherPlan",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  // 获取凭证方案对应明细
  getDetailsByIds: {
    method: "post",
    url: "/voucher/queryBringVoucher",
    config: {},
  },

  // 调用T+接口 提交信息
  subVoucherInfo: {
    method: "post",
    url: "/voucher/setVoucher",
    config: {},
  },
  // 调用T+接口 内账管理
  subVoucherInfoTwo: {
    method: "post",
    url: "/voucher/setVoucherTwo",
    config: {},
  },
  // 凭证导出---异常回写
  voucherwriteVoucher: {
    method: "post",
    url: "/voucher/writeVoucher",
    config: {},
  },

  //采购收货冷链校验
  fromruleCheckPsColdChain: {
    method: "post",
    url: "/fromrule/checkPsColdChain",
    config: {},
  },

  // 养护规则修改
  updateMaintenanceRules: {
    method: "post",
    url: "/curingPlan/updatePeriod",
    config: {},
  },

  // 查询协同历史库存信息
  getCollOfficeHistoryStockInfo: {
    method: "post",
    url: "/stockStatistics/queryXtStockHistory",
    config: {},
  },

  // 根据单位id查询出单位的业务员
  queryByUnitByIds: {
    method: "post",
    url: "/counterpartySalesman/queryByUnit",
    config: {},
  },

  // 客户收货地址维护
  cusmasterAddressMaintain: {
    method: "post",
    url: "/cusmaster/addr_maintain",
    config: {},
  },

  // 查询质检报告
  queryQualityInspection: {
    method: "post",
    url: "/bgStock/queryQualityInspection",
    config: {},
  },

  // 获取菜单可配置项
  getJur: {
    method: "post",
    url: "/jurconfig/getJur",
    config: {},
  },
  // 活动管理-查询
  queryActivity: {
    method: "post",
    url: "/su/activity/query",
    config: {},
  },
  // 活动管理-新增/修改保存
  saveActivity: {
    method: "post",
    url: "/su/activity/save",
    config: {},
  },
  // 活动管理-删除
  delActivity: {
    method: "post",
    url: "/su/activity/del",
    config: {},
  },
  // 获取报表动态表单
  getUserReportPlanById: {
    method: "post",
    url: "/userReport/getUserReportPlanById",
    config: {},
  },
  // 获取报表动态表单
  addUserCustom: {
    method: "post",
    url: "/userReport/addUserCustom",
    config: {},
  },

  // 红冲 采购结算记账
  hongchong: {
    method: "post",
    url: "/psSettleAccount/rushRed",
    config: {},
  },

  // 销售订单集中文件管理
  queryWoapplyFile: {
    method: "post",
    url: "/woApply/queryWoapplyFile",
    config: {},
  },
  // 根据类型查询对应的销售订单集中文件
  queryWarehousingFileSales: {
    method: "post",
    url: "/woApply/queryWarehousingFile",
    config: {},
  },

  // 首营非首营供货商证照拦截11414
  checkVendorSupplier: {
    method: "post",
    url: "/fromrule/checkVendor",
    config: {},
  },
  // 校验首营供应商
  gspSuppliercheckRepeatSup: {
    method: "post",
    url: "/gspSupplier/checkRepeatSup",
    config: {},
  },

  // 首营非首营客户证照拦截11425
  checkVendorCustomer: {
    method: "post",
    url: "/fromrule/checkCustomer",
    config: {},
  },
  // 校验首营客户
  gspCustomercheckRepeatCus: {
    method: "post",
    url: "/gspCustomer/checkRepeatCus",
    config: {},
  },

  // 新增供应商银行信息
  addSupBankinfo: {
    method: "post",
    url: "/gspSupplier/addSupBankinfo",
    config: {},
  },
  // 修改供应商银行信息
  updateSupBankinfo: {
    method: "post",
    url: "/gspSupplier/updateSupBankinfo",
    config: {},
  },
  // 查询供应商银行信息
  querySupBankinfo: {
    method: "post",
    url: "/gspSupplier/querySupBankinfo",
    config: {},
  },
  // 删除供应商银行信息
  deleteSupBankinfo: {
    method: "post",
    url: "/gspSupplier/deleteSupBankinfo",
    config: {},
  },

  // 新增客户银行信息
  addCusBankinfo: {
    method: "post",
    url: "/gspCustomer/addCusBankinfo",
    config: {},
  },
  // 修改客户银行信息
  updateCusBankinfo: {
    method: "post",
    url: "/gspCustomer/updateCusBankinfo",
    config: {},
  },
  // 查询客户银行信息
  queryCusBankinfo: {
    method: "post",
    url: "/gspCustomer/queryCusBankinfo",
    config: {},
  },
  // 删除客户银行信息
  deleteCusBankinfo: {
    method: "post",
    url: "/gspCustomer/deleteCusBankinfo",
    config: {},
  },

  // 新增供应商地址信息
  addSupAddress: {
    method: "post",
    url: "/gspSupplier/addSupAddress",
    config: {},
  },
  // 修改供应商地址信息
  updateSupAddress: {
    method: "post",
    url: "/gspSupplier/updateSupAddress",
    config: {},
  },
  // 查询供应商地址信息
  querySupAddress: {
    method: "post",
    url: "/gspSupplier/querySupAddress",
    config: {},
  },
  // 删除供应商地址信息
  deleteSupAddress: {
    method: "post",
    url: "/gspSupplier/deleteSupAddress",
    config: {},
  },

  // 新增客户地址信息
  addCusAddress: {
    method: "post",
    url: "/gspCustomer/addCusAddress",
    config: {},
  },
  // 修改客户地址信息
  updateCusAddress: {
    method: "post",
    url: "/gspCustomer/updateCusAddress",
    config: {},
  },
  // 查询客户地址信息
  queryCusAddress: {
    method: "post",
    url: "/gspCustomer/queryCusAddress",
    config: {},
  },
  // 删除客户地址信息
  deleteCusAddress: {
    method: "post",
    url: "/gspCustomer/deleteCusAddress",
    config: {},
  },

  // 删除单号信息
  deleteBillNum: {
    method: "post",
    url: "/extract/deleteBillNum",
    config: {},
  },

  // 批量养护
  batchMaintenance: {
    method: "post",
    url: "/curingPlan/batchMaintenance",
    config: {},
  },

  // 车辆启用
  stopVehicle: {
    method: "post",
    url: "/Vehicle/stop",
    config: {},
  },

  // 获取所有不可见属性字典表
  invisibleDictList: {
    method: "post",
    url: "/invisible/dictList",
    config: {},
  },

  // 获取人员不可见属性
  invisibleOpminvisible: {
    method: "post",
    url: "/invisible/opminvisible",
    config: {},
  },

  // 保存人员不可见属性
  invisibleSaveOpminvisible: {
    method: "post",
    url: "/invisible/saveOpminvisible",
    config: {},
  },

  // 保存人员不可见属性
  addUserJur: {
    method: "post",
    url: "/jurconfig/addUserJur",
    config: {},
  },

  // 查询初始或驳回状态拒收记录
  returnRecordQueryInIt: {
    method: "post",
    url: "/returnRecord/queryInIt",
    config: {},
  },
  // 编辑拒收记录
  returnRecordQueryUpdate: {
    method: "post",
    url: "/returnRecord/update",
    config: {},
  },

  // 初始或驳回状态拒收记录提交审核
  returnRecordSubmitAudit: {
    method: "post",
    url: "/returnRecord/submitAudit",
    config: {},
  },
  // 查询初始或驳回状态拒收记录审核
  returnRecordQueryTask: {
    method: "post",
    url: "/returnRecord/queryTask",
    config: {},
  },
  // 查询初始或驳回状态拒收记录历史
  returnRecordQueryHis: {
    method: "post",
    url: "/returnRecord/queryHis",
    config: {},
  },
  // 采购与付款根据金额计算手续费
  feeDeduction: {
    method: "post",
    url: "/preApply/feeDeduction",
    config: {},
  },
  // 新增物流信息
  addLogistics: {
    method: "post",
    url: "/logistics/add",
    config: {},
  },

  // 修改物流信息
  updateLogistics: {
    method: "post",
    url: "/logistics/update",
    config: {},
  },

  // 删除物流信息
  deleteLogistics: {
    method: "post",
    url: "/logistics/delete",
    config: {},
  },

  // 查询物流信息
  queryLogistics: {
    method: "post",
    url: "/logistics/query",
    config: {},
  },

  // 查询发货计划
  shipPlanQuery: {
    method: "post",
    url: "/shipPlan/query",
    config: {},
  },

  // 修改发货计划
  shipPlanUpdate: {
    method: "post",
    url: "/shipPlan/update",
    config: {},
  },

  // 发货计划生成装车单
  shipPlanLoadingAdd: {
    method: "post",
    url: "/shipPlan/addLoading",
    config: {},
  },
  // 发货计划生成装车单
  addLogisticsLoading: {
    method: "post",
    url: "/shipPlan/addLogisticsLoading",
    config: {},
  },

  // 获取应付款 预付款
  shipPlanAddLoading: {
    method: "post",
    url: "/psSettleApply/getAccount",
    config: {},
  },
  // 新增应收冲抵应付
  addReceOffpay: {
    method: "post",
    url: "/receOffpay/add",
    config: {},
  },
  // 应收冲抵应付列表
  queryReceOffpayList: {
    method: "post",
    url: "/receOffpay/query",
    config: {},
  },
  // 应收冲抵应付列表
  redPushReceOffpay: {
    method: "post",
    url: "/receOffpay/redPush",
    config: {},
  },
  // 根据类型获取动态表单
  getFormByType: {
    method: "post",
    url: "/gspChange/getForm",
    config: {},
  },

  // 添加账簿
  addAccountbook: {
    method: "post",
    url: "/accountbook/add",
    config: {},
  },

  // 删除账簿
  deleteAccountbook: {
    method: "post",
    url: "/accountbook/delete",
    config: {},
  },

  // 查询账簿
  queryAccountbook: {
    method: "post",
    url: "/accountbook/query",
    config: {},
  },

  // 修改账簿
  updateAccountbook: {
    method: "post",
    url: "/accountbook/update",
    config: {},
  },

  // 追加保证金
  addCash: {
    method: "post",
    url: "/CargoOwner/addCash",
    config: {},
  },

  // 维护授信额度
  setCreditAccount: {
    method: "post",
    url: "CargoOwner/setCreditAccount",
    config: {},
  },
  // 维护提现授信额度
  setWithdrawCredit: {
    method: "post",
    url: "CargoOwner/setWithdrawCredit",
    config: {},
  },
  // 货主保证金流水
  queryCash: {
    method: "post",
    url: "/CargoOwner/queryCash",
    config: {},
  },

  // 财务收款查询
  queryFinancialCollect: {
    method: "post",
    url: "/woApply/querySubmit",
    config: {},
  },

  // 财务收款查询余额
  queryCoInvoice: {
    method: "post",
    url: "/woApply/queryCoInvoice",
    config: {},
  },

  // 财务收款确认收款
  invoiceAudit: {
    method: "post",
    url: "/woApply/invoiceAudit",
    config: {},
  },

  // 财务收款确认收款
  invoiceAudit: {
    method: "post",
    url: "/woApply/invoiceAudit",
    config: {},
  },

  // 查询预收款申请初始或驳回
  queryPreregApply: {
    method: "post",
    url: "/preregApply/queryInit",
    config: {},
  },

  // 添加预收款申请
  addPreregApply: {
    method: "post",
    url: "/preregApply/add",
    config: {},
  },

  // 修改预收款申请
  updatePreregApply: {
    method: "post",
    url: "/preregApply/update",
    config: {},
  },

  // 删除预收款申请
  deletePreregApply: {
    method: "post",
    url: "/preregApply/delete",
    config: {},
  },
  // 导入
  preregApplyuploadExcel: {
    method: "post",
    url: "/preregApply/uploadExcel",
    config: {},
  },

  // 提交预收款申请
  submitPreregApply: {
    method: "post",
    url: "/preregApply/submit",
    config: {},
  },

  // 预收款记账列表
  preregApplyQueryAudit: {
    method: "post",
    url: "/preregApply/queryAudit",
    config: {},
  },
  // 预收款批量记账
  preregisterbatchadd: {
    method: "post",
    url: "/preregister/batchadd",
    config: {},
  },
  // 查询预收款申请审核
  queryPreregApplyTask: {
    method: "post",
    url: "/preregApply/queryTask",
    config: {},
  },

  // 查询预收款申请审核
  queryPreregApplyHis: {
    method: "post",
    url: "/preregApply/queryHis",
    config: {},
  },

  // 添加费用登记
  addOwnerfree: {
    method: "post",
    url: "/ownerfree/add",
    config: {},
  },

  // 删除费用登记
  deleteOwnerfree: {
    method: "post",
    url: "ownerfree/delete",
    config: {},
  },

  // 查询费用登记
  queryOwnerfree: {
    method: "post",
    url: "ownerfree/query",
    config: {},
  },
  // 导入费用登记
  ownerfreeUpload: {
    method: "post",
    url: "ownerfree/upload",
    config: {},
  },
  //导入期初商品
  initUpload: {
    method: "post",
    url: "GSPgoods/exportinit",
    config: {},
  },
  //导入期初商品证照
  importUpload: {
    method: "post",
    url: "GSPgoods/exportLicence",
    config: {},
  },
  //导入期初商品（广迎）
  importGoodinit: {
    method: "post",
    url: "GSPgoods/importGoodinit",
    config: {},
  },
  //导入供应商
  importUploadGys: {
    method: "post",
    url: "gspSupplier/exportinit",
    config: {},
  },
  //导入供应商证照
  importUploadGyszz: {
    method: "post",
    url: "gspSupplier/exportSupLicence",
    config: {},
  },
  //导入客户
  importUploadkh: {
    method: "post",
    url: "gspCustomer/exportinit",
    config: {},
  },
  //导入客户证照
  importUploadkhzz: {
    method: "post",
    url: "gspCustomer/exportCusLicence",
    config: {},
  },
  //导入库存
  importUploadkc: {
    method: "post",
    url: "bgStock/exportStockInit",
    config: {},
  },
  //导入库存质检文件
  bgStockimportStockFile: {
    method: "post",
    url: "bgStock/importStockFile",
    config: {},
  },
  importUpQc: {
    method: "post",
    url: "klPuorder/upload",
    config: {},
  },
  importUpQcxs: {
    method: "post",
    url: "klSuorder/upload",
    config: {},
  },
  //导入委托书
  importUpWts: {
    method: "post",
    url: "counterpartySalesman/importLicence",
    config: {},
  },
  importUpGyszk: {
    method: "post",
    url: "currentReset/exportSupAccount",
    config: {},
  },
  importUpKhzk: {
    method: "post",
    url: "currentReset/exportCusAccount",
    config: {},
  },

  // 查询费用登记项目
  queryCate: {
    method: "post",
    url: "ownerfree/queryCate",
    config: {},
  },
  // 修改费用登记备注
  ownerfreeRemark: {
    method: "post",
    url: "/ownerfree/updateRemark",
    config: {},
  },

  // 批量修改物流信息
  updateLogisticsWl: {
    method: "post",
    url: "shipPlan/updateLogistics",
    config: {},
  },

  // 批量修改物流信息 (订单物流)
  updateLogisticsOrderWl: {
    method: "post",
    url: "logisticsOrder/updateLogistics",
    config: {},
  },
  // 批量修改
  updateColdData: {
    method: "post",
    url: "logisticsOrder/updateColdData",
    config: {},
  },

  // 查询订单物流列表
  queryLogisticsOrder: {
    method: "post",
    url: "logisticsOrder/query",
    config: {},
  },

  // 删除根据状态销售出库订单
  deleteByState: {
    method: "post",
    url: "woApply/deleteByState",
    config: {},
  },

  // 供应商业务员应付统计 查询
  salespaystatic: {
    method: "post",
    url: "castatic/salespaystatic",
    config: {},
  },
  // 供应商业务员应付统计 查询
  paystatic: {
    method: "post",
    url: "castatic/suppayMxstatic",
    config: {},
  },
  // 供应商业务员应付统计 查询
  receStatic: {
    method: "post",
    url: "castatic/cusreceMxstatic",
    config: {},
  },

  // 供应商应付统计 查询
  suppaystatic: {
    method: "post",
    url: "castatic/suppaystatic",
    config: {},
  },

  //  供货商货主应付统计 查询
  ownerpaystatic: {
    method: "post",
    url: "castatic/ownerpaystatic",
    config: {},
  },
  // 客户货主应付统计 查询
  supplyOwnerPaystatic: {
    method: "post",
    url: "castatic/supplyOwnerPaystatic",
    config: {},
  },
  // 货主应付统计 查询
  customerOwnerPaystatic: {
    method: "post",
    url: "castatic/customerOwnerPaystatic",
    config: {},
  },

  // 业务员应付统计 查询
  opmpaystatic: {
    method: "post",
    url: "castatic/opmpaystatic",
    config: {},
  },

  // 客户业务员应收统计 查询
  salesrecestatic: {
    method: "post",
    url: "castatic/salesrecestatic",
    config: {},
  },

  // 客户应收统计 查询
  cusrecestatic: {
    method: "post",
    url: "castatic/cusrecestatic",
    config: {},
  },
  // 客户应收汇总 查询
  cusreceSummery: {
    method: "post",
    url: "castatic/cusreceSummery",
    config: {},
  },

  // 货主应收统计 查询
  ownerrecestatic: {
    method: "post",
    url: "castatic/ownerrecestatic",
    config: {},
  },

  // 业务员应收统计 查询
  opmrecestatic: {
    method: "post",
    url: "castatic/opmrecestatic",
    config: {},
  },
  // 客户业务员应收款分析(发票) 查询
  salesrecestaticInvoice: {
    method: "post",
    url: "castatic/salesrecestaticInvoice",
    config: {},
  },

  // 查询货主未结算管理费用 查询
  queryManageList: {
    method: "post",
    url: "ownerfree/queryManageList",
    config: {},
  },

  // 查询货主未结算管理费用单据明细 查询
  queryManageListDetail: {
    method: "post",
    url: "ownerfree/queryManageListDetail",
    config: {},
  },

  // 货主管理费用结算
  manageSettle: {
    method: "post",
    url: "ownerfree/manageSettle",
    config: {},
  },

  // 新增帮助文档
  addHelpDocument: {
    method: "post",
    url: "helpDocument/add",
    config: {},
  },

  // 保存帮助文档
  saveOrUpdate: {
    method: "post",
    url: "helpDocument/saveOrUpdate ",
    config: {},
  },

  // 根据菜单ID获取帮助文档
  getDocumentData: {
    method: "post",
    url: "helpDocument/getDocumentData",
    config: {},
  },
  // 预付款回退
  preApplyGoBack: {
    method: "post",
    url: "preApply/goBack",
    config: {},
  },
  // 采购结算回退
  psSettleApplyGoBack: {
    method: "post",
    url: "psSettleApply/goBack",
    config: {},
  },
  // 检查预付款期限
  checkPaymentCreditPeriod: {
    method: "post",
    url: "psSettleApply/checkPaymentCreditPeriod",
    config: {},
  },
  //  预收款回退
  preregApplyGoBack: {
    method: "post",
    url: "preregApply/goBack",
    config: {},
  },
  //  预付款红冲
  rushRedRegister: {
    method: "post",
    url: "register/rushRed",
    config: {},
  },
  //  销售结算红冲
  rushRedSuSettleAccount: {
    method: "post",
    url: "suSettleAccount/rushRed",
    config: {},
  },
  //  预收款红冲
  rushRedPreregister: {
    method: "post",
    url: "preregister/rushRed",
    config: {},
  },
  //  获取最近的聊天记录
  getChatRecord: {
    method: "post",
    url: "getChatRecord",
    config: {},
  },
  //  获取人员列表
  getChatManage: {
    method: "post",
    url: "chatManage/query",
    config: {},
  },
  //  自主登记回执
  autonomousReceipt: {
    method: "post",
    url: "receipt/autonomousReceipt",
    config: {},
  },

  //  重置密码
  resetPassword: {
    method: "post",
    url: "Operator/resetPassword",
    config: {},
  },
  //  清除人员权限
  JurisdictionCleanOperJur: {
    method: "post",
    url: "Jurisdiction/cleanOperJur",
    config: {},
  },

  //  货主调拨 查询
  queryOwnertransfer: {
    method: "post",
    url: "ownertransfer/queryInit",
    config: {},
  },

  //  货主调拨 新增
  addOwnertransfer: {
    method: "post",
    url: "ownertransfer/add",
    config: {},
  },

  //  货主调拨 删除
  deleteOwnertransfer: {
    method: "post",
    url: "ownertransfer/delete",
    config: {},
  },

  //  货主调拨 修改
  updateOwnertransfer: {
    method: "post",
    url: "ownertransfer/update",
    config: {},
  },

  //  货主调拨 提交
  submitOwnertransfer: {
    method: "post",
    url: "ownertransfer/submit",
    config: {},
  },

  //  货主调拨 审核列表查询
  queryTaskOwnertransfer: {
    method: "post",
    url: "ownertransfer/queryTask",
    config: {},
  },

  //  货主调拨 历史列表查询
  queryHisOwnertransfer: {
    method: "post",
    url: "ownertransfer/queryHis",
    config: {},
  },

  //  查询货主费用登记类目
  ownerexPensecateOwnList: {
    method: "post",
    url: "ownerexPensecate/selectOwnList",
    config: {},
  },
  //  添加货主费用登记类目
  ownerexPensecateAdd: {
    method: "post",
    url: "ownerexPensecate/add",
    config: {},
  },
  //  修改货主费用登记类目
  ownerexPensecateUpdate: {
    method: "post",
    url: "ownerexPensecate/update",
    config: {},
  },
  //  删除货主费用登记类目
  ownerexPensecateDelete: {
    method: "post",
    url: "ownerexPensecate/delete",
    config: {},
  },
  //  查询系统设置
  settingSelect: {
    method: "post",
    url: "setting/select",
    config: {},
  },
  //  修改系统设置
  settingUpdate: {
    method: "post",
    url: "setting/update",
    config: {},
  },
  //  获取拦截规则列表
  getInterceptRoules: {
    method: "post",
    url: "fromrule/queryFormrulePage",
    config: {},
  },
  //  设置拦截规则列表
  setRoulesList: {
    method: "post",
    url: "fromrule/updateDesysFormrule",
    config: {},
  },
  //  新增货主银行信息
  addCobankinfo: {
    method: "post",
    url: "cobankinfo/add",
    config: {},
  },
  //  删除货主银行信息
  deleteCobankinfo: {
    method: "post",
    url: "cobankinfo/delete",
    config: {},
  },
  //  查询货主银行信息
  queryCobankinfo: {
    method: "post",
    url: "cobankinfo/query",
    config: {},
  },
  //  查询货主银行信息
  updateCobankinfo: {
    method: "post",
    url: "cobankinfo/update",
    config: {},
  },
  // 查询货主资金信息待审核
  queryTaskCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/queryTask",
    config: {},
  },
  // 审核货主资金提现信息
  setActualMoney: {
    method: "post",
    url: "cargoownerMoney/setActualMoney",
    config: {},
  },
  // 确认付款
  confirmPayment: {
    method: "post",
    url: "cargoownerMoney/confirmPayment",
    config: {},
  },
  // 新增货主资金信息
  addCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/add",
    config: {},
  },  
  // 修改货主资金信息
  updateCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/update",
    config: {},
  },
  //查询货主资金信息列表
  queryCargoownerMoney:{
      method: "post",
      url: "/cargoownerMoney/queryInit",
      config: {}
  },
  // 提交货主资金信息
  submitCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/submit",
    config: {},
  },
  // 删除货主资金信息
  deleteCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/delete",
    config: {},
  },

  // 查询销售流水
  runwaterQueryInit: {
    method: "post",
    url: "runwater/queryInit",
    config: {},
  },
  // 导入流水数据
  runwaterUpload: {
    method: "post",
    url: "runwater/upload",
    config: {
      "Content-Type": "multipart/form-data",
    },
  },
  // 删除流水数据
  runwaterDel: {
    method: "post",
    url: "runwater/delete",
    config: {},
  },
  // 提交导入的流水
  runwaterinsertList: {
    method: "post",
    url: "runwater/insertList",
    config: {},
  },

  // 查询货主认款提交状态
  ownerAcceptQueryAudit: {
    method: "post",
    url: "ownerAccept/queryAudit",
    config: {},
  },
  // 货主认款记账
  ownerAcceptAccount: {
    method: "post",
    url: "ownerAccept/account",
    config: {},
  },
  // 货主认款记账历史状态
  ownerAcceptHis: {
    method: "post",
    url: "ownerAccept/queryHis",
    config: {},
  },
  // 货主认款回退
  ownerAcceptCallback: {
    method: "post",
    url: "ownerAccept/callback",
    config: {},
  },
  // 货主认款红冲
  ownerAcceptRedbash: {
    method: "post",
    url: "ownerAccept/redbash",
    config: {},
  },
  // 流水合计
  runWaterMoney: {
    method: "post",
    url: "/runwater/runWaterMoney",
    config: {},
  },
  // 流水合计
  ownerAcceptHisMoeny: {
    method: "post",
    url: "ownerAccept/ownerAcceptHisMoeny",
    config: {},
  },
  // 查询费用票待审核信息
  feeticketTask: {
    method: "post",
    url: "feeticket/queryTask",
    config: {},
  },
  // 批量审核费用票
  feeticketApproval: {
    method: "post",
    url: "feeticket/approval",
    config: {},
  },
  // 费用票记账
  feeticketQueryBookkeeping: {
    method: "post",
    url: "feeticket/queryBookkeeping",
    config: {},
  },
  // 费用票记账
  feeticketBookkeeping: {
    method: "post",
    url: "feeticket/bookkeeping",
    config: {},
  },
  // 查询费用票历史
  feeticketHis: {
    method: "post",
    url: "feeticket/queryHis",
    config: {},
  },
  // 采购一步入库
  puOneWarehousingAdd: {
    method: "post",
    url: "pisplanorder/addPuOneWarehous",
    config: {},
  },
  // 采购一步入查询
  puOneWarehousingQuery: {
    method: "post",
    url: "pisplanorder/queryOneWarehousing",
    config: {},
  },
  // 采购一步入查询
  updateRunwater: {
    method: "post",
    url: "runwater/update",
    config: {},
  },
  // 新增销售流水
  runwaterAdd: {
    method: "post",
    url: "runwater/add",
    config: {},
  },
  // 预付款批量记账
  registerBatchBookkeeping: {
    method: "post",
    url: "register/batchBookkeeping",
    config: {},
  },
  // 查询财务费用票登记初始信息
  queryFinanceChargesTicket: {
    method: "post",
    url: "feeticket/queryFinanceChargesTicket",
    config: {},
  },
  // 生成计算
  generateCalculate: {
    method: "post",
    url: "feeticket/generateCalculate",
    config: {},
  },
  // 删除费用票
  deleteFeeticketgenerate: {
    method: "post",
    url: "feeticket/deleteFeeticketgenerate",
    config: {},
  },
  // 抵扣
  updateFeeticketgenerate: {
    method: "post",
    url: "feeticket/updateFeeticketgenerate",
    config: {},
  },
  // 批量余额抵扣抵扣
  feeticketBatchDeduction: {
    method: "post",
    url: "feeticket/batchDeduction",
    config: {},
  },

  // 查询认款结算信息
  queryAcceptsettlement: {
    method: "post",
    url: "acceptsettlement/query",
    config: {},
  },
  // 删除认款结算信息
  deleteAcceptsettlement: {
    method: "post",
    url: "acceptsettlement/delete",
    config: {},
  },
  // 新增认款结算信息
  addAcceptsettlement: {
    method: "post",
    url: "acceptsettlement/add",
    config: {},
  },
  // 查询货主认款初始状态
  ownerAcceptQueryInit: {
    method: "post",
    url: "ownerAccept/queryInit",
    config: {},
  },
  // 新增货主认款
  ownerAcceptAdd: {
    method: "post",
    url: "ownerAccept/add",
    config: {},
  },
  // 提交货主认款
  ownerAcceptSubmit: {
    method: "post",
    url: "ownerAccept/submit",
    config: {},
  },
  // 删除货主认款
  ownerAcceptDelete: {
    method: "post",
    url: "ownerAccept/delete",
    config: {},
  },
  // 查询费用票记录
  queryDeductionRecord: {
    method: "post",
    url: "feeticket/queryRecord",
    config: {},
  },
  // 新增证照变更
  addLicenceList: {
    method: "post",
    url: "licenceChange/add",
    config: {},
  },
  // 修改证照变更
  updateLicenceList: {
    method: "post",
    url: "licenceChange/update",
    config: {},
  },
  // 删除证照变更
  delLicenceList: {
    method: "post",
    url: "licenceChange/delete",
    config: {},
  },
  // 提交证照变更
  subLicenceList: {
    method: "post",
    url: "licenceChange/submit",
    config: {},
  },
  // 根据类型查询证照原信息
  queryLicenceChange: {
    method: "post",
    url: "licenceChange/queryLicence",
    config: {},
  },
  // 采购时间调整
  pisplanorderUpdateOderTime: {
    method: "post",
    url: "pisplanorder/updateOderTime",
    config: {},
  },
  // 采购退货时间调整
  pisplanorderupdateRgOderTime: {
    method: "post",
    url: "pisplanorder/updateRgOderTime",
    config: {},
  },
  // 销售退货时间调整
  woApplyupdateRgOderTime: {
    method: "post",
    url: "woApply/updateRgOderTime",
    config: {},
  },
  // 装车单时间调整
  woApplyupdateZcdTime: {
    method: "post",
    url: "woApply/updateZcdTime",
    config: {},
  },
  // 销售时间调整
  woApplyUpdateOderTime: {
    method: "post",
    url: "woApply/updateOderTime",
    config: {},
  },
  // 查询初始状态和驳回状态的证照变更
  queryLicenceList: {
    method: "post",
    url: "licenceChange/queryInit",
    config: {},
  },
  // 查询历史证照变更变更任务
  queryLicenceHis: {
    method: "post",
    url: "licenceChange/queryHis",
    config: {},
  },
  // 查询证照变更变更任务
  queryLicenceTask: {
    method: "post",
    url: "licenceChange/queryTask",
    config: {},
  },
  // 获取采购开票总开票金额信息
  psdocumentsGetAllMoney: {
    method: "post",
    url: "psdocuments/getAllMoney",
    config: {},
  },
  // 获取销售开票总开票金额信息
  sudocumentsGetAllMoney: {
    method: "post",
    url: "sudocuments/getAllMoney",
    config: {},
  },
  // 销售结算导出
  exportSuSettleData: {
    method: "post",
    url: "suSettleApply/exportSuSettleData",
    config: {},
  },
  // 资料变更穿透
  queryDetailByGchmId: {
    method: "post",
    url: "gspChange/queryDetailByGchmId",
    config: {},
  },
  // 确认验收查询
  acceptanceConfirmCheck: {
    method: "post",
    url: "acceptance/query",
    config: {},
  },
  // 确认验收
  acceptanceConfirm: {
    method: "post",
    url: "acceptance/chooseAcceptor",
    config: {},
  },
  // 查询付款记录
  queryRecordCargoownerMoney: {
    method: "post",
    url: "cargoownerMoney/queryRecord",
    config: {},
  },
  // 单位付款查询待审核
  queryTaskUnitPay: {
    method: "post",
    url: "unitPay/queryTask",
    config: {},
  },
  // 单位付款 确认付款
  confirmPayUnitPay: {
    method: "post",
    url: "unitPay/confirmPay",
    config: {},
  },
  // 单位付款 审核
  aduitUnitPay: {
    method: "post",
    url: "unitPay/aduit",
    config: {},
  },
  // 单位收付审核--回退
  unitPayback: {
    method: "post",
    url: "unitPay/back",
    config: {},
  },
  // 货主账款调拨新增
  addOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/add",
    config: {},
  },
  // 货主账款调拨删除
  deleteOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/delete",
    config: {},
  },
  // 货主账款调拨修改
  updateOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/update",
    config: {},
  },
  // 货主账款调拨提交
  submitOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/submit",
    config: {},
  },
  // 货主账款调拨查询
  queryOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/queryInit",
    config: {},
  },
  // 货主账款调拨审核查询
  queryTaskOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/queryTask",
    config: {},
  },
  // 货主账款调拨历史查询
  queryHisOwnermoneyChange: {
    method: "post",
    url: "ownermoneyChange/queryHis",
    config: {},
  },
  // 审核流程列表
  processList: {
    method: "post",
    url: "process/processList",
    config: {},
  },
  // 查询节点
  getappNode: {
    method: "post",
    url: "process/getappNode",
    config: {},
  },
  // 编辑审核流程
  updnode: {
    method: "post",
    url: "process/updnode",
    config: {},
  },

  // 查询所有人员
  queryOperator: {
    method: "post",
    url: "Operator/queryAllUser",
    config: {},
  },
  // 查询缓存中存在单号信息
  queryBillNum: {
    method: "post",
    url: "extract/queryBillNum",
    config: {},
  },
  // 删除单号信息
  deleteBillNum: {
    method: "post",
    url: "extract/deleteBillNum",
    config: {},
  },
  // 新增凭证配置信息
  addAccountInfo: {
    method: "post",
    url: "voucher/addConfig",
    config: {},
  },
  // 修改凭证配置信息
  updateAccountInfo: {
    method: "post",
    url: "voucher/updateConfig",
    config: {},
  },
  // 查询凭证方案配置信息
  getAccountInfo: {
    method: "post",
    url: "voucher/queryConfig",
    config: {},
  },
  // 删除凭证方案配置信息
  delAccountInfo: {
    method: "post",
    url: "voucher/deleteConfig",
    config: {},
  },
  // 新增凭证方案
  addVoucherPlan: {
    method: "post",
    url: "voucher/addVoucherPlan",
    config: {},
  },
  // 查询凭证方案
  getVoucherPlan: {
    method: "post",
    url: "voucher/queryVoucherPlan",
    config: {},
  },
  // 删除凭证方案
  delVoucherPlan: {
    method: "post",
    url: "voucher/deleteVoucherPlan",
    config: {},
  },
  // 修改凭证方案
  updateVoucherPlan: {
    method: "post",
    url: "voucher/updateVoucherPlan",
    config: {},
  },
  // 修改当前用户的订阅信息
  updateTaskreceiver: {
    method: "post",
    url: "desysTaskreceiver/updateTaskreceiver",
    config: {},
  },
  // 查询当前用户的订阅信息
  queryTaskreceiver: {
    method: "post",
    url: "desysTaskreceiver/queryTaskreceiver",
    config: {},
  },
  // 查询所有人员
  queryOperator: {
    method: "post",
    url: "Operator/query",
    config: {},
  },
  // 一键解除占用
  deleteAllBillNum: {
    method: "post",
    url: "extract/deleteAllBillNum",
    config: {},
  },
  queryStockOccupy: {
    method: "post",
    url: "bgStock/queryStockOccupy",
    config: {},
  },
  // 查询销售合同
  querysucontract: {
    method: "post",
    url: "sucontract/query",
    config: {},
  },
  // 查询销售合同审核列表
  queryTasksucontract: {
    method: "post",
    url: "sucontract/queryTask",
    config: {},
  },
  // 提交销售合同审核
  submitsucontract: {
    method: "post",
    url: "sucontract/submit",
    config: {},
  },
  // 销售合同-重新计算
  sucontractResetContractFinish: {
    method: "post",
    url: "sucontract/resetContractFinish",
    config: {},
  },
  // 查询记账单
  queryContractsign: {
    method: "post",
    url: "contractsign/query",
    config: {},
  },
  // 删除销售合同
  deletesucontract: {
    method: "post",
    url: "sucontract/delete",
    config: {},
  },
  // 新增销售合同
  addsucontract: {
    method: "post",
    url: "sucontract/add",
    config: {},
  },
  // 修改销售合同
  editsucontract: {
    method: "post",
    url: "sucontract/modifyContract",
    config: {},
  },
  //修改首营日期
  gspTimeUpdate: {
    method: "post",
    url: "/gsptime/add",
    config: {},
  },
  // 查询控销组商品
  controlruleQuery: {
    method: "post",
    url: "/controlrule/queryStock",
    config: {},
  },
  // 新增控销组
  controlruleAdd: {
    method: "post",
    url: "/controlrule/add",
    config: {},
  },
  // 删除控销组
  deleteControlGroup: {
    method: "post",
    url: "/controlrule/deleteControlGroup",
    config: {},
  },
  // 查询控销组
  controlruleControlrule: {
    method: "post",
    url: "/controlrule/queryControlrule",
    config: {},
  },
  // 删除控销组单位
  deleteControlUnit: {
    method: "post",
    url: "/controlrule/deleteControlUnit",
    config: {},
  },
  // 查询商品控销
  goodControlquery: {
    method: "post",
    url: "/goodControl/query",
    config: {},
  },
  // 删除商品控销
  goodControldelete: {
    method: "post",
    url: "/goodControl/delete",
    config: {},
  },
  // 新增商品控销
  goodControladd: {
    method: "post",
    url: "/goodControl/add",
    config: {},
  },
  // 修改商品控销
  goodControlupdate: {
    method: "post",
    url: "/goodControl/update",
    config: {},
  },
  //查询控销区域
  goodControlqueryControlAreaList: {
    method: "post",
    url: "/goodControl/queryControlAreaList",
    config: {},
  },
  //查询商品控销明细
  goodControldetailQuery: {
    method: "post",
    url: "/goodControl/detailQuery",
    config: {},
  },
  //查询GSP限销分类
  queryClassifyData: {
    method: "post",
    url: "/goodslimit/queryClassify",
    config: {},
  },
  //查询GSP限销商品明细
  queryClassifyDetailData: {
    method: "post",
    url: "/goodsunitlimit/query",
    config: {},
  },
  //查询限销倍数
  queryGoodsMultipleData: {
    method: "post",
    url: "/goodsmultiple/query",
    config: {},
  },
  //新增限销倍数
  addGoodsMultipleData: {
    method: "post",
    url: "/goodsmultiple/add",
    config: {},
  },
  //删除限销倍数
  delGoodsMultipleData: {
    method: "post",
    url: "/goodsmultiple/delete",
    config: {},
  },
  //新增GSP限销商品明细
  addqueryClassifyDetailData: {
    method: "post",
    url: "/goodslimit/addGoodsLimitDtail",
    config: {},
  },
  //删除GSP限销商品明细
  deletequeryClassifyDetailData: {
    method: "post",
    url: "/goodslimit/deleteGoodsLimitDtail",
    config: {},
  },
  //新增GSP限销分类
  addClassifyData: {
    method: "post",
    url: "/goodslimit/addClassify",
    config: {},
  },
  //新增GSP限销分类
  updateClassifyData: {
    method: "post",
    url: "/goodslimit/updateClassify",
    config: {},
  },
  //删除GSP限销分类
  deleteClassifyData: {
    method: "post",
    url: "/goodslimit/deleteClassify",
    config: {},
  },
  //新增限销
  addXianXiaoGoods: {
    method: "post",
    url: "/goodsunitlimit/add",
    config: {},
  },
  //限销明细查询
  goodsunitlimitqueryById: {
    method: "post",
    url: "/goodsunitlimit/queryById",
    config: {},
  },
  //删除限销
  delXianXiaoGoods: {
    method: "post",
    url: "/goodsunitlimit/delete",
    config: {},
  },
  //修改限销
  updateXianXiaoGoods: {
    method: "post",
    url: "/goodsunitlimit/update",
    config: {},
  },
  //添加阅读公告的阅读人
  addReaderPeople: {
    method: "post",
    url: "/publicNotice/addReader",
    config: {},
  },
  addCheckSuColdChain: {
    //销售退货收货页面接口
    method: "post",
    url: "/fromrule/checkSuColdChain",
    config: {},
  },
  updateKdnStatusUrl: {
    //快递鸟
    method: "post",
    url: "/shipPlan/updateKdnStatus",
    config: {},
  },
  updatewoapplysattorney: {
    //修改协同协同委托书
    method: "post",
    url: "/woapplysattorney/update",
    config: {},
  },

  deletewoapplysattorney: {
    //删除协同协同委托书
    method: "post",
    url: "/woapplysattorney/delete",
    config: {},
  },
  submitwoapplysattorney: {
    //删除协同协同委托书
    method: "post",
    url: "/woapplysattorney/submit",
    config: {},
  },
  addwoapplysattorney: {
    //新增协同协同委托书
    method: "post",
    url: "/woapplysattorney/add",
    config: {},
  },

  querywoapplysattorney: {
    //查询协同协同委托书
    method: "post",
    url: "/woapplysattorney/queryInit",
    config: {},
  },
  querytaskwoapplysattorney: {
    //查询提交协同委托书
    method: "post",
    url: "/woapplysattorney/queryTask",
    config: {},
  },
  queryHiswoapplysattorney: {
    //查询提交协同委托书历史
    method: "post",
    url: "/woapplysattorney/queryHis",
    config: {},
  },
  printKdnStatusUrl: {
    //打印电子面单
    method: "post",
    url: "/shipPlan/printTemplate",
    config: {},
  },
  addcontractsign: {
    //新增销售合同登记回执
    method: "post",
    url: "/contractsign/add",
    config: {},
  },
  updatecontractsign: {
    //修改销售合同登记回执
    method: "post",
    url: "/contractsign/update",
    config: {},
  },
  closePlan: {
    //快递鸟
    method: "post",
    url: "/shipPlan/closePlan",
    config: {},
  },
  resetSrm: {
    //重发SRM
    method: "post",
    url: "/shipPlan/resetSrm",
    config: {},
  },
  // 修改发货计划回单图片路径
  updateSfllpath: {
    method: "post",
    url: "/shipPlan/updateSfllpath",
    config: {},
  },
  flowtempAdd: {
    //出库流向临时报表管理(新增)
    method: "post",
    url: "/flowtemp/add",
    config: {},
  },
  flowtempUpdate: {
    //出库流向临时报表管理(编辑)
    method: "post",
    url: "/flowtemp/update",
    config: {},
  },
  flowtempGenerateRealData: {
    //出库流向临时报表管理(生成)
    method: "post",
    url: "/flowtemp/generateRealData",
    config: {},
  },
  counterpartySalesmanupdateLicenceStatus: {
    //对方业务员管理(修改状态)
    method: "post",
    url: "/counterpartySalesman/updateLicenceStatus",
    config: {},
  },
  orderpoolinvalid: {
    //外部订单池管理(删除外部订单)
    method: "post",
    url: "/orderpool/invalid",
    config: {},
  },
  orderpooldelete: {
    //外部订单池管理(删除外部订单)
    method: "post",
    url: "/orderpool/delete",
    config: {},
  },
  resetInit: {
    //重置外部订单池状态
    method: "post",
    url: "/orderpool/resetInit",
    config: {},
  },
  //集采平台订单（重置初始）
  jcResetInit: {
    //重置外部订单池状态
    method: "post",
    url: "/orderpool/jcResetInit",
    config: {},
  },
  resetRkm: {
    //重置上传入库码
    method: "post",
    url: "/orderpool/resetRkm",
    config: {},
  },
  resetOut: {
    //重置上传随货
    method: "post",
    url: "/orderpool/resetOut",
    config: {},
  },
  diffShip: {
    //华源重置
    method: "post",
    url: "/orderpool/diffShip",
    config: {},
  },
  resetHyState: {
    //华源重置
    method: "post",
    url: "/orderpool/resetHyState",
    config: {},
  },
  orderpoolBindUnit: {
    //外部订单池管理绑定客户
    method: "post",
    url: "/orderpool/bindUnit",
    config: {},
  },
  revokeReceiptReg: {
    //撤销回执登记
    method: "post",
    url: "/receipt/revokeReceipt",
    config: {},
  },

  getOwnerdeduc: {
    //查询货主扣费标准
    method: "post",
    url: "/ownerdeduc/querydeduction",
    config: {},
  },
  addOwnerdeduc: {
    //新增货主扣费标准
    method: "post",
    url: "/ownerdeduc/adddeductin",
    config: {},
  },
  upDateOwnerdeduc: {
    //修改货主扣费标准
    method: "post",
    url: "/ownerdeduc/updatedeductions",
    config: {},
  },
  delOwnerdeduc: {
    //删除货主扣费标准
    method: "post",
    url: "/ownerdeduc/deletedeductions",
    config: {},
  },
  retryGoods: {
    //重新传输商品
    method: "post",
    url: "/rabbit/retryGoods",
    config: {},
  },
  retrySup: {
    //重新传输供应商
    method: "post",
    url: "/rabbit/retrySup",
    config: {},
  },
  retryCus: {
    //重新传输客户
    method: "post",
    url: "/rabbit/retryCus",
    config: {},
  },
  retryParam: {
    //重新传输WMS
    method: "post",
    url: "/rabbit/retryParam",
    config: {},
  },
  interceptPuNumPsPrice: {
    //采购小数位数拦截
    method: "post",
    url: "/fromrule/checkPuNumPsPrice",
    config: {},
  },
  interceptSuNumPsPrice: {
    //销售小数位数拦截
    method: "post",
    url: "/fromrule/checkSuNumPsPrice",
    config: {},
  },
  puRateChangequeryPuRateChange: {
    //查询采购进项税率变更记录
    method: "post",
    url: "/puRateChange/queryPuRateChange",
    config: {},
  },
  puRateChangeaddPuRateChange: {
    //新增采购进项税率变更
    method: "post",
    url: "/puRateChange/addPuRateChange",
    config: {},
  },
  suRateChangequerySuRateChange: {
    //查询销售进项税率变更记录
    method: "post",
    url: "/suRateChange/querySuRateChange",
    config: {},
  },
  suRateChangeaddSuRateChange: {
    //新增销售进项税率变更
    method: "post",
    url: "/suRateChange/addSuRateChange",
    config: {},
  },
  getAllQueryCodeSetting: {
    //查询所有编号规则
    method: "post",
    url: "/codeSetting/queryCodeSetting",
    config: {},
  },
  addQueryCodeSetting: {
    //新增编号规则
    method: "post",
    url: "/codeSetting/add",
    config: {},
  },
  updateQueryCodeSetting: {
    //修改编号规则
    method: "post",
    url: "/codeSetting/update",
    config: {},
  },
  deleteQueryCodeSetting: {
    //删除编号规则
    method: "post",
    url: "/codeSetting/delete",
    config: {},
  },
  getQueryCodeClassify: {
    //获取编号分类
    method: "post",
    url: "/codeSetting/queryCodeClassify",
    config: {},
  },
  getQueryPlanrecover: {
    //查询凭证方案
    method: "post",
    url: "/planrecover/queryPlanrecover",
    config: {},
  },
  deleteQueryPlanrecover: {
    //删除凭证方案
    method: "post",
    url: "/planrecover/delete",
    config: {},
  },
  addQueryPlanrecover: {
    //新增凭证方案
    method: "post",
    url: "/planrecover/add",
    config: {},
  },
  updateQueryPlanrecover: {
    //修改凭证方案
    method: "post",
    url: "/planrecover/update",
    config: {},
  },
  getQueryVoucherPlanMasterData: {
    //修改凭证方案
    method: "post",
    url: "/planrecover/queryVoucherPlanMasterData",
    config: {},
  },
  recoverQueryVoucherPlanMasterData: {
    //恢复凭证方案
    method: "post",
    url: "/planrecover/recover",
    config: {},
  },
  addHighvalue: {
    //添加销售出库高值订单
    method: "post",
    url: "/highvalue/add",
    config: {},
  },
  updateHighvalue: {
    //修改销售出库高值订单
    method: "post",
    url: "/highvalue/modify",
    config: {},
  },
  getHighvalue: {
    //查询销售出库高值订单
    method: "post",
    url: "/highvalue/querySuHighvalue",
    config: {},
  },
  queryAftersale: {
    //查询销售出库高值订单列表
    method: "post",
    url: "/highvalue/queryAftersale",
    config: {},
  },
  delHighvalue: {
    //删除销售出库高值订单
    method: "post",
    url: "/highvalue/delete",
    config: {},
  },
  deleteAftersale: {
    //删除销售出库高值订单列表
    method: "post",
    url: "/highvalue/deleteAftersale",
    config: {},
  },
  highvaluesubmit: {
    //提交
    method: "post",
    url: "/highvalue/submit",
    config: {},
  },
  submitAftersale: {
    //提交销售出库高值订单列表
    method: "post",
    url: "/highvalue/submitAftersale",
    config: {},
  },
  addAftersaleHighvalue: {
    //添加售后单
    method: "post",
    url: "/highvalue/addAftersale",
    config: {},
  },
  highvaluequeryWoadId: {
    //查询明细ID
    method: "post",
    url: "/highvalue/queryWoadId",
    config: {},
  },
  highvaluequeryMoneyAccounting: {
    //费用结算查询
    method: "post",
    url: "/highvalue/queryMoneyAccounting",
    config: {},
  },
  highvalueaccountingExpenses: {
    //费用结算提交
    method: "post",
    url: "/highvalue/accountingExpenses",
    config: {},
  },
  highvaluequeryRecycle: {
    //回库查询列表
    method: "post",
    url: "/highvalue/queryRecycle",
    config: {},
  },
  highvaluequeryRecycleDetail: {
    //回库查询详情
    method: "post",
    url: "/highvalue/queryRecycleDetail",
    config: {},
  },
  highvaluerecycleAdd: {
    //回库新增
    method: "post",
    url: "/highvalue/recycleAdd",
    config: {},
  },
  highvaluerecycleUpdate: {
    //回库修改
    method: "post",
    url: "/highvalue/recycleUpdate",
    config: {},
  },
  highvaluerecycleDeleta: {
    //回库删除
    method: "post",
    url: "/highvalue/recycleDeleta",
    config: {},
  },
  highvaluerecycleSubmit: {
    //回库提交
    method: "post",
    url: "/highvalue/recycleSubmit",
    config: {},
  },
  productLock: {
    //
    method: "post",
    url: "/BusinessGood/productAboutLock",
    config: {},
  },
  queryUploadVo: {
    //
    method: "post",
    url: "/Operator/queryUploadVo",
    config: {},
  },
  directOrderAdd: {
    //直调新增
    method: "post",
    url: "/directOrder/order_add",
    config: {},
  },
  directOrderQuery: {
    //直调查询
    method: "post",
    url: "/directOrder/order_query",
    config: {},
  },
  opercreditQuery: {
    //查询业务员授信列表
    method: "post",
    url: "/opercredit/query",
    config: {},
  },
  opercreditAdd: {
    //新增业务员授信列表
    method: "post",
    url: "/opercredit/add",
    config: {},
  },
  opercreditUpdateTemp: {
    //修改业务员临时授信
    method: "post",
    url: "/opercredit/updateTemp",
    config: {},
  },
  opercreditUpdate: {
    //修改业务员授信列表
    method: "post",
    url: "/opercredit/update",
    config: {},
  },
  opercreditDelete: {
    //删除业务员授信列表
    method: "post",
    url: "/opercredit/delete",
    config: {},
  },
  addOrderAfterSaleDataApi: {
    //新增售后信息
    method: "post",
    url: "/woApply/addOrderAfterSaleData",
    config: {},
  },
  directOrderdelete: {
    //直调删除
    method: "post",
    url: "/directOrder/delete",
    config: {},
  },
  directOrderOrderUpdate: {
    //直调修改
    method: "post",
    url: "/directOrder/order_update",
    config: {},
  },
  directOrderOrderSubmit: {
    //直调提交
    method: "post",
    url: "/directOrder/order_submit",
    config: {},
  },
  drtchaOrderAdd: {
    //直调验收新增
    method: "post",
    url: "/drtcha/order_add",
    config: {},
  },
  drtchaQuery: {
    //直调验收查询
    method: "post",
    url: "/drtcha/drtcha_query",
    config: {},
  },
  drtchaUpdate: {
    //直调验收修改
    method: "post",
    url: "/drtcha/drtcha_update",
    config: {},
  },
  drtchadelete: {
    //直调验收删除
    method: "post",
    url: "/drtcha/delete",
    config: {},
  },
  drtchaDrtchaSubmit: {
    //直调验收提交
    method: "post",
    url: "/drtcha/drtcha_submit",
    config: {},
  },
  dgapplyQuery: {
    //直调退货查询
    method: "post",
    url: "/dgapply/dgapply_query",
    config: {},
  },
  dgapplyAdd: {
    //直调退货新增
    method: "post",
    url: "/dgapply/dgapply_add",
    config: {},
  },
  dgapplyUpdate: {
    //直调退货修改
    method: "post",
    url: "/dgapply/dgapply_update",
    config: {},
  },
  dgapplyDelete: {
    //直调退货删除
    method: "post",
    url: "/dgapply/delete",
    config: {},
  },
  dgapplySubmit: {
    //直调退货提交
    method: "post",
    url: "/dgapply/dgapply_submit",
    config: {},
  },
  dgchaQuery: {
    //直调退货验收查询
    method: "post",
    url: "/dgcha/dgacha_query",
    config: {},
  },
  dgchaAdd: {
    //直调退货验收新增
    method: "post",
    url: "/dgcha/dgacha_add",
    config: {},
  },
  dgchaUpdate: {
    //直调退货验收修改
    method: "post",
    url: "/dgcha/dgacha_update",
    config: {},
  },
  dgchaDelete: {
    //直调退货验收删除
    method: "post",
    url: "/dgcha/delete",
    config: {},
  },
  dgchaSubmit: {
    //直调退货验收提交
    method: "post",
    url: "/dgcha/dgacha_submit",
    config: {},
  },
  storeLocationAdd: {
    //库位列表新增
    method: "post",
    url: "/storeLocation/add",
    config: {},
  },
  storeLocationQuery: {
    //库位列表查询
    method: "post",
    url: "/storeLocation/query",
    config: {},
  },
  storeLocationimport: {
    //库位列表导入
    method: "post",
    url: "/storeLocation/import",
    config: {},
  },
  storeLocationModify: {
    //库位列表修改
    method: "post",
    url: "/storeLocation/modify",
    config: {},
  },
  storeLocationDelete: {
    //库位列表删除
    method: "post",
    url: "/storeLocation/delete",
    config: {},
  },
  storeLocationSwitch: {
    //库位列表库位状态修改
    method: "post",
    url: "/storeLocation/switch",
    config: {},
  },
  slAdjustListQuery: {
    //库位调整列表查询
    method: "post",
    url: "/sladjust/getSladjustList",
    config: {},
  },
  slAdjustListAdd: {
    //库位调整列表新增
    method: "post",
    url: "/sladjust/add",
    config: {},
  },
  slAdjustListUpdate: {
    //库位调整列表修改
    method: "post",
    url: "/sladjust/modifySlAdjust",
    config: {},
  },
  slAdjustListDelete: {
    //库位调整列表删除
    method: "post",
    url: "/sladjust/delete",
    config: {},
  },
  slAdjustListSubmitAudit: {
    //库位调整列表提交
    method: "post",
    url: "/sladjust/submitAudit",
    config: {},
  },
  orderpoolUpdateNumAdd: {
    //外部订单列表提交
    method: "post",
    url: "/orderpool/updateNum",
    config: {},
  },
  orderpooldeleteMx: {
    //外部订单列表提交
    method: "post",
    url: "/orderpool/deleteMx",
    config: {},
  },
  getQualifapplyQueryInit: {
    //查询上下游资质申请
    method: "post",
    url: "/qualifapply/queryInit",
    config: {},
  },
  qualifapplyAdd: {
    //新增上下游资质申请
    method: "post",
    url: "/qualifapply/add",
    config: {},
  },
  qualifapplyUpdate: {
    //修改上下游资质申请
    method: "post",
    url: "/qualifapply/update",
    config: {},
  },
  qualifapplyDelete: {
    //删除上下游资质申请
    method: "post",
    url: "/qualifapply/delete",
    config: {},
  },
  qualifapplySubmit: {
    //提交上下游资质申请
    method: "post",
    url: "/qualifapply/submit",
    config: {},
  },
  getQualifapplyQueryTask: {
    //查询上下游资质申请审核列表
    method: "post",
    url: "/qualifapply/queryTask",
    config: {},
  },
  qualifapplyAudit: {
    //提交上下游资质申请审核列表
    method: "post",
    url: "/qualifapply/audit",
    config: {},
  },
  qualifapplyQueryHis: {
    //提交上下游资质申请审核列表
    method: "post",
    url: "/qualifapply/queryHis",
    config: {},
  },
  qualifapplyCancel: {
    //作废上下游资质申请审核
    method: "post",
    url: "/qualifapply/cancel",
    config: {},
  },
  woapplySattorneyQueryMXInfo: {
    //查询协同协同委托书详细信息
    method: "post",
    url: "/woapplysattorney/queryInfo",
    config: {},
  },
  pisplanorderupdateDetailRowNum: {
    //采购订单历史调序
    method: "post",
    url: "/pisplanorder/updateDetailRowNum",
    config: {},
  },
  preregApplyqueryTaskCountMoney: {
    //收款申请审核
    method: "post",
    url: "/preregApply/queryTaskCountMoney",
    config: {},
  },
  preregApplyqueryHisCountMoney: {
    //收款申请历史
    method: "post",
    url: "/preregApply/queryHisCountMoney",
    config: {},
  },
  readRuleQueryInit: {
    //查询
    method: "post",
    url: "/readRule/queryInit",
    config: {},
  },
  runwaterImportWater: {
    //提交
    method: "post",
    url: "/runwater/importWater",
    config: {
      "Content-Type": "multipart/form-data",
    },
  },
  readRuleDelete: {
    //删除
    method: "post",
    url: "/readRule/delete",
    config: {},
  },
  readRuleUpdate: {
    //修改
    method: "post",
    url: "/readRule/update",
    config: {},
  },
  readRuleAdd: {
    //新增
    method: "post",
    url: "/readRule/add",
    config: {},
  },
  contractQueryDetail: {
    //查询采购合同明细
    method: "post",
    url: "/contract/queryDetail",
    config: {},
  },
  runwaterSubmitReadWater: {
    //查询采购合同明细
    method: "post",
    url: "/runwater/submitReadWater",
    config: {},
  },
  acceptsettlementQueryReturnRkRecordList: {
    //查询退款结算左
    method: "post",
    url: "/acceptsettlement/queryReturnRkRecordList",
    config: {},
  },
  acceptsettlementQueryPsaccountList: {
    //查询退款结算右
    method: "post",
    url: "/acceptsettlement/queryPsaccountList",
    config: {},
  },
  acceptsettlementQueryPsaccountDetailList: {
    //查询退款结算右,点击查询
    method: "post",
    url: "/acceptsettlement/queryPsaccountDetailList",
    config: {},
  },
  querySuaccountDetailList: {
    //查询退款结算右,点击查询
    method: "post",
    url: "/acceptsettlement/querySuaccountDetailList",
    config: {},
  },
  registerQueryWaitPre: {
    //查询退款结算右,点击查询
    method: "post",
    url: "register/queryWaitPre",
    config: {},
  },
  registerAddRerurnPreSettle: {
    //查询退款结算右,点击查询
    method: "post",
    url: "register/addRerurnPreSettle",
    config: {},
  },
  suRefundQueryInit: {
    //查询退款
    method: "post",
    url: "/suRefund/queryInit",
    config: {},
  },
  suRefundAdd: {
    //新增退款
    method: "post",
    url: "/suRefund/add",
    config: {},
  },
  returnGoodsAddOneAccount: {
    //新增销售退回申请一步记账
    method: "post",
    url: "/ReturnGoods/addOneAccount",
    config: {},
  },
  sucontractQueryDetail: {
    //查询销售合同详细信息
    method: "post",
    url: "/sucontract/queryDetail",
    config: {},
  },
  contractQueryDetailInfo: {
    //查询采购合同详细信息
    method: "post",
    url: "/contract/queryDetailInfo",
    config: {},
  },
  licenceChangeQueryDetail: {
    //查询证照变更详情
    method: "post",
    url: "/licenceChange/queryDetail",
    config: {},
  },
  suRefundModifyRefund: {
    //修改退款
    method: "post",
    url: "/suRefund/modifyRefund",
    config: {},
  },
  suRefundDelete: {
    //删除退款
    method: "post",
    url: "/suRefund/delete",
    config: {},
  },
  suRefundSubmit: {
    //提交退款
    method: "post",
    url: "/suRefund/submit",
    config: {},
  },
  suRefundQueryAudit: {
    //查询退款待审核
    method: "post",
    url: "/suRefund/queryAudit",
    config: {},
  },
  suRefundQueryHis: {
    //查询退款历史
    method: "post",
    url: "/suRefund/queryHis",
    config: {},
  },
  suRefundGoBack: {
    //退款历史，回退
    method: "post",
    url: "/suRefund/goBack",
    config: {},
  },
  suRefundQueryAccount: {
    //查询退款记账
    method: "post",
    url: "/suRefund/queryAccount",
    config: {},
  },
  suRefundBookAccount: {
    //批量   退款记账
    method: "post",
    url: "/suRefund/bookAccount",
    config: {},
  },
  suRefundQueryAccountHis: {
    //退款记账历史
    method: "post",
    url: "/suRefund/queryAccountHis",
    config: {},
  },
  egisterQueryWaitPre: {
    //预付订单匹配---左
    method: "post",
    url: "/register/queryWaitPre",
    config: {},
  },
  preOrderNormalQueryWaitPisorder: {
    //预付订单匹配---右
    method: "post",
    url: "/preOrderNormal/queryWaitPisorder",
    config: {},
  },
  preOrderNormalQueryPisOrderDetail: {
    //预付订单匹配---右--查明细
    method: "post",
    url: "/preOrderNormal/queryPisOrderDetail",
    config: {},
  },
  preOrderNormalAddPreOrderNormal: {
    //预付订单匹配---右--保存
    method: "post",
    url: "/preOrderNormal/addPreOrderNormal",
    config: {},
  },
  psdocumentsQueryAuthentication: {
    //查询采购发票认证信息
    method: "post",
    url: "/psdocuments/queryAuthentication",
    config: {},
  },
  // 采购发票审核认证
  psdocumentAuth: {
    method: "post",
    url: "/psdocuments/auth",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceGetPusendList: {
    //获取采购的UDI记录
    method: "post",
    url: "/udiTrace/getPusendList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceGetSusendList: {
    //获取销售的UDI记录
    method: "post",
    url: "/udiTrace/getSusendList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceGetStocksendList: {
    //获取库存的UDI记录
    method: "post",
    url: "/udiTrace/getStocksendList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceUpdPusend: {
    //采购确定上传
    method: "post",
    url: "/udiTrace/updPusend",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceUpdStocksend: {
    //库存确定上传
    method: "post",
    url: "/udiTrace/updStocksend",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceUpdSusend: {
    //销售确定上传
    method: "post",
    url: "/udiTrace/updSusend",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceQueryUdiFile: {
    //查询udi
    method: "post",
    url: "/udiTrace/queryUdiFile",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceGetUdiData: {
    //udi上传
    method: "post",
    url: "udiTrace/getUdiData",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  udiTraceUpdUdidata: {
    //udi保存
    method: "post",
    url: "udiTrace/updUdidata",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  gspChangeChangeInfo: {
    //资料变更记录报表
    method: "post",
    url: "gspChange/changeInfo",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  suRefundRedRush: {
    //客户退款红冲
    method: "post",
    url: "/suRefund/redRush",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  suRefundAddRefundSettle: {
    //新增客户退款结算
    method: "post",
    url: "/suRefund/addRefundSettle",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },

  suRefundQueryRefundSettle: {
    //客户退款结算--左
    method: "post",
    url: "/suRefund/queryRefundSettle",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  suRefundQuerySusettle: {
    //客户退款结算--右边-*--货款
    method: "post",
    url: "/suRefund/querySusettle",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  suRefundQueryRkRecordList: {
    //客户退款结算--右边-*--认款
    method: "post",
    url: "/suRefund/queryRkRecordList",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  fromruleCheckSuDismode: {
    //   销售订单配送方式拦截
    method: "post",
    url: "/fromrule/checkSuDismode",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  runwaterQueryHis: {
    //回款历史查询
    method: "post",
    url: "/runwater/queryHis",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  bgStockReleaseAbnormal: {
    //系统设置/解除异常占用
    method: "post",
    url: "/bgStock/releaseAbnormal",
    config: {
      headers: {
        jurId: sessionStorage.getItem("printJurId"),
      },
    },
  },
  sucontractQueryFtDetail: {
    //销售合同提取商品分摊批号展示
    method: "post",
    url: "/sucontract/queryFtDetail",
    config: {},
  },
  fromruleCheckSalsesFile: {
    //对方业务员上传证照拦截
    method: "post",
    url: "/fromrule/checkSalsesFile",
    config: {},
  },
  //预付匹配记录删除
  preOrderNormalDeletePreOrderNormal: {
    //
    method: "post",
    url: "/preOrderNormal/deletePreOrderNormal",
    config: {},
  },
  //查询预付匹配记录
  preOrderNormalQueryPreOrderNormal: {
    //
    method: "post",
    url: "/preOrderNormal/queryPreOrderNormal",
    config: {},
  },
  //查询预付匹配记录明细
  preOrderNormalQueryNormaldetail: {
    //
    method: "post",
    url: "/preOrderNormal/queryNormaldetail",
    config: {},
  },
  //权限排序
  JurisdictionUpdateSort: {
    //
    method: "post",
    url: "/Jurisdiction/updateSort",
    config: {},
  },
  //查询批次价格策略
  batchPriceQueryLotPrice: {
    //
    method: "post",
    url: "/batchPrice/queryLotPrice",
    config: {},
  },
  //新增批次价格策略
  batchPriceUpdateLotPrice: {
    //
    method: "post",
    url: "/batchPrice/updateLotPrice",
    config: {},
  },
  //删除批次价格策略
  batchPriceDeleteLotPrice: {
    //
    method: "post",
    url: "/batchPrice/deleteLotPrice",
    config: {},
  },
  //动态表头
  batchPriceQueryPriceLevensList: {
    //
    method: "post",
    url: "/price/queryPriceLevensList",
    config: {},
  },
  // 查询器械
  basicinstrumentQuery: {
    //
    method: "post",
    url: "/basicinstrument/query",
    config: {},
  },
  // 获取器械基础包装
  basicinstrumentGetPack: {
    //
    method: "post",
    url: "/basicinstrument/getPack",
    config: {},
  },

  // 获取修改商品字段动态配置
  fromruleQueryRuleByName: {
    //
    method: "post",
    url: "/fromrule/queryRuleByName",
    config: {},
  },
  // 重置自定义设计
  jurconfigClearUserJur: {
    //
    method: "post",
    url: "/jurconfig/clearUserJur",
    config: {},
  },

  // 保存近效期记录
  nearExpireAdd: {
    //
    method: "post",
    url: "/nearExpire/add",
    config: {},
  },
  // 查询近效期记录
  nearExpireQuery: {
    //
    method: "post",
    url: "/nearExpire/query",
    config: {},
  },
  // 开票申请记录-回退
  sudrawbillreback: {
    //
    method: "post",
    url: "/sudrawbill/reback",
    config: {},
  },
  // 开票申请记录-回写发票号
  sudrawbillwriteBillnum: {
    //
    method: "post",
    url: "/sudrawbill/writeBillnum",
    config: {},
  },

  // 有效期验证
  pschacheckProdit: {
    //
    method: "post",
    url: "/pscha/checkProdit",
    config: {},
  },

  //---------------------------------------------------
  userStqueryUserNoExistSt: {
    //获取用户没绑定的库房信息
    method: "post",
    url: "/userSt/queryUserNoExistSt",
    config: {},
  },
  userStqueryUserExistSt: {
    //获取用户绑定的库房信息
    method: "post",
    url: "/userSt/queryUserExistSt",
    config: {},
  },
  userStadd: {
    //添加或删除绑定库房
    method: "post",
    url: "/userSt/add",
    config: {},
  },
  //---------------------------------------------------
  //查询调拨入库列表
  allotinQueryList: {
    method: "post",
    url: "/allotin/queryList",
    config: {},
  },
  //查询调拨入库明细
  allotinQueryDetail: {
    method: "post",
    url: "/allotin/queryDetail",
    config: {},
  },
  //新增调拨入库
  allotinAdd: {
    method: "post",
    url: "/allotin/add",
    config: {},
  },
  //修改调拨入库
  allotinUpdate: {
    method: "post",
    url: "/allotin/update",
    config: {},
  },
  //删除调拨入库
  allotinDelete: {
    method: "post",
    url: "/allotin/delete",
    config: {},
  },
  //提交调拨入库
  allotinSubmit: {
    method: "post",
    url: "/allotin/submit",
    config: {},
  },
  //拦截是否存在供应商信息
  allotinQuerySup: {
    method: "post",
    url: "/allotin/querySup",
    config: {},
  },
  //复制首营商品
  allotinCopyGspGood: {
    method: "post",
    url: "/allotin/copyGspGood",
    config: {},
  },
  //查询调拨入库待审核信息
  allotinQueryTask: {
    method: "post",
    url: "/allotin/queryTask",
    config: {},
  },
  //查询调拨入库历史信息
  allotinQueryHis: {
    method: "post",
    url: "/allotin/queryHis",
    config: {},
  },

  //查询商品维护库房院内编码列表
  hospitalcodeQuery: {
    method: "post",
    url: "/hospitalcode/query",
    config: {},
  },
  //新增商品维护库房院内编码列表
  hospitalcodeAdd: {
    method: "post",
    url: "/hospitalcode/add",
    config: {},
  },
  //修改商品维护库房院内编码列表
  hospitalcodeUpdate: {
    method: "post",
    url: "/hospitalcode/update",
    config: {},
  },
  //删除商品维护库房院内编码列表
  hospitalcodeDelete: {
    method: "post",
    url: "/hospitalcode/delete",
    config: {},
  },
  //导入商品维护库房院内编码列表
  hospitalcodeImport: {
    method: "post",
    url: "/hospitalcode/import",
    config: {},
  },
  //-------------------
  //渠道查询列表
  channelInfoQueryList: {
    method: "post",
    url: "/channelInfo/queryList",
    config: {},
  },
  //新增渠道
  channelInfoAdd: {
    method: "post",
    url: "/channelInfo/add",
    config: {},
  },
  //修改渠道
  channelInfoUpdate: {
    method: "post",
    url: "/channelInfo/update",
    config: {},
  },
  //删除渠道
  channelInfoDelete: {
    method: "post",
    url: "/channelInfo/delete",
    config: {},
  },
  //货主报销审核
  ownerReimasterQueryTask: {
    method: "post",
    url: "/ownerReimaster/queryTask",
    config: {},
  },
  //查询货主报销申请历史
  ownerReimasterQueryHis: {
    method: "post",
    url: "/ownerReimaster/queryHis",
    config: {},
  },
  //查询单个货主报销申请明细
  ownerReimasterQueryDetail: {
    method: "post",
    url: "/ownerReimaster/queryDetail",
    config: {},
  },
  //---------------------------------单位调账
  //查询单位调账
  unitReconqueryList: {
    method: "post",
    url: "/unitRecon/queryList",
    config: {},
  },
  //新增单位调账
  addUnitRecon: {
    method: "post",
    url: "/unitRecon/addUnitRecon",
    config: {},
  },
  // 下载质检报告
  // queryQualityInspection: {
  // 	method: 'post',
  // 	url: '/bgStock/downInspectionFileZip',
  // 	config: {}
  // },
  //----------------------
  //上传物流归结
  logisticsOrderuplodRoutemapImg: {
    method: "post",
    url: "/logisticsOrder/uplodRoutemapImg",
    config: {},
  },
  //采购-结算历史
  registerIgnoreSeele: {
    method: "post",
    url: "/register/ignoreSeele",
    config: {},
  },
  //财务-认款历史
  ownerAcceptIgnoreSettle: {
    method: "post",
    url: "/ownerAccept/ignoreSettle",
    config: {},
  },
  //修改物流查询明细
  logisticsOrderqueryDetail: {
    method: "post",
    url: "/logisticsOrder/queryDetail",
    config: {},
  },
  //供应商对账
  finanicalRecongetSupFinanica: {
    method: "post",
    url: "/finanicalRecon/getSupFinanica",
    config: {},
  },
  //财务对账新增
  finanicalReconaddFinanical: {
    method: "post",
    url: "/finanicalRecon/addFinanical",
    config: {},
  },
  //客户财务对账
  finanicalRecongetCusFinanica: {
    method: "post",
    url: "/finanicalRecon/getCusFinanica",
    config: {},
  },
  //客户财务对账
  finanicalRecongetFinanicaRecord: {
    method: "post",
    url: "/finanicalRecon/getFinanicaRecord",
    config: {},
  },
  //财务对账-删除
  finanicalReconDelFinanical: {
    method: "post",
    url: "/finanicalRecon/delFinanical",
    config: {},
  },
  //完善售后信息修改
  highvalueupdateAftersale: {
    method: "post",
    url: "/highvalue/updateAftersale",
    config: {},
  },
  //配置证照号赋默认值规则
  getLicenceNumberRule: {
    method: "post",
    url: "/GSPgoods/getLicenceNumberRule",
    config: {},
  },
  // 导入采购商品详情
  exportPisDetail: {
    method: "post",
    url: "pisplanorder/exportPisDetail",
    config: {},
  },
  // 一步导入采购商品详情
  exportStepPisDetail: {
    method: "post",
    url: "pisplanorder/exportStepPisDetail",
    config: {},
  },
  exportSuDetail: {
    method: "post",
    url: "woApply/exportSuDetail",
    config: {},
  },
   terminalCompanyPriceimport: {
    method: "post",
    url: "terminalCompanyPrice/import",
    config: {},
  },
  orderpoolimportOrderPoolExcel: {
    method: "post",
    url: "orderpool/importOrderPoolExcel",
    config: {},
  },

  pwoapplyexportSuDetail: {
    method: "post",
    url: "pwoapply/exportSuDetail",
    config: {},
  },
  checkPassComPlex: {
    method: "post",
    url: "Login/checkPassComPlex",
    config: {},
  },

  // 文件上传
  uploadFile: {
    method: "post",
    url: "/upload/fileupload",
    config: {},
  },
  // 文件上传（新）---发票上传专用
  uploadimgUploadPath: {
    method: "post",
    url: "/upload/imgUploadPath",
    config: {},
  },
  //上传凭证
  suSettleAccountuploadImg: {
    method: "post",
    url: "suSettleAccount/uploadImg",
    config: {},
  },
  //----------------------------------------------------------------------------------
  //维护商品的UDI解码自定义规则
  addGoodUDIrule: {
    method: "post",
    url: "pscha/addGoodUDIrule",
    config: {},
  },
  //查询商品的UDI解码自定义规则
  queryGoodUDIrule: {
    method: "post",
    url: "pscha/queryGoodUDIrule",
    config: {},
  },
  //维护商品的多DI码
  addGoodDi: {
    method: "post",
    url: "pscha/addGoodDi",
    config: {},
  },
  //查询商品的多DI码
  queryGoodDi: {
    method: "post",
    url: "pscha/queryGoodDi",
    config: {},
  },
  //新增UDI入库记录
  addUDIputin: {
    method: "post",
    url: "pscha/addUDIputin",
    config: {},
  },
  //查询UDI入库记录
  queryUdiPutin: {
    method: "post",
    url: "pscha/queryUdiPutin",
    config: {},
  },
  //查询验收通过的列表--不包括上架单据
  waitPriceVerify: {
    method: "post",
    url: "pscha/waitPriceVerify",
    config: {},
  },
  //查询验收详细信息
  pschaqueryById: {
    method: "post",
    url: "pscha/queryById",
    config: {},
  },
  //采购订单核价
  pschapriceVerify: {
    method: "post",
    url: "pscha/priceVerify",
    config: {},
  },
  //采购订单核价--返回上一步
  deleteVerifymaster: {
    method: "post",
    url: "pscha/deleteVerifymaster",
    config: {},
  },
  //查询UDI入库记录
  ftUdiStock: {
    method: "post",
    url: "woApply/ftUdiStock",
    config: {},
  },
  //--------
  //清除数据
  clearBasicData: {
    method: "post",
    url: "/sys/clearBasicData",
    config: {},
  },
  //获取商品默认库房拦截规则
  getGoodStRule: {
    method: "post",
    url: "/GSPgoods/getGoodStRule",
    config: {},
  },
  //---------------
  //查询待开票列表
  notInvoicedList: {
    method: "post",
    url: "/applyInvoicing/notInvoicedList",
    config: {},
  },
  //查询当前单据明细
  sudoDetail: {
    method: "post",
    url: "/applyInvoicing/sudoDetail",
    config: {},
  },
  //新增开票申请
  addApply: {
    method: "post",
    url: "/applyInvoicing/addApply",
    config: {},
  },
  //获取二维码
  applyInvoicingqRCode: {
    method: "post",
    url: "/applyInvoicing/qRCode",
    config: {},
  },
  //退货红冲
  returnRedChong: {
    method: "post",
    url: "/applyInvoicing/returnRed",
    config: {},
  },
  //退补红冲
  returnRrRed: {
    method: "post",
    url: "/applyInvoicing/rrRed",
    config: {},
  },
  //获取短信验证码
  smsVerifyCode: {
    method: "post",
    url: "/applyInvoicing/smsVerifyCode",
    config: {},
  },
  //验证短信验证码
  verifySmsCode: {
    method: "post",
    url: "/applyInvoicing/verifySmsCode",
    config: {},
  },
  //验证是否人脸识别
  applyInvoicingGetFaceState: {
    method: "post",
    url: "/applyInvoicing/getFaceState",
    config: {},
  },
  //获取申请结果
  queryApplyList: {
    method: "post",
    url: "/applyInvoicing/queryApplyList",
    config: {},
  },
  //获取申请结果明细
  queryApplyDetailList: {
    method: "post",
    url: "/applyInvoicing/queryApplyDetailList",
    config: {},
  },
  //红冲发票
  redChong: {
    method: "post",
    url: "/applyInvoicing/redChong",
    config: {},
  },
  //是否需要人脸识别
  faceAuthState: {
    method: "post",
    url: "/applyInvoicing/faceAuthState",
    config: {},
  },
  //再次推送
  repush: {
    method: "post",
    url: "/applyInvoicing/repush",
    config: {},
  },
  //开票结果修改优惠方式
  updatePush: {
    method: "post",
    url: "/applyInvoicing/updatePush",
    config: {},
  },
  //查询当前组织信息(开票申请使用)
  getInvoiceInfo: {
    method: "post",
    url: "/Organization/getInvoiceInfo",
    config: {},
  },
  //修改当前组织信息(开票申请使用)
  OrganizationModify: {
    method: "post",
    url: "/Organization/modify",
    config: {},
  },
  //回退开票申请
  backInvoiced: {
    method: "post",
    url: "/applyInvoicing/backInvoiced",
    config: {},
  },
  //----------------------------销售计划------------------------
  //销售计划列表查询
  suwoplanQeuryList: {
    method: "post",
    url: "/suwoplan/qeuryList",
    config: {},
  },
  //销售计划详情查询
  suwoplanQueryDetailInfo: {
    method: "post",
    url: "/suwoplan/queryDetailInfo",
    config: {},
  },

  //查询期初出库 入库记录  0.采购1.销售
  returnPoolQuery: {
    method: "post",
    url: "/returnPool/query",
    config: {},
  },
  //期初入库记录 提交
  returnPoolPuOrder: {
    method: "post",
    url: "/returnPool/puOrder",
    config: {},
  },
  //查询期初出库记录 提交
  returnPoolQcsuOrder: {
    method: "post",
    url: "/returnPool/qcsuOrder",
    config: {},
  },
  //查询期初出库 入库记录详情
  returnPoolQueryDetailById: {
    method: "post",
    url: "/returnPool/queryDetailByid",
    config: {},
  },
  //绑定商品
  suwoplanbindBgmSpd: {
    method: "post",
    url: "/suwoplan/bindBgmSpd",
    config: {},
  },
  //销售计划列表删除
  suwoplanDelPlan: {
    method: "post",
    url: "/suwoplan/delPlan",
    config: {},
  },
  //销售计划列表新增
  suwoplanAddPlan: {
    method: "post",
    url: "/suwoplan/addPlan",
    config: {},
  },
  //销售计划列表修改
  suwoplanUpdPlan: {
    method: "post",
    url: "/suwoplan/updPlan",
    config: {},
  },
  //销售计划列表提交审核
  suwoplanSubmit: {
    method: "post",
    url: "/suwoplan/submit",
    config: {},
  },
  //销售计划待审核列表
  suwoplanQueryTask: {
    method: "post",
    url: "/suwoplan/queryTask",
    config: {},
  },
  //销售计划历史列表
  suwoplanQueryHis: {
    method: "post",
    url: "/suwoplan/queryHis",
    config: {},
  },
  //----------------国药取消订单
  //国药取消订单页面查询
  gyxnCancelquery: {
    method: "post",
    url: "/gyxnCancel/query",
    config: {},
  },
  //国药取消订单页面新增
  gyxnCanceladd: {
    method: "post",
    url: "/gyxnCancel/add",
    config: {},
  },
  //----------------------------自定义审批流程
  //查询自定义审核流程
  queryDeinition: {
    method: "post",
    url: "/flowDeinit/queryDeinition",
    config: {},
  },
  //查询自定义审核流程
  queryDeinitnode: {
    method: "post",
    url: "/flowDeinit/queryDeinitnode",
    config: {},
  },
  //编辑自定义审核流程
  updDeinitnode: {
    method: "post",
    url: "/flowDeinit/updDeinitnode",
    config: {},
  },
  //新增审核流程实例
  flowInstanceAdd: {
    method: "post",
    url: "/flowInstance/add",
    config: {},
  },
  //查询待我审核实例任务
  flowInstancequeryTask: {
    method: "post",
    url: "/flowInstance/queryTask",
    config: {},
  },
  //查询实例的详细信息
  flowInstancequeryInfo: {
    method: "post",
    url: "/flowInstance/queryInfo",
    config: {},
  },
  //审核
  flowInstanceaudit: {
    method: "post",
    url: "/flowInstance/audit",
    config: {},
  },
  //查询审核实例历史
  flowInstancequeryHis: {
    method: "post",
    url: "/flowInstance/queryHis",
    config: {},
  },
  //查询审核历史节点
  flowInstanceauditHis: {
    method: "post",
    url: "/flowInstance/auditHis",
    config: {},
  },
  //查询待我提交的
  flowInstancequerySubmit: {
    method: "post",
    url: "/flowInstance/querySubmit",
    config: {},
  },
  //修改审核流程实例
  flowInstanceupdate: {
    method: "post",
    url: "/flowInstance/update",
    config: {},
  },
  //查询自定义审批流程根据id
  flowDeinitqueryDeinitionById: {
    method: "post",
    url: "/flowDeinit/queryDeinitionById",
    config: {},
  },
  //提交养护计划
  submitCuringPlan: {
    method: "post",
    url: "/curingPlan/submitCuringPlan",
    config: {},
  },
  //查询养护计划审核任务
  curingPlanQueryTask: {
    method: "post",
    url: "/curingPlan/queryTask",
    config: {},
  },
  //查询本人待审核订单列表
  orderQueryTask: {
    method: "post",
    url: "/directOrder/orderQueryTask",
    config: {},
  },
  //查询召回通知单列表
  queryNoticeInit: {
    method: "post",
    url: "/rcn/queryNoticeInit",
    config: {},
  },
  //查询召回通知单任务列表
  queryNoticeTask: {
    method: "post",
    url: "/rcn/queryNoticeTask",
    config: {},
  },
  //添加召回通知单
  addNotice: {
    method: "post",
    url: "/rcn/addNotice",
    config: {},
  },
  //更新召回通知单
  updateNotice: {
    method: "post",
    url: "/rcn/updateNotice",
    config: {},
  },
  //删除召回通知单
  delNotice: {
    method: "post",
    url: "/rcn/delNotice",
    config: {},
  },
  //提交召回通知单
  submitNotice: {
    method: "post",
    url: "/rcn/submitNotice",
    config: {},
  },
  //查询召回分发列表
  queryHandOut: {
    method: "post",
    url: "/rcn/queryHandOut",
    config: {},
  },
  //添加召回分发
  addHandOut: {
    method: "post",
    url: "/rcn/addHandOut",
    config: {},
  },
  //更新召回分发
  updateHandOut: {
    method: "post",
    url: "/rcn/updateHandOut",
    config: {},
  },
  //删除召回分发
  delHandOut: {
    method: "post",
    url: "/rcn/delHandOut",
    config: {},
  },
  //提交召回分发
  submitHandOut: {
    method: "post",
    url: "/rcn/submitHandOut",
    config: {},
  },
  //查询召回登记列表
  queryCheck: {
    method: "post",
    url: "/rcn/queryCheck",
    config: {},
  },
  //添加召回登记
  addCheck: {
    method: "post",
    url: "/rcn/addCheck",
    config: {},
  },
  //更新召回登记
  updateCheck: {
    method: "post",
    url: "/rcn/updateCheck",
    config: {},
  },
  //删除召回登记
  delCheck: {
    method: "post",
    url: "/rcn/delCheck",
    config: {},
  },
  //提交召回登记
  rcnSubmitCheck: {
    method: "post",
    url: "/rcn/submitCheck",
    config: {},
  },
  //查询召回报告单列表
  queryReportInit: {
    method: "post",
    url: "/rcn/queryReportInit",
    config: {},
  },
  //添加召回报告单
  rcnAddReport: {
    method: "post",
    url: "/rcn/addReport",
    config: {},
  },
  //更新召回报告单
  rcnUpdateReport: {
    method: "post",
    url: "/rcn/updateReport",
    config: {},
  },
  //删除召回报告单
  rcnDelReport: {
    method: "post",
    url: "/rcn/delReport",
    config: {},
  },
  //提交召回报告单
  rcnSubmitReport: {
    method: "post",
    url: "/rcn/submitReport",
    config: {},
  },
  //查询召回通知单任务列表
  rcnQueryNoticeTask: {
    method: "post",
    url: "/rcn/queryNoticeTask",
    config: {},
  },
  //查询召回报告单历史列表
  queryReportHistory: {
    method: "post",
    url: "/rcn/queryReportHistory",
    config: {},
  },
  //查询投诉登记列表
  queryRegInit: {
    method: "post",
    url: "/complaint/queryRegInit",
    config: {},
  },
  //查询投诉登记历史列表
  queryRegHistory: {
    method: "post",
    url: "/complaint/queryRegHistory",
    config: {},
  },
  //添加投诉登记
  complaintAddReg: {
    method: "post",
    url: "/complaint/addReg",
    config: {},
  },
  //更新投诉登记
  complaintUpdateReg: {
    method: "post",
    url: "/complaint/updateReg",
    config: {},
  },
  //删除投诉登记
  complaintDelReg: {
    method: "post",
    url: "/complaint/delReg",
    config: {},
  },
  //提交投诉登记
  complaintSubmitReg: {
    method: "post",
    url: "/complaint/submitReg",
    config: {},
  },
  //查询投诉登记任务列表
  complaintQueryRegTask: {
    method: "post",
    url: "/complaint/queryRegTask",
    config: {},
  },
  //查询投诉内部处理列表
  queryHandleInit: {
    method: "post",
    url: "/complaint/queryHandleInit",
    config: {},
  },
  //查询投诉内部处理历史列表
  queryHandleHistory: {
    method: "post",
    url: "/complaint/queryHandleHistory",
    config: {},
  },
  //添加投诉内部处理
  complaintAddHandle: {
    method: "post",
    url: "/complaint/addHandle",
    config: {},
  },
  //更新投诉内部处理
  complaintUpdateHandle: {
    method: "post",
    url: "/complaint/updateHandle",
    config: {},
  },
  //删除投诉内部处理
  complaintDelHandle: {
    method: "post",
    url: "/complaint/delHandle",
    config: {},
  },
  //提交投诉内部处理
  complaintSubmitHandle: {
    method: "post",
    url: "/complaint/submitHandle",
    config: {},
  },
  //查询投诉内部处理任务列表
  queryHandleTask: {
    method: "post",
    url: "/complaint/queryHandleTask",
    config: {},
  },
  //查询投诉分析报告列表
  complaintQueryReportInit: {
    method: "post",
    url: "/complaint/queryReportInit",
    config: {},
  },
  //添加投诉分析报告
  complaintAddReport: {
    method: "post",
    url: "/complaint/addReport",
    config: {},
  },
  //更新投诉分析报告
  complaintUpdateReport: {
    method: "post",
    url: "/complaint/updateReport",
    config: {},
  },
  //删除投诉分析报告
  complaintDelReport: {
    method: "post",
    url: "/complaint/delReport",
    config: {},
  },
  //查询召回通知单历史列表
  queryNoticeHistory: {
    method: "post",
    url: "/rcn/queryNoticeHistory",
    config: {},
  },
  //查询追回通知单列表
  clawBackQueryNoticeInit: {
    method: "post",
    url: "/ClawBack/queryNoticeInit",
    config: {},
  },
  //添加追回通知单
  ClawBackAddNotice: {
    method: "post",
    url: "/ClawBack/addNotice",
    config: {},
  },
  //更新追回通知单
  ClawBackUpdateNotice: {
    method: "post",
    url: "/ClawBack/updateNotice",
    config: {},
  },
  //删除追回通知单
  ClawBackDelNotice: {
    method: "post",
    url: "/ClawBack/delNotice",
    config: {},
  },
  //提交追回通知单
  ClawBackSubmitNotice: {
    method: "post",
    url: "/ClawBack/submitNotice",
    config: {},
  },
  //查询追回通知单任务列表
  ClawBackQueryNoticeTask: {
    method: "post",
    url: "/ClawBack/queryNoticeTask",
    config: {},
  },
  //查询追回通知单历史列表
  ClawBackQueryNoticeHistory: {
    method: "post",
    url: "/ClawBack/queryNoticeHistory",
    config: {},
  },
  //查询追回分发列表
  ClawBackQueryQueryHandOut: {
    method: "post",
    url: "/ClawBack/queryHandOut",
    config: {},
  },
  //添加追回分发
  ClawBackQueryAddHandOut: {
    method: "post",
    url: "/ClawBack/addHandOut",
    config: {},
  },
  //更新追回分发
  ClawBackQueryUpdateHandOut: {
    method: "post",
    url: "/ClawBack/updateHandOut",
    config: {},
  },
  //删除追回分发
  ClawBackQueryDelHandOut: {
    method: "post",
    url: "/ClawBack/delHandOut",
    config: {},
  },
  //提交追回分发
  ClawBackQuerySubmitHandOut: {
    method: "post",
    url: "/ClawBack/submitHandOut",
    config: {},
  },
  //查询追回登记列表
  ClawBackQueryQueryCheck: {
    method: "post",
    url: "/ClawBack/queryCheck",
    config: {},
  },
  //添加追回登记
  ClawBackQueryAddCheck: {
    method: "post",
    url: "/ClawBack/addCheck",
    config: {},
  },
  //更新追回登记
  ClawBackQueryUpdateCheck: {
    method: "post",
    url: "/ClawBack/updateCheck",
    config: {},
  },
  //删除追回登记
  ClawBackQueryDelCheck: {
    method: "post",
    url: "/ClawBack/delCheck",
    config: {},
  },
  //提交追回登记
  ClawBackQuerySubmitCheck: {
    method: "post",
    url: "/ClawBack/submitCheck",
    config: {},
  },
  //查询追回报告单列表
  ClawBackQueryQueryReportInit: {
    method: "post",
    url: "/ClawBack/queryReportInit",
    config: {},
  },
  //添加追回报告单
  ClawBackQueryAddReport: {
    method: "post",
    url: "/ClawBack/addReport",
    config: {},
  },
  //更新追回报告单
  ClawBackQueryUpdateReport: {
    method: "post",
    url: "/ClawBack/updateReport",
    config: {},
  },
  //删除追回报告单
  ClawBackQueryDelReport: {
    method: "post",
    url: "/ClawBack/delReport",
    config: {},
  },
  //提交追回报告单
  ClawBackQuerySubmitReport: {
    method: "post",
    url: "/ClawBack/submitReport",
    config: {},
  },
  //查询追回报告单任务列表
  ClawBackQueryQueryReportTask: {
    method: "post",
    url: "/ClawBack/queryReportTask",
    config: {},
  },
  //查询追回报告单历史列表
  ClawBackQueryQueryReportHistory: {
    method: "post",
    url: "/ClawBack/queryReportHistory",
    config: {},
  },
  //查询部门文件列表
  queryDepartFileInit: {
    method: "post",
    url: "/DepartFile/queryDepartFileInit",
    config: {},
  },
  //添加部门文件
  addDepartFile: {
    method: "post",
    url: "/DepartFile/addDepartFile",
    config: {},
  },
  //更新部门文件
  updateDepartFile: {
    method: "post",
    url: "/DepartFile/updateDepartFile",
    config: {},
  },
  //删除部门文件
  delDepartFile: {
    method: "post",
    url: "/DepartFile/delDepartFile",
    config: {},
  },
  //auditModelHis 历史审核
  auditModelHis: {
    method: "post",
    url: "/process/auditModelHis",
    config: {},
  },
  //查询不合格确定列表
  gybhgQuery: {
    method: "post",
    url: "/gybhg/query",
    config: {},
  },
  //不合格审批
  gybhgAudit: {
    method: "post",
    url: "/gybhg/audit",
    config: {},
  },
  //查询不合格确定审批记录
  gybhgQuerySp: {
    method: "post",
    url: "/gybhg/querySp",
    config: {},
  },
  //查询收货异常确定列表----------------------
  gyycshQuery: {
    method: "post",
    url: "/gyycsh/query",
    config: {},
  },
  //收货异常审批
  gyycshAudit: {
    method: "post",
    url: "/gyycsh/audit",
    config: {},
  },
  //查询收货异常确定审批记录
  gyycshQuerySp: {
    method: "post",
    url: "/gyycsh/querySp",
    config: {},
  },
  //关联人员
  bindMem: {
    method: "post",
    url: "/DepartFile/bindMem",
    config: {},
  },
  //获取已经绑定的人员id
  getBindMemByFileId: {
    method: "post",
    url: "/DepartFile/getBindMemByFileId",
    config: {},
  },
  //出库复核删除
  WoRecheckDelete: {
    method: "post",
    url: "/WoRecheck/delete",
    config: {},
  },
  //查询销售价目表
  supriceListqueryList: {
    method: "post",
    url: "/supriceList/queryList",
    config: {},
  },
  //添加销售价目表
  supriceListadd: {
    method: "post",
    url: "/supriceList/add",
    config: {},
  },
  //修改销售价目表
  supriceListupdate: {
    method: "post",
    url: "/supriceList/update",
    config: {},
  },
  //删除销售价目表
  supriceListdelete: {
    method: "post",
    url: "/supriceList/delete",
    config: {},
  },
  //导入销售价目表
  supriceListexportReturnDetail: {
    method: "post",
    url: "/supriceList/exportReturnDetail",
    config: {},
  },
  //提交销售价目表
  supriceListsubmit: {
    method: "post",
    url: "/supriceList/submit",
    config: {},
  },
  //查询销售价目表审核列表
  supriceListqueryTask: {
    method: "post",
    url: "/supriceList/queryTask",
    config: {},
  },
  //查询销售价目表历史列表
  supriceListqueryHis: {
    method: "post",
    url: "/supriceList/queryHis",
    config: {},
  },
  //销售价目表历史(回退)
  supriceListbackPrice: {
    method: "post",
    url: "/supriceList/backPrice",
    config: {},
  },
  //查询采购价目表
  pupriceListqueryList: {
    method: "post",
    url: "/pupriceList/queryList",
    config: {},
  },
  //添加采购价目表
  pupriceListadd: {
    method: "post",
    url: "/pupriceList/add",
    config: {},
  },
  //修改采购价目表
  pupriceListupdate: {
    method: "post",
    url: "/pupriceList/update",
    config: {},
  },
  //删除采购价目表
  pupriceListdelete: {
    method: "post",
    url: "/pupriceList/delete",
    config: {},
  },
  //查询商品拒收列表
  refusequeryList: {
    method: "post",
    url: "/refuse/queryList",
    config: {},
  },
  //-----供应商押金
  //查询押金列表
  smDepositqueryList: {
    method: "post",
    url: "/smDeposit/queryList",
    config: {},
  },
  //扣减押金
  smDepositdeduction: {
    method: "post",
    url: "/smDeposit/deduction",
    config: {},
  },
  //新增押金
  smDepositadd: {
    method: "post",
    url: "/smDeposit/add",
    config: {},
  },
  //-----客户押金
  //查询押金列表
  cmDepositqueryList: {
    method: "post",
    url: "/cmDeposit/queryList",
    config: {},
  },
  //扣减押金
  cmDepositdeduction: {
    method: "post",
    url: "/cmDeposit/deduction",
    config: {},
  },
  //新增押金
  cmDepositadd: {
    method: "post",
    url: "/cmDeposit/add",
    config: {},
  },
  //-----手术类型维护
  //查询手术类型
  dictSurgeryqueryList: {
    method: "post",
    url: "/dictSurgery/queryList",
    config: {},
  },
  //新增手术类型
  dictSurgeryadd: {
    method: "post",
    url: "/dictSurgery/add",
    config: {},
  },
  //修改手术类型
  dictSurgeryupdate: {
    method: "post",
    url: "/dictSurgery/update",
    config: {},
  },
  //删除手术类型
  dictSurgerydelete: {
    method: "post",
    url: "/dictSurgery/delete",
    config: {},
  },
  //-----供应商费用登记
  //查询初始费用登记
  smfeeregistqueryInit: {
    method: "post",
    url: "/smfeeregist/queryInit",
    config: {},
  },
  //新增供应商费用登记
  smfeeregistadd: {
    method: "post",
    url: "/smfeeregist/add",
    config: {},
  },
  //修改供应商费用登记
  smfeeregistupdate: {
    method: "post",
    url: "/smfeeregist/update",
    config: {},
  },
  //删除费用登记
  smfeeregistdelete: {
    method: "post",
    url: "/smfeeregist/delete",
    config: {},
  },
  //提交供应商费用登记
  smfeeregistsubmitAudit: {
    method: "post",
    url: "/smfeeregist/submitAudit",
    config: {},
  },
  //查询待审核供应商费用登记
  smfeeregistqueryTask: {
    method: "post",
    url: "/smfeeregist/queryTask",
    config: {},
  },
  //查询供应商费用登记历史
  smfeeregistqueryHis: {
    method: "post",
    url: "/smfeeregist/queryHis",
    config: {},
  },
  //供应商费用登记历史---红冲
  smfeeregistaddRed: {
    method: "post",
    url: "/smfeeregist/addRed",
    config: {},
  },
  //------客户费用登记
  //查询费用登记
  cmfeeregistqueryInit: {
    method: "post",
    url: "/cmfeeregist/queryInit",
    config: {},
  },
  //新增费用登记
  cmfeeregistadd: {
    method: "post",
    url: "/cmfeeregist/add",
    config: {},
  },
  //修改费用登记
  cmfeeregistupdate: {
    method: "post",
    url: "/cmfeeregist/update",
    config: {},
  },
  //删除费用登记
  cmfeeregistdelete: {
    method: "post",
    url: "/cmfeeregist/delete",
    config: {},
  },
  //提交费用登记
  cmfeeregistsubmitAudit: {
    method: "post",
    url: "/cmfeeregist/submitAudit",
    config: {},
  },
  //查询待审核费用登记
  cmfeeregistqueryTask: {
    method: "post",
    url: "/cmfeeregist/queryTask",
    config: {},
  },
  //查询费用登记历史
  cmfeeregistqueryHis: {
    method: "post",
    url: "/cmfeeregist/queryHis",
    config: {},
  },
  //费用登记历史--红冲
  cmfeeregistaddRed: {
    method: "post",
    url: "/cmfeeregist/addRed",
    config: {},
  },
  //-----------手术包
  //查询手术包列表
  surgerymasterqueryList: {
    method: "post",
    url: "/surgerymaster/queryList",
    config: {},
  },
  //查询手术包明细
  surgerymasterqueryDetail: {
    method: "post",
    url: "/surgerymaster/queryDetail",
    config: {},
  },
  //新增手术包
  surgerymasteradd: {
    method: "post",
    url: "/surgerymaster/add",
    config: {},
  },
  //修改手术包
  surgerymasterupdate: {
    method: "post",
    url: "/surgerymaster/update",
    config: {},
  },
  //删除手术包
  surgerymasterdelete: {
    method: "post",
    url: "/surgerymaster/delete",
    config: {},
  },
  //导入手术包
  surgerymasterexporSurgery: {
    method: "post",
    url: "/surgerymaster/exporSurgery",
    config: {},
  },
  //查询手术订单
  surorderqueryList: {
    method: "post",
    url: "/surorder/queryList",
    config: {},
  },
  //新增手术订单
  surorderadd: {
    method: "post",
    url: "/surorder/add",
    config: {},
  },
  //修改手术订单
  surorderupdate: {
    method: "post",
    url: "/surorder/update",
    config: {},
  },
  //删除手术订单
  surorderdelete: {
    method: "post",
    url: "/surorder/delete",
    config: {},
  },
  //查询手术订单历史
  surorderqueryHis: {
    method: "post",
    url: "/surorder/queryHis",
    config: {},
  },
  //查询手术订单授权公司
  surorderqueryAuthCompany: {
    method: "post",
    url: "/surorder/queryAuthCompany",
    config: {},
  },
  //--------------预出库
  //查询预出库订单列表
  pwoapplyqueryList: {
    method: "post",
    url: "/pwoapply/queryList",
    config: {},
  },
  //新增预出库订单
  pwoapplyadd: {
    method: "post",
    url: "/pwoapply/add",
    config: {},
  },
  //修改预出库订单
  pwoapplyupdate: {
    method: "post",
    url: "/pwoapply/update",
    config: {},
  },
  //删除预出库订单
  pwoapplydelete: {
    method: "post",
    url: "/pwoapply/delete",
    config: {},
  },
  //提交预出库订单
  pwoapplysubmitAudit: {
    method: "post",
    url: "/pwoapply/submitAudit",
    config: {},
  },
  //查询待审核预出库订单
  pwoapplyqueryTask: {
    method: "post",
    url: "/pwoapply/queryTask",
    config: {},
  },
  //查询预出库订单历史
  pwoapplyqueryHis: {
    method: "post",
    url: "/pwoapply/queryHis",
    config: {},
  },
  //查询回库订单历史
  queryReturnHis: {
    method: "post",
    url: "/consumeAdmin/queryReturnHis",
    config: {},
  },
  //查询待收货列表
  pwoapplyqueryWaitDelive: {
    method: "post",
    url: "/pwoapply/queryWaitDelive",
    config: {},
  },
  //查询跟台登记信息
  pwoapplyregistPwoapplyPC: {
    method: "post",
    url: "/pwoapply/registPwoapplyPc",
    config: {},
  },
  //工具停售
  //查询工具停售
  stopsqueryToolStop: {
    method: "post",
    url: "/stops/queryToolStop",
    config: {},
  },
  //新增工具停售
  stopstoolStop: {
    method: "post",
    url: "/stops/toolStop",
    config: {},
  },
  //修改工具停售
  stopsupdateToolStop: {
    method: "post",
    url: "/tops/updateToolStop",
    config: {},
  },
  //删除工具停售
  stopsdeleteToolStop: {
    method: "post",
    url: "/stops/deleteToolStop",
    config: {},
  },
  //解除工具停售
  stopsliftStop: {
    method: "post",
    url: "/stops/liftStop",
    config: {},
  },
  //查询消耗单列表
  consumeAdminqueryList: {
    method: "post",
    url: "/consumeAdmin/queryList",
    config: {},
  },
  //查询询消耗单明细信息
  consumeAdminqueryById: {
    method: "post",
    url: "/consumeAdmin/queryById",
    config: {},
  },
  //提交审核消耗单
  consumeAdminsubmit: {
    method: "post",
    url: "/consumeAdmin/submit",
    config: {},
  },
  //消耗上报-生成消耗单
  consumeAdminconsumptionReporting: {
    method: "post",
    url: "/consumeAdmin/consumptionReporting",
    config: {},
  },
  //填写消耗单价格信息
  consumeAdminfillPrice: {
    method: "post",
    url: "/consumeAdmin/fillPrice",
    config: {},
  },
  //查询消耗单历史
  consumeAdminqueryHis: {
    method: "post",
    url: "/consumeAdmin/queryHis",
    config: {},
  },
  //查询寄售订单列表
  conorderqueryInit: {
    method: "post",
    url: "/conorder/queryInit",
    config: {},
  },
  //查询寄售订单详情
  conorderqueryDetail: {
    method: "post",
    url: "/conorder/queryDetail",
    config: {},
  },
  //新增寄售订单
  conorderadd: {
    method: "post",
    url: "/conorder/add",
    config: {},
  },
  //修改I寄售订单
  conorderupdate: {
    method: "post",
    url: "/conorder/update",
    config: {},
  },
  //删除寄售订单
  conorderdelete: {
    method: "post",
    url: "/conorder/delete",
    config: {},
  },
  //提交寄售订单
  conordersubmit: {
    method: "post",
    url: "/conorder/submit",
    config: {},
  },
  //查询待审核寄售订单
  conorderqueryTask: {
    method: "post",
    url: "/conorder/queryTask",
    config: {},
  },
  //查询历史寄售订单
  conorderqueryHis: {
    method: "post",
    url: "/conorder/queryHis",
    config: {},
  },
  //查询寄售出库订单列表
  conoutboundqueryInit: {
    method: "post",
    url: "/conoutbound/queryInit",
    config: {},
  },
  //查询寄售出库订单详情
  conoutboundqueryDetail: {
    method: "post",
    url: "/conoutbound/queryDetail",
    config: {},
  },
  //新增寄售出库订单
  conoutboundadd: {
    method: "post",
    url: "/conoutbound/add",
    config: {},
  },
  //修改寄售出库订单
  conoutboundupdate: {
    method: "post",
    url: "/conoutbound/update",
    config: {},
  },
  //删除寄售出库订单
  conoutbounddelete: {
    method: "post",
    url: "/conoutbound/delete",
    config: {},
  },
  //提交寄售出库订单
  conoutboundsubmit: {
    method: "post",
    url: "/conoutbound/submit",
    config: {},
  },
  //查询未审核寄售出库订单列表
  conoutboundqueryTask: {
    method: "post",
    url: "/conoutbound/queryTask",
    config: {},
  },
  //查询历史寄售出库订单列表
  conoutboundqueryHis: {
    method: "post",
    url: "/conoutbound/queryHis",
    config: {},
  },
  //查询寄售回库订单列表
  conreturnqueryInit: {
    method: "post",
    url: "/conreturn/queryInit",
    config: {},
  },
  //查询寄售回库订单详情
  conreturnqueryDetail: {
    method: "post",
    url: "/conreturn/queryDetail",
    config: {},
  },
  //新增寄售回库订单
  conreturnadd: {
    method: "post",
    url: "/conreturn/add",
    config: {},
  },
  //查询对账单列表
  reconciliationqueryList: {
    method: "post",
    url: "/reconciliation/queryList",
    config: {},
  },
  //查询对账单
  reconciliationqueryById: {
    method: "post",
    url: "/reconciliation/queryById",
    config: {},
  },
  //新增对账单
  reconciliationadd: {
    method: "post",
    url: "/reconciliation/add",
    config: {},
  },
  //修改对账单
  reconciliationupdate: {
    method: "post",
    url: "/reconciliation/update",
    config: {},
  },
  //删除对账单
  reconciliationdelete: {
    method: "post",
    url: "/reconciliation/delete",
    config: {},
  },
  //确认对账单
  reconciliationconfirmReconciliation: {
    method: "post",
    url: "/reconciliation/submitTask",
    config: {},
  },
  //查询待提取数据
  reconciliationqueryWait: {
    method: "post",
    url: "/reconciliation/queryWait",
    config: {},
  },
  //查询对账单待审核列表
  reconciliationqueryTask: {
    method: "post",
    url: "/reconciliation/queryTask",
    config: {},
  },
  //查询对账单历史列表
  reconciliationqueryHist: {
    method: "post",
    url: "/reconciliation/queryHis",
    config: {},
  },
  //对账单历史--回退
  reconciliationreback: {
    method: "post",
    url: "/reconciliation/reback",
    config: {},
  },
  //查询对账单提取列表
  reconciliationextPisInfo: {
    method: "post",
    url: "/reconciliation/extPisInfo",
    config: {},
  },
  //-------------------------------------------------------------------------------------------------------------------------------------------
  //拦截规则配置
  fromrulequeryByIdToJson: {
    method: "post",
    url: "/fromrule/queryByIdToJson",
    config: {},
  },
  //--------------------------------------------------------------------------------------------------------------------------------------------
  //--------------------------------------------------------------------------------------------------------------------------------------------
  //提取预出库单主信息
  pwoapplyExtractPwoapplyMaster: {
    method: "post",
    url: "/pwoapply/extractPwoapplyMaster",
    config: {},
  },
  //查询医院资料
  dempHospitalquery: {
    method: "post",
    url: "/dempHospital/query",
    config: {},
  },
  //删除医院资料
  dempHospitaldelete: {
    method: "post",
    url: "/dempHospital/delete",
    config: {},
  },
  //新增医院资料
  dempHospitalAdd: {
    method: "post",
    url: "/dempHospital/add",
    config: {},
  },
  //修改医院资料
  dempHospitalUpdate: {
    method: "post",
    url: "/dempHospital/update",
    config: {},
  },
  //医院资料--授权查询列表
  dempHospitalqueryBrandAuth: {
    method: "post",
    url: "/dempHospital/queryBrandAuth",
    config: {},
  },
  //医院资料--授权
  dempHospitaladdBrandAuth: {
    method: "post",
    url: "/dempHospital/addBrandAuth",
    config: {},
  },
  //查询消耗单列表
  consumeAdminQueryList: {
    method: "post",
    url: "/consumeAdmin/queryList",
    config: {},
  },
  //确认消耗单
  consumeAdminConfirm: {
    method: "post",
    url: "/consumeAdmin/confirm",
    config: {},
  },
  //查询消耗单审核列表
  consumeAdminQueryTask: {
    method: "post",
    url: "/consumeAdmin/queryTask",
    config: {},
  },
  //确认收货
  pwoapplyconfirmDeliver: {
    method: "post",
    url: "/pwoapply/confirmDeliver",
    config: {},
  },
  importSudrawbill: {
    method: "post",
    url: "/sudrawbill/importSudrawbill",
    config: {},
  },
  //查询采购开票申请
  psdrawbillqueryInit: {
    method: "post",
    url: "/psdrawbill/queryInit",
    config: {},
  },
  //新增采购开票申请
  psdrawbilladd: {
    method: "post",
    url: "/psdrawbill/add",
    config: {},
  },
  //删除采购开票申请
  psdrawbilldelete: {
    method: "post",
    url: "/psdrawbill/delete",
    config: {},
  },
  //提交采购开票申请
  psdrawbillsubmit: {
    method: "post",
    url: "/psdrawbill/submit",
    config: {},
  },
  //查询采购开票申请审核
  psdrawbillqueryPass: {
    method: "post",
    url: "/psdrawbill/queryTask",
    config: {},
  },
  //查询采购开票申请历史
  psdrawbillqueryHis: {
    method: "post",
    url: "/psdrawbill/queryHis",
    config: {},
  },
  //回写发票号
  psdrawbillwriteBillnum: {
    method: "post",
    url: "/psdrawbill/writeBillnum",
    config: {},
  },
  //回退
  psdrawbillreback: {
    method: "post",
    url: "/psdrawbill/reback",
    config: {},
  },
  //提取开票成功明细信息
  psdrawbillextractDetail: {
    method: "post",
    url: "/psdrawbill/extractDetail",
    config: {},
  },
  //提取开票成功单据
  psdrawbillextractSudrawbill: {
    method: "post",
    url: "/psdrawbill/extractSudrawbill",
    config: {},
  },
  //提取开票成功明细信息
  reconciliationextractConsignreconDetail: {
    method: "post",
    url: "/reconciliation/extractConsignreconDetail",
    config: {},
  },
  //提取开票成功单据
  reconciliationextractConsignreconMaster: {
    method: "post",
    url: "/reconciliation/extractConsignreconMaster",
    config: {},
  },
  //添加
  psdocumentssaveBillRegist: {
    method: "post",
    url: "/psdocuments/saveBillRegist",
    config: {},
  },
  //委托书资料变更删除验证
  counterpartySalesmandeleteState: {
    method: "post",
    url: "/counterpartySalesman/deleteState",
    config: {},
  },
  //查询工具计费规则列表
  toolBillingqueryList: {
    method: "post",
    url: "/toolBilling/queryList",
    config: {},
  },
  //新增工具计费规则
  toolBillingadd: {
    method: "post",
    url: "/toolBilling/add",
    config: {},
  },
  //修改工具计费规则
  toolBillingupdate: {
    method: "post",
    url: "/toolBilling/update",
    config: {},
  },
  //删除工具计费规则
  toolBillingdelete: {
    method: "post",
    url: "/toolBilling/delete",
    config: {},
  },
  //查询现金流水
  cashFlowqueryList: {
    method: "post",
    url: "/cashFlow/queryList",
    config: {},
  },
  //修改现金流水
  cashFlowupdate: {
    method: "post",
    url: "/cashFlow/update",
    config: {},
  },
  //删除现金流水
  cashFlowdelete: {
    method: "post",
    url: "/cashFlow/delete",
    config: {},
  },
  //导入现金流水
  cashFlowexportCashFlow: {
    method: "post",
    url: "/cashFlow/exportCashFlow",
    config: {},
  },
  //拦截规则---首营客户仓库地址是否同步到收货地址里
  gspCustomerAddressFromRule: {
    method: "post",
    url: "/gspCustomer/addressFromRule",
    config: {},
  },
  //维护SPD编码
  supplierupdateSpdCode: {
    method: "post",
    url: "/supplier/updateSpdCode",
    config: {},
  },
  //业务员提成
  //查询业务员提成修改单列表
  bgmPrcorderList: {
    method: "post",
    url: "/bgmPrc/orderList",
    config: {},
  },
  //添加业务员提成修改单
  bgmPrcaddOrder: {
    method: "post",
    url: "/bgmPrc/addOrder",
    config: {},
  },
  //修改业务员提成修改单
  bgmPrcupdateOrder: {
    method: "post",
    url: "/bgmPrc/updateOrder",
    config: {},
  },
  //删除业务员提成修改单
  bgmPrcdelOrder: {
    method: "post",
    url: "/bgmPrc/delOrder",
    config: {},
  },
  //提交业务员提成修改单
  bgmPrcsubmit: {
    method: "post",
    url: "/bgmPrc/submit",
    config: {},
  },
  //查询业务员提成修改单审核任务列表
  bgmPrcorderTaskList: {
    method: "post",
    url: "/bgmPrc/orderTaskList",
    config: {},
  },
  //查询业务员提成修改单历史任务列表
  bgmPrcorderHisList: {
    method: "post",
    url: "/bgmPrc/orderHisList",
    config: {},
  },
  //器械订单提示价格拦截
  woApplypriceIntercept: {
    method: "post",
    url: "/woApply/priceIntercept",
    config: {},
  },
  //库存差异对比
  //查询库存差异对比
  stockDifferenceMasterqueryWaitPage: {
    method: "post",
    url: "/stockDifferenceMaster/queryWaitPage",
    config: {},
  },
  //导入明细
  stockDifferenceexportChangeDetail: {
    method: "post",
    url: "/stockDifference/exportChangeDetail",
    config: {},
  },
  //保存差异
  stockDifferenceMasteradd: {
    method: "post",
    url: "/stockDifferenceMaster/add",
    config: {},
  },
  //删除
  stockDifferenceMasterdelete: {
    method: "post",
    url: "/stockDifferenceMaster/delete",
    config: {},
  },
  //提交
  stockDifferenceMastersubmitTask: {
    method: "post",
    url: "/stockDifferenceMaster/submitTask",
    config: {},
  },
  //查询审核任务列表
  stockDifferenceMasterqueryTask: {
    method: "post",
    url: "/stockDifferenceMaster/queryTask",
    config: {},
  },
  //查询历史列表
  stockDifferenceMasterqueryHisPage: {
    method: "post",
    url: "/stockDifferenceMaster/queryHisPage",
    config: {},
  },
  //轮播图分类
  //查询轮播图分类列表
  carouseClassifyqueryList: {
    method: "post",
    url: "/carouseClassify/queryList",
    config: {},
  },
  //新增轮播图分类
  carouseClassifyadd: {
    method: "post",
    url: "/carouseClassify/add",
    config: {},
  },
  //修改轮播图分类
  carouseClassifyupdate: {
    method: "post",
    url: "/carouseClassify/update",
    config: {},
  },
  //删除轮播图分类
  carouseClassifydelete: {
    method: "post",
    url: "/carouseClassify/delete",
    config: {},
  },
  //查询轮播图
  carouselqueryList: {
    method: "post",
    url: "/carousel/queryList",
    config: {},
  },
  //添加轮播图
  carouseladd: {
    method: "post",
    url: "/carousel/add",
    config: {},
  },
  //修改轮播图
  carouselupdate: {
    method: "post",
    url: "/carousel/update",
    config: {},
  },
  //删除轮播图
  carouseldelete: {
    method: "post",
    url: "/carousel/delete",
    config: {},
  },
  //查询货主商品管理费
  CargoOwnerMfequeryList: {
    method: "post",
    url: "/CargoOwnerMfe/queryList",
    config: {},
  },
  //新增货主商品管理费
  CargoOwnerMfeadd: {
    method: "post",
    url: "/CargoOwnerMfe/add",
    config: {},
  },
  //修改货主商品管理费
  CargoOwnerMfeupdate: {
    method: "post",
    url: "/CargoOwnerMfe/update",
    config: {},
  },
  //删除货主商品管理费
  CargoOwnerMfedelete: {
    method: "post",
    url: "/CargoOwnerMfe/delete",
    config: {},
  },
  //查询采购退货红冲待提交列表
  rrgapplyqueryWait: {
    method: "post",
    url: "/rrgapply/queryWait",
    config: {},
  },

  //根据ID查询采购退货红冲详情
  rrgapplyqueryById: {
    method: "get",
    url: "/rrgapply/queryById",
    config: {},
  },
  //新增采购退货红冲
  rrgapplyadd: {
    method: "post",
    url: "/rrgapply/add",
    config: {},
  },
  //修改采购退货红冲
  rrgapplyupdate: {
    method: "post",
    url: "/rrgapply/update",
    config: {},
  },
  //删除采购退货红冲
  rrgapplydelete: {
    method: "post",
    url: "/rrgapply/delete",
    config: {},
  },
  //采购退货红冲---提交
  rrgapplysubmit: {
    method: "post",
    url: "/rrgapply/submit",
    config: {},
  },
  //查询采购红冲--回退
  rrgapplyreback: {
    method: "post",
    url: "/rrgapply/reback",
    config: {},
  },
  //查询采购退货红冲待审核任务列表
  rrgapplyqueryTask: {
    method: "post",
    url: "/rrgapply/queryTask",
    config: {},
  },
  //查询采购退货红冲历史列表
  rrgapplyqueryHis: {
    method: "post",
    url: "/rrgapply/queryHis",
    config: {},
  },
  //查询采购红冲记账列表
  rrgbkmasterqueryList: {
    method: "post",
    url: "/rrgbkmaster/queryList",
    config: {},
  },
  //查询采购红冲记账----记账
  rrgbkmasteraddAccount: {
    method: "post",
    url: "/rrgbkmaster/addAccount",
    config: {},
  },
  //查询采购红冲记账历史列表
  rrgbkmasterqueryHis: {
    method: "post",
    url: "/rrgbkmaster/queryHis",
    config: {},
  },
  //查询基础生产厂家信息
  basemanufacturerquery: {
    method: "post",
    url: "/basemanufacturer/query",
    config: {},
  },
  //查询基础生产厂家详细信息
  basemanufacturerqueryDetail: {
    method: "post",
    url: "/basemanufacturer/queryDetail",
    config: {},
  },
  //新增基础生产厂家信息
  basemanufactureradd: {
    method: "post",
    url: "/basemanufacturer/add",
    config: {},
  },
  //修改基础生产厂家信息
  basemanufacturerupdate: {
    method: "post",
    url: "/basemanufacturer/update",
    config: {},
  },
  //删除基础生产厂家信息
  basemanufacturerdelete: {
    method: "post",
    url: "/basemanufacturer/delete",
    config: {},
  },
  //查询基础注册证信息
  baseregistnoquery: {
    method: "post",
    url: "/baseregistno/query",
    config: {},
  },
  //查询基础注册证详细信息
  baseregistnoqueryDetail: {
    method: "post",
    url: "/baseregistno/queryDetail",
    config: {},
  },
  //新增基础注册证信息
  baseregistnoadd: {
    method: "post",
    url: "/baseregistno/add",
    config: {},
  },
  //查询基础注册证信息
  baseregistnoQuery: {
    method: "post",
    url: "/baseregistno/query",
    config: {
    },
  },
  //修改基础注册证信息
  baseregistnoupdate: {
    method: "post",
    url: "/baseregistno/update",
    config: {},
  },
  //删除基础注册证信息
  baseregistnodelete: {
    method: "post",
    url: "/baseregistno/delete",
    config: {},
  },
  //导入
  baseregistnoexport: {
    method: "post",
    url: "/baseregistno/export",
    config: {},
  },
  //t停用
  baseregistnostop: {
    method: "post",
    url: "/baseregistno/stop",
    config: {},
  },
  //启用
  baseregistnoenable: {
    method: "post",
    url: "/baseregistno/enable",
    config: {},
  },
  //查询授权注册书
  baseregistnoqueryAuthList: {
    method: "post",
    url: "/baseregistno/queryAuthList",
    config: {},
  },
  //查询基础品牌信息
  basebrandquery: {
    method: "post",
    url: "/basebrand/query",
    config: {},
  },
  //查询基础品牌明细信息
  basebrandqueryDetail: {
    method: "post",
    url: "/basebrand/queryDetail",
    config: {},
  },
  //新增基础品牌信息
  basebrandadd: {
    method: "post",
    url: "/basebrand/add",
    config: {},
  },
  //修改基础品牌信息
  basebrandupdate: {
    method: "post",
    url: "/basebrand/update",
    config: {},
  },
  //删除基础品牌信息
  basebranddelete: {
    method: "post",
    url: "/basebrand/delete",
    config: {},
  },
  //查询授权品牌列表
  basebrandqueryAuthList: {
    method: "post",
    url: "/basebrand/queryAuthList",
    config: {},
  },
  //查询业务员控销列表
  limitSalesquerySales: {
    method: "post",
    url: "/limitSales/querySales",
    config: {},
  },
  //新增业务员控销
  limitSalesaddSales: {
    method: "post",
    url: "/limitSales/addSales",
    config: {},
  },
  //删除业务员控销
  limitSalesdelSales: {
    method: "post",
    url: "/limitSales/delSales",
    config: {},
  },
  //查询业务员限销商品列表
  limitSalesqueryGoodss: {
    method: "post",
    url: "/limitSales/queryGoods",
    config: {},
  },
  //新增业务员限销商品
  limitSalesaddGoods: {
    method: "post",
    url: "/limitSales/addGoods",
    config: {},
  },
  //删除业务员限销商品
  limitSalesdelGoods: {
    method: "post",
    url: "/limitSales/delGoods",
    config: {},
  },
  //查询附加库存属性调整列表
  bgaChangequeryInit: {
    method: "post",
    url: "/bgaChange/queryInit",
    config: {},
  },
  //附加库存属性调整新增
  bgaChangeadd: {
    method: "post",
    url: "/bgaChange/add",
    config: {},
  },
  //修改附加库存属性调整
  bgaChangeupdate: {
    method: "post",
    url: "/bgaChange/update",
    config: {},
  },
  //附加库存属性调整提交
  bgaChangesubmit: {
    method: "post",
    url: "/bgaChange/submit",
    config: {},
  },
  //删除附加库存属性调整
  bgaChangedelete: {
    method: "post",
    url: "/bgaChange/delete",
    config: {},
  },
  //查询附加库存属性调整任务
  bgaChangequeryTask: {
    method: "post",
    url: "/bgaChange/queryTask",
    config: {},
  },
  //查询附加库存属性调整历史
  bgaChangequeryHis: {
    method: "post",
    url: "/bgaChange/queryHis",
    config: {},
  },
  //查询商品采购记录
  puReportqueryGoodsInHis: {
    method: "post",
    url: "/puReport/queryGoodsInHis",
    config: {},
  },
  //查询销售授信申请列表
  creditApplyqueryCreditApplyInit: {
    method: "post",
    url: "/creditApply/queryCreditApplyInit",
    config: {},
  },
  //根据ID查询销售信贷申请
  creditApplyqueryById: {
    method: "GET",
    url: "/creditApply/queryById",
    config: {},
  },
  //新增销售授信申请
  creditApplyaddCreditApply: {
    method: "post",
    url: "/creditApply/addCreditApply",
    config: {},
  },
  //修改销售授信申请
  creditApplyupdateCreditApply: {
    method: "post",
    url: "/creditApply/updateCreditApply",
    config: {},
  },
  //删除销售授信申请
  creditApplydeleteCreditApply: {
    method: "post",
    url: "/creditApply/deleteCreditApply",
    config: {},
  },
  //提交销售授信申请
  creditApplysubmitAudit: {
    method: "post",
    url: "/creditApply/submitAudit",
    config: {},
  },
  //销售信贷申请待审核状态查询
  creditApplyqueryCreditApplyTask: {
    method: "post",
    url: "/creditApply/queryCreditApplyTask",
    config: {},
  },
  //销售信贷申请历史状态查询
  creditApplyqueryCreditApplyHistory: {
    method: "post",
    url: "/creditApply/queryCreditApplyHistory",
    config: {},
  },
  //查询销售授信申请列表
  creditApplyqueryCreditResultList: {
    method: "post",
    url: "/creditApply/queryCreditResultList",
    config: {},
  },

  //删除销售授信申请结果
  creditApplydeleteResult: {
    method: "post",
    url: "/creditApply/deleteResult",
    config: {},
  },
  //查询旺店通订单---成功单据
  orderpoolqueryWdtSuccess: {
    method: "post",
    url: "/orderpool/queryWdtSuccess",
    config: {},
  },
  //查询返利协议--申请列表
  rebateAgreementqueryInit: {
    method: "post",
    url: "/rebateAgreement/queryInit",
    config: {},
  },
  //返利协议--新增
  rebateAgreementadd: {
    method: "post",
    url: "/rebateAgreement/add",
    config: {},
  },
  //返利协议--修改
  rebateAgreementupdate: {
    method: "post",
    url: "/rebateAgreement/update",
    config: {},
  },
  //返利协议--删除
  rebateAgreementdelete: {
    method: "post",
    url: "/rebateAgreement/delete",
    config: {},
  },
  //返利协议--提交
  rebateAgreementsubmit: {
    method: "post",
    url: "/rebateAgreement/submit",
    config: {},
  },
  //返利协议--审核任务列表
  rebateAgreementqueryTask: {
    method: "post",
    url: "/rebateAgreement/queryTask",
    config: {},
  },
  //返利协议--历史列表
  rebateAgreementqueryHis: {
    method: "post",
    url: "/rebateAgreement/queryHis",
    config: {},
  },
  //返利协议--待确认列表
  rebateAgreementqueryConfirmList: {
    method: "post",
    url: "/rebateAgreement/queryConfirmList",
    config: {},
  },
  //返利协议--到账确认
  rebateAgreementrebateConfirm: {
    method: "post",
    url: "/rebateAgreement/rebateConfirm",
    config: {},
  },
  //获取供应商信息的接口
  rebateAgreementgetSmInfoList: {
    method: "post",
    url: "/rebateAgreement/getSmInfoList",
    config: {},
  },
  //绑定外部编码
  cusmasterbindUnitNum: {
    method: "post",
    url: "/cusmaster/bindUnitNum",
    config: {},
  },
  //绑定店铺编码
  cusmasterbindshopId: {
    method: "post",
    url: "/cusmaster/bindshopId",
    config: {},
  },
  //对方业务员---查询
  counterpartySalesmanquerySalesList: {
    method: "post",
    url: "/counterpartySalesman/querySalesList",
    config: {},
  },
  //对方业务员---添加
  counterpartySalesmanaddSales: {
    method: "post",
    url: "/counterpartySalesman/addSales",
    config: {},
  },
  //对方业务员---修改
  counterpartySalesmanupdateSales: {
    method: "post",
    url: "/counterpartySalesman/updateSales",
    config: {},
  },
  //对方业务员---删除
  counterpartySalesmandelSales: {
    method: "post",
    url: "/counterpartySalesman/delSales",
    config: {},
  },
  //对方业务员---状态
  counterpartySalesmanupdateStatus: {
    method: "post",
    url: "/counterpartySalesman/updateStatus",
    config: {},
  },
  //人员信息维护---列表查询接口
  opmAttInfoqueryList: {
    method: "post",
    url: "/opmAttInfo/queryList",
    config: {},
  },
  //人员信息维护---修改接口
  opmAttInfosetAttInfo: {
    method: "post",
    url: "/opmAttInfo/setAttInfo",
    config: {},
  },
  //产品线分类信息---查询
  baseprolinequery: {
    method: "post",
    url: "/baseproline/query",
    config: {},
  },
  //产品线分类详情---查询
  baseprolinequeryDetail: {
    method: "post",
    url: "/baseproline/queryDetail",
    config: {},
  },
  //产品线分类信息---新增
  baseprolineadd: {
    method: "post",
    url: "/baseproline/add",
    config: {},
  },
  //产品线分类信息---修改
  baseprolineupdate: {
    method: "post",
    url: "/baseproline/update",
    config: {},
  },
  //产品线分类信息---删除
  baseprolinedelete: {
    method: "post",
    url: "/baseproline/delete",
    config: {},
  },
  //客户授权信息---查询
  baseauthquery: {
    method: "post",
    url: "/baseauth/query",
    config: {},
  },
  //客户授权信息---查询详情
  baseauthqueryDetail: {
    method: "post",
    url: "/baseauth/queryDetail",
    config: {},
  },
  //客户授权信息---新增
  baseauthadd: {
    method: "post",
    url: "/baseauth/add",
    config: {},
  },
  //客户授权信息---修改
  baseauthupdate: {
    method: "post",
    url: "/baseauth/update",
    config: {},
  },
  //客户授权信息---删除
  baseauthdelete: {
    method: "post",
    url: "/baseauth/delete",
    config: {},
  },
  //查询终端客户列表
  baseauthqueryCustomerList: {
    method: "post",
    url: "/baseauth/queryCustomerList",
    config: {},
  },
  //查询品牌列表
  baseauthqueryBrandList: {
    method: "post",
    url: "/baseauth/queryBrandList",
    config: {},
  },
  //查询医院列表
  baseauthqueryHospitalList: {
    method: "post",
    url: "/baseauth/queryHospitalList",
    config: {},
  },
  //查询注册证列表
  baseauthqueryRegistnoList: {
    method: "post",
    url: "/baseauth/queryRegistnoList",
    config: {},
  },
  //货主应付款明细查询
  castaticownerPaymxQuery: {
    method: "post",
    url: "/castatic/ownerPaymxQuery",
    config: {},
  },
  //货主应收款明细查询
  castaticownerRecemxQuery: {
    method: "post",
    url: "/castatic/ownerRecemxQuery",
    config: {},
  },
  //货主实时余额查询
  CargoOwnerqueryBalanceInfo: {
    method: "post",
    url: "/CargoOwner/queryBalanceInfo",
    config: {},
  },
  //线上零售订单---获取门店配置
  retailWebgetStoreConfig: {
    method: "post",
    url: "/retailWeb/getStoreConfig",
    config: {},
  },
  //线上零售订单---生成订单
  retailWebgenOrder: {
    method: "post",
    url: "/retailWeb/genOrder",
    config: {},
  },
  //线上零售订单---生成店内订单
  retailWebgenOrderStore: {
    method: "post",
    url: "/retailWeb/genOrderStore",
    config: {},
  },
  //线上零售订单---查询单据退货分摊信息
  retailWebgetRejFtInfo: {
    method: "post",
    url: "/retailWeb/getRejFtInfo",
    config: {},
  },
  //线上零售订单---生成退货订单
  retailWebgenOrderRej: {
    method: "post",
    url: "/retailWeb/genOrderRej",
    config: {},
  },
  //线上零售订单---默认设置保存
  retailWebsetStoreDefaultConfig: {
    method: "post",
    url: "/retailWeb/setStoreDefaultConfig",
    config: {},
  },
  //线上零售订单---获取默认设置
  retailWebgetStoreDefaultConfig: {
    method: "post",
    url: "/retailWeb/getStoreDefaultConfig",
    config: {},
  },
  //线上零售订单---作废
  orderpooldisAble: {
    method: "post",
    url: "/orderpool/disAble",
    config: {},
  },
  //线上零售记录---单据查询
  retailWebqueryWebOrder: {
    method: "post",
    url: "/retailWeb/queryWebOrder",
    config: {},
  },
  //线上零售记录---明细
  retailWebqueryWebOrderDetail: {
    method: "post",
    url: "/retailWeb/queryWebOrderDetail",
    config: {},
  },
  //线上零售记录---获取单据明细信息
  retailgetDetailPrintById: {
    method: "post",
    url: "/retail/getDetailPrintById",
    config: {},
  },
  //线上零售O2O订单---作废
  orderpooldisAbleO2O: {
    method: "post",
    url: "/orderpool/disAbleO2O",
    config: {},
  },
  //线上零售O2O订单---退货
  retailWebgenOrderRejByOriginOrder: {
    method: "post",
    url: "/retailWeb/genOrderRejByOriginOrder",
    config: {},
  },
  //查询待结算的采购对账单
  registerqueryWaitpsRecon: {
    method: "post",
    url: "/register/queryWaitpsRecon",
    config: {},
  },
  //采购对账单--保存
  registeraddPreReconSettle: {
    method: "post",
    url: "/register/addPreReconSettle",
    config: {},
  },
  //库存文件上传--查询
  bgStockqueryStockPage: {
    method: "post",
    url: "/bgStock/queryStockPage",
    config: {},
  },
  //库存文件上传--上传
  bgStockuploadStockFile: {
    method: "post",
    url: "/bgStock/uploadStockFile",
    config: {},
  },
  //期初采购发票登记-- 查询待开票列表
  klPuorderqueryList: {
    method: "post",
    url: "/klPuorder/queryList",
    config: {},
  },
  //期初采购发票登记-- 保存开票
  klPuordersaveInvoice: {
    method: "post",
    url: "/klPuorder/saveInvoice",
    config: {},
  },
  //期初销售发票登记-- 查询待开票列表
  klSuorderqueryList: {
    method: "post",
    url: "/klSuorder/queryList",
    config: {},
  },
  //期初销售发票登记-- 保存开票
  klSuordersaveInvoice: {
    method: "post",
    url: "/klSuorder/saveInvoice",
    config: {},
  },
  //UDI出库记录-- 查询
  woApplyquerySuudi: {
    method: "post",
    url: "/woApply/querySuudi",
    config: {},
  },
  //UDI出库记录-- 导出
  woApplyexportSuUdi: {
    method: "post",
    url: "/woApply/exportSuUdi",
    config: {
      responseType: 'blob' // 重要：设置响应类型为blob
    },
  },
  //分类管理-- 查询
  categoryquery: {
    method: "post",
    url: "/category/query",
    config: {},
  },
  //分类管理-- 新增
  categoryadd: {
    method: "post",
    url: "/category/add",
    config: {},
  },
  //分类管理-- 删除
  categorydelete: {
    method: "post",
    url: "/category/delete",
    config: {},
  },
  //通过客户ID和供应商ID来获取赋值信息
  queryDefaultSales: {
    method: "post",
    url: "/counterpartySalesman/queryDefaultSales",
    config: {},
  },
  //资料库商品管理-- 查询
  sysBasicsgoodqueryList: {
    method: "post",
    url: "/sysBasicsgood/queryList",
    config: {},
  },
  //资料库商品管理-- 新增
  sysBasicsgoodadd: {
    method: "post",
    url: "/sysBasicsgood/add",
    config: {},
  },
  //资料库商品管理-- 更新
  sysBasicsgoodupdate: {
    method: "post",
    url: "/sysBasicsgood/update",
    config: {},
  },
  //资料库商品管理-- 删除
  sysBasicsgooddelete: {
    method: "post",
    url: "/sysBasicsgood/delete",
    config: {},
  },
  //终端人员账号管理-- 查询
  terminalOperatorquery: {
    method: "post",
    url: "/terminalOperator/query",
    config: {},
  },
  //终端人员账号管理-- 新增
  terminalOperatoradd: {
    method: "post",
    url: "/terminalOperator/add",
    config: {},
  },
  //终端人员账号管理-- 修改
  terminalOperatormodify: {
    method: "post",
    url: "/terminalOperator/modify",
    config: {},
  },
  //终端人员账号管理-- 删除
  terminalOperatordelete: {
    method: "post",
    url: "/terminalOperator/delete",
    config: {},
  },
  //终端人员账号管理-- 停用/启用
  terminalOperatortoggleState: {
    method: "post",
    url: "/terminalOperator/toggleState",
    config: {},
  },
  //终端人员账号管理-- 修改密码
  terminalOperatorupdatePassword: {
    method: "post",
    url: "/terminalOperator/updatePassword",
    config: {},
  },
  //终端公司管理-- 查询
  terminalCompanyquery: {
    method: "post",
    url: "/terminalCompany/query",
    config: {},
  },
  //终端公司管理-- 新增
  terminalCompanyadd: {
    method: "post",
    url: "/terminalCompany/add",
    config: {},
  },
  //终端公司管理-- 修改
  terminalCompanymodify: {
    method: "post",
    url: "/terminalCompany/modify",
    config: {},
  },
  //终端公司管理-- 删除
  terminalCompanydelete: {
    method: "post",
    url: "/terminalCompany/delete",
    config: {},
  },
  //终端公司管理-- 停用/启用
  terminalCompanytoggleState: {
    method: "post",
    url: "/terminalCompany/toggleState",
    config: {},
  },
  //终端人员账号管理-- 查询所有权限
  terminalMenuqueryAllTree: {
    method: "post",
    url: "/terminalMenu/queryAllTree",
    config: {},
  },
  //终端人员账号管理-- 查询人员已绑定的菜单ID列表
  terminalMenuqueryBoundMenuIds: {
    method: "post",
    url: "/terminalMenu/queryBoundMenuIds",
    config: {},
  },
  //终端人员账号管理-- 绑定权限
  terminalMenubindMenus: {
    method: "post",
    url: "/terminalMenu/bindMenus",
    config: {},
  },
  //终端公司线路-查询所有
  terminalLinequeryAll: {
    method: "post",
    url: "/terminalLine/queryAll",
    config: {},
  },
  //终端公司线路-新增
  terminalLineadd: {
    method: "post",
    url: "/terminalLine/add",
    config: {},
  },
  //终端公司线路-修改
  terminalLinemodify: {
    method: "post",
    url: "/terminalLine/modify",
    config: {},
  },
  //终端公司线路-删除
  terminalLinedelete: {
    method: "post",
    url: "/terminalLine/delete",
    config: {},
  },
  //终端公司线路-查询明细
  lineDetailqueryByLineId: {
    method: "post",
    url: "/lineDetail/queryByLineId",
    config: {},
  },
  //终端公司线路-明细新增
  lineDetailadd: {
    method: "post",
    url: "/lineDetail/add",
    config: {},
  },
  //终端公司线路-明细修改
  lineDetailmodify: {
    method: "post",
    url: "/lineDetail/modify",
    config: {},
  },
  //终端公司线路-明细删除
  lineDetaildelete: {
    method: "post",
    url: "/lineDetail/delete",
    config: {},
  },
  //数据流任务-查询
  dataflowpending: {
    method: "post",
    url: "/dataflow/pending",
    config: {},
  },
  //数据流任务-重试
  dataflowexecute: {
    method: "post",
    url: "/dataflow/execute",
    config: {},
  },
  //自动打印-查询销售出库记账历史列表
  woApplyqueryWoBkeHis: {
    method: "post",
    url: "/woApply/queryWoBkeHis",
    config: {},
  },
  //自动打印-查询配置设置
  woApplygetWoPrintConfig: {
    method: "post",
    url: "/woApply/getWoPrintConfig",
    config: {},
  },
  //自动打印-修改配置设置
  woApplysetWoPrintConfig: {
    method: "post",
    url: "/woApply/setWoPrintConfig",
    config: {},
  },
  //-根据品种和供应商查询确认wes订单明细信息
  pisplanorderwesDetailQuery: {
    method: "post",
    url: "/pisplanorder/wesDetailQuery",
    config: {},
  },
  //匹配wes订单明细信息
  pisplanordermatchWesDetail: {
    method: "post",
    url: "/pisplanorder/matchWesDetail",
    config: {},
  },
  //扫码监控--查询上传信息
  wesMonitorqueryList: {
    method: "post",
    url: "/wesMonitor/queryList",
    config: {},
  },
  //扫码监控--更新单位
  wesMonitorupdatePlname: {
    method: "post",
    url: "/wesMonitor/updatePlname",
    config: {},
  },
   //扫码监控--更新状态
  wesMonitorupdateState: {
    method: "post",
    url: "/wesMonitor/updateState",
    config: {},
  },
  //扫码任务--查询
  wesMonitorqueryScanTask: {
    method: "post",
    url: "/wesMonitor/queryScanTask",
    config: {},
  },
  //扫码任务--取消
  wesMonitorcancelScan: {
    method: "post",
    url: "/wesMonitor/cancelScan",
    config: {},
  },
  //扫码任务--查看监管码
  wesMonitorqueryScanCode: {
    method: "post",
    url: "/wesMonitor/queryScanCode",
    config: {},
  },
  //终端公司价格维护--查询
  terminalCompanyPricequery: {
    method: "post",
    url: "/terminalCompanyPrice/query",
    config: {},
  },
  //终端公司价格维护--新增
  terminalCompanyPriceadd: {
    method: "post",
    url: "/terminalCompanyPrice/add",
    config: {},
  },
  //终端公司价格维护--修改
  terminalCompanyPricemodify: {
    method: "post",
    url: "/terminalCompanyPrice/modify",
    config: {},
  },
  //终端公司价格维护--删除
  terminalCompanyPricedelete: {
    method: "post",
    url: "/terminalCompanyPrice/delete",
    config: {},
  },
  //客户销售目标--查询
  cusPlanqueryList: {
    method: "post",
    url: "/cusplan/queryList",
    config: {},
  },
  //客户销售目标--新增
  cusPlanadd: {
    method: "post",
    url: "/cusplan/add",
    config: {},
  },
  //客户销售目标--修改
  cusPlanupdate: {
    method: "post",
    url: "/cusplan/update",
    config: {},
  },
  //客户销售目标--删除
  cusPlandelete: {
    method: "post",
    url: "/cusplan/delete",
    config: {},
  },
  //集采平台订单--查询
  orderpoolqueryJcOrder: {
    method: "post",
    url: "/orderpool/queryJcOrder",
    config: {},
  },
  //集采平台订单--查询明细
  orderpoolqueryJcDetail: {
    method: "post",
    url: "/orderpool/queryJcDetail",
    config: {},
  },
  //集采平台订单--明细绑定集采编码
  orderpoolbindJcCode: {
    method: "post",
    url: "/orderpool/bindJcCode",
    config: {},
  },
  //集采平台订单--绑定客户集采编码
  orderpoolbindJcUnitCode: {
    method: "post",
    url: "/orderpool/bindJcUnitCode",
    config: {},
  },
  //复方制剂控销--查询
  prepaircontrolquery: {
    method: "post",
    url: "/prepaircontrol/query",
    config: {},
  },
  //复方制剂控销--详情
  prepaircontroldetail: {
    method: "post",
    url: "/prepaircontrol/detail",
    config: {},
  },
  //复方制剂控销--新增
  prepaircontroladd: {
    method: "post",
    url: "/prepaircontrol/add",
    config: {},
  },
  //复方制剂控销--修改
  prepaircontrolupdate: {
    method: "post",
    url: "/prepaircontrol/update",
    config: {},
  },
  //复方制剂控销--删除
  prepaircontroldelete: {
    method: "post",
    url: "/prepaircontrol/delete",
    config: {},
  },
  //临时证照审批--查询任务单据
  licenseExpiqueryTask: {
    method: "post",
    url: "/licenseExpi/queryTask",
    config: {},
  },
  //临时证照审批--查询历史单据
  licenseExpiqueryHistory: {
    method: "post",
    url: "/licenseExpi/queryHistory",
    config: {},
  },
  //临时证照审批--新增
  licenseExpiadd: {
    method: "post",
    url: "/licenseExpi/add",
    config: {},
  },
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  //----------------------------关于零售接口-----------------------------------------------------------------------------------------------------
  // 获取当前成本
  retailgetCurCb: {
    method: "post",
    url: "/retail/getCurCb",
    config: {},
  },
  // 更新当前成本
  retailchangeCurCb: {
    method: "post",
    url: "/retail/changeCurCb",
    config: {},
  },
  // 查询门店
  queryStoremasts: {
    method: "post",
    url: "/storemast/query",
    config: {},
  },
  // 查询门店详情
  queryDetail: {
    method: "post",
    url: "/storemast/queryDetail",
    config: {},
  },
  // 查询门店详情
  queryDetail: {
    method: "post",
    url: "/storemast/queryDetail",
    config: {},
  },
  // 新增门店
  addstore: {
    method: "post",
    url: "/storemast/addstore",
    config: {},
  },
  // 修改门店
  updatestore: {
    method: "post",
    url: "/storemast/updatestore",
    config: {},
  },
  //删除门店
  delstore: {
    method: "post",
    url: "/storemast/delstore",
    config: {},
  },
  // 查询当前门店绑定的人员
  queryStoreBindUser: {
    method: "post",
    url: "/storemast/queryStoreBindUser",
    config: {},
  },
  // 查询当前门店没有绑定的人员
  queryStoreNoBindUser: {
    method: "post",
    url: "/storemast/queryStoreNoBindUser",
    config: {},
  },
  // 门店绑定人员
  addstoreOper: {
    method: "post",
    url: "/storemast/addstoreOper",
    config: {},
  },
  // 门店删除绑定人员
  delstoreOper: {
    method: "post",
    url: "/storemast/delstoreOper",
    config: {},
  },
  //   停用门店
  disableStore: {
    method: "post",
    url: "/storemast/disableStore",
    config: {},
  },
  //  获取当前人员绑定门店
  storemastgetCurStore: {
    method: "post",
    url: "/storemast/getCurStore",
    config: {},
  },
  //  门店执业药师--加价率列表
  storemastgetDoctorAddRate: {
    method: "post",
    url: "/storemast/getDoctorAddRate",
    config: {},
  },
  //  门店执业药师--维护加价率
  storemastsetDoctorAddRate: {
    method: "post",
    url: "/storemast/setDoctorAddRate",
    config: {},
  },
  //   查询收款台列表
  queryCashDeskList: {
    method: "post",
    url: "/cashdesk/queryList",
    config: {},
  },
  //   新增收款台
  addcashdesk: {
    method: "post",
    url: "/cashdesk/addcashdesk",
    config: {},
  },
  //   删除收款台
  delcashdesk: {
    method: "post",
    url: "/cashdesk/delcashdesk",
    config: {},
  },
  //   修改收款台
  updcashdesk: {
    method: "post",
    url: "/cashdesk/updcashdesk",
    config: {},
  },

  //   查询收款台绑定账簿
  queryCashdeskBook: {
    method: "post",
    url: "/cashdesk/queryCashdeskBook",
    config: {},
  },
  //   查询账簿
  queryLsAbook: {
    method: "post",
    url: "/cashdesk/queryLsAbook",
    config: {},
  },
  //   新增收款台绑定账簿
  addCashdeskBook: {
    method: "post",
    url: "/cashdesk/addCashdeskBook",
    config: {},
  },
  //   删除收款台绑定账簿
  delCashdeskBook: {
    method: "post",
    url: "/cashdesk/delCashdeskBook",
    config: {},
  },

  // 查询调拨出库列表，初始和驳回单据
  moveOutAdd: {
    method: "post",
    url: "/dera/moveOut/add",
    config: {},
  },
  // 添加调拨出库单据
  moveOutQueryInit: {
    method: "post",
    url: "/dera/moveOut/queryInit",
    config: {},
  },
  // 删除调拨出库单据
  moveOutDelete: {
    method: "post",
    url: "/dera/moveOut/delete",
    config: {},
  },
  // 修改调拨出库单据
  moveOutModifyMaster: {
    method: "post",
    url: "/dera/moveOut/modifyMaster",
    config: {},
  },
  // 提交调拨出库单据
  moveOutSubmitAudit: {
    method: "post",
    url: "/dera/moveOut/submitAudit",
    config: {},
  },
  //   查询调拨出库列表，任务单据
  moveOutQueryTask: {
    method: "post",
    url: "/dera/moveOut/queryTask",
    config: {},
  },
  // 查询调拨出库列表，历史单据
  moveOutQueryHis: {
    method: "post",
    url: "/dera/moveOut/queryHis",
    config: {},
  },
  // 关闭调拨出库
  moveOutClose: {
    method: "post",
    url: "/dera/moveOut/close",
    config: {},
  },
  // 查询调拨入库列表，初始和驳回单据
  inQueryInit: {
    method: "post",
    url: "/dera/moveIn/queryInit",
    config: {},
  },
  // 查询调拨入库列表，任务单据
  inQueryTask: {
    method: "post",
    url: "/dera/moveIn/queryTask",
    config: {},
  },

  // 删除调拨入库单据
  inDelete: {
    method: "post",
    url: "/dera/moveIn/delete",
    config: {},
  },
  // 提交调拨入库单据
  inSubmitAudit: {
    method: "post",
    url: "/dera/moveIn/submitAudit",
    config: {},
  },
  // 添加调拨入库单据
  inAdd: {
    method: "post",
    url: "/dera/moveIn/add",
    config: {},
  },
  // 修改调拨入库单据
  inmodifyMaster: {
    method: "post",
    url: "/dera/moveIn/modifyMaster",
    config: {},
  },
  // 查询卡类型列表
  queryMemCardType: {
    method: "post",
    url: "/member/queryMemCardType",
    config: {},
  },
  // 新增卡类型
  addCardType: {
    method: "post",
    url: "/member/addCardType",
    config: {},
  },
  // 修改卡类型
  updateCardType: {
    method: "post",
    url: "/member/updateCardType",
    config: {},
  },
  // 删除卡类型
  delCardType: {
    method: "post",
    url: "/member/delCardType",
    config: {},
  },

  // 查询会员卡列表
  queryMembermastList: {
    method: "post",
    url: "/member/queryMembermastList",
    config: {},
  },
  // 新增会员卡
  addMembermast: {
    method: "post",
    url: "/member/addMembermast",
    config: {},
  },
  // 删除会员卡
  delMembermast: {
    method: "post",
    url: "/member/delMembermast",
    config: {},
  },
  // 修改会员卡
  updMembermast: {
    method: "post",
    url: "/member/updMembermast",
    config: {},
  },
  // 查询方案列表
  getPlanList: {
    method: "post",
    url: "/sellPlan/getPlanList",
    config: {},
  },
  // 新增促销方案
  addSellPlan: {
    method: "post",
    url: "/sellPlan/addSellPlan",
    config: {},
  },
  // 更新促销方案
  updateSellPlan: {
    method: "post",
    url: "/sellPlan/updateSellPlan",
    config: {},
  },
  // 查询方案明细
  getPlanDetail: {
    method: "post",
    url: "/sellPlan/getPlanDetail",
    config: {},
  },
  // 删除促销方案
  delSellPlan: {
    method: "post",
    url: "/sellPlan/delSellPlan",
    config: {},
  },
  // 查询方案已绑定的门店列表
  getBindList: {
    method: "post",
    url: "/sellPlan/getBindList",
    config: {},
  },
  // 查询所有门店
  storemastQueryAll: {
    method: "post",
    url: "/storemast/queryAll",
    config: {},
  },
  // 门店绑定方案
  bindPlan: {
    method: "post",
    url: "/sellPlan/bindPlan",
    config: {},
  },
  // 查询价格组
  groupQuery: {
    method: "post",
    url: "/priceGroup/groupQuery",
    config: {},
  },
  // 查询价格组下商品
  bgmPriceGroupQuery: {
    method: "post",
    url: "/priceGroup/bgmPriceGroupQuery",
    config: {},
  },
  // 新增价格组
  groupAdd: {
    method: "post",
    url: "/priceGroup/groupAdd",
    config: {},
  },
  // 修改价格组
  groupUpdate: {
    method: "post",
    url: "/priceGroup/groupUpdate",
    config: {},
  },
  // 删除价格组
  groupDel: {
    method: "post",
    url: "/priceGroup/groupDel",
    config: {},
  },
  // 删除商品价格组信息
  bgmPriceGroupDelete: {
    method: "post",
    url: "/priceGroup/bgmPriceGroupDelete",
    config: {},
  },
  // 初始化未设置价格的商品
  initPriceGroup: {
    method: "post",
    url: "/priceGroup/initPriceGroup",
    config: {},
  },
  // 修改商品价格组信息
  bgmPriceGroupUpdate: {
    method: "post",
    url: "/priceGroup/bgmPriceGroupUpdate",
    config: {},
  },
    // 批量修改商品价格组信息
  priceGroupBgmPriceGroupBatchUpdate: {
    method: "post",
    url: "/priceGroup/bgmPriceGroupBatchUpdate",
    config: {},
  },


  // 查询零售商品信息
  getRetailBgmInfo: {
    method: "post",
    url: "/priceGroup/getRetailBgmInfo",
    config: {},
  },
  // 增加单品特价明细
  addSpDetail: {
    method: "post",
    url: "/sellPlan/addSpDetail",
    config: {},
  },
  //删除单品特价明细
  delSpDetail: {
    method: "post",
    url: "/sellPlan/delSpDetail",
    config: {},
  },
  //更新单品特价明细
  updateSpDetail: {
    method: "post",
    url: "/sellPlan/updateSpDetail",
    config: {},
  },
  //查询当前人员绑定的门店信息
  getCurStoreInfo: {
    method: "post",
    url: "/storemast/getCurStoreInfo",
    config: {},
  },
  //查询流水
  getRecord: {
    method: "post",
    url: "/memRecharge/getRecord",
    config: {},
  },
  //查询流水
  getIntegralRecord: {
    method: "post",
    url: "/memRedeem/getRecord",
    config: {},
  },
  //获取商品可参与的方案
  checkBgmPlan: {
    method: "post",
    url: "/sellPlan/checkBgmPlan",
    config: {},
  },
  //检查整单可参与的方案
  checkOrderPlan: {
    method: "post",
    url: "/sellPlan/checkOrderPlan",
    config: {},
  },
  //添加门店零售单据
  retailAdd: {
    method: "post",
    url: "/retail/add",
    config: {},
  },
  //新增收款台绑定人员
  addCashdeskMem: {
    method: "post",
    url: "/cashdesk/addCashdeskMem",
    config: {},
  },
  //查询收款台绑定人员
  queryCashdeskMem: {
    method: "post",
    url: "/cashdesk/queryCashdeskMem",
    config: {},
  },
  //更新付款密码
  updatePassword: {
    method: "post",
    url: "/member/updatePassword",
    config: {},
  },
  // 会员储值充值
  memRechargeRecharge: {
    method: "post",
    url: "/memRecharge/recharge",
    config: {},
  },
  // 修改余额
  memRechargechange: {
    method: "post",
    url: "/memRecharge/change",
    config: {},
  },
  // 查询门店零售列表
  retailQuery: {
    method: "post",
    url: "/retail/query",
    config: {},
  },
  // 查询商品拆分列表，初始和驳回单据
  splitQueryInit: {
    method: "post",
    url: "/split/queryInit",
    config: {},
  },
  // 删除商品拆分单据
  splitDelete: {
    method: "post",
    url: "/split/delete",
    config: {},
  },
  // 提交商品拆分单据
  splitSubmitAudit: {
    method: "post",
    url: "/split/submitAudit",
    config: {},
  },
  // 添加商品拆分单据
  splitAdd: {
    method: "post",
    url: "/split/addSplit",
    config: {},
  },
  // 修改商品拆分单据
  splitModifyMaster: {
    method: "post",
    url: "/split/modifyMaster",
    config: {},
  },
  // 查询商品拆分列表，任务单据
  splitQueryTask: {
    method: "post",
    url: "/split/queryTask",
    config: {},
  },
  // 查询商品拆分列表，历史单据
  splitQueryHis: {
    method: "post",
    url: "/split/queryHis",
    config: {},
  },
  // 查询方案任务列表
  getPlanListTask: {
    method: "post",
    url: "/sellPlan/getPlanListTask",
    config: {},
  },
  // 提交单据
  sellPlanSubmitAudit: {
    method: "post",
    url: "/sellPlan/submitAudit",
    config: {},
  },// 查询促销历史
  getPlanListHistory: {
    method: "post",
    url: "/sellPlan/getPlanListHistory",
    config: {},
  },
  // 更新方案状态
  sellPlanUpdateState: {
    method: "post",
    url: "/sellPlan/setState",
    config: {},
  },
  // 查询分类列表
  getTypeList: {
    method: "post",
    url: "/deraBgmType/getTypeList",
    config: {},
  },
  // 新增分类
  deraBgmTypeAdd: {
    method: "post",
    url: "/deraBgmType/addType",
    config: {},
  },
  // 修改分类
  deraBgmTypeUpdate: {
    method: "post",
    url: "/deraBgmType/updateType",
    config: {},
  },
  // 删除分类
  deraBgmTypeDelete: {
    method: "post",
    url: "/deraBgmType/delType",
    config: {},
  },
  // 查询分类明细列表
  getDetailList: {
    method: "post",
    url: "/deraBgmType/getDetailList",
    config: {},
  },
  // 方案查询商品列表
  getBgmListByType: {
    method: "post",
    url: "/deraBgmType/getBgmListByType",
    config: {},
  },
  // 新增分类明细
  deraBgmTypeAddDetail: {
    method: "post",
    url: "/deraBgmType/addDetail",
    config: {},
  },
  // 删除分类明细
  deraBgmTypeDelDetail: {
    method: "post",
    url: "/deraBgmType/delDetail",
    config: {},
  },
  // 查询优惠券列表
  getYhqList: {
    method: "post",
    url: "/deraYhq/getYhqList",
    config: {},
  },
  // 删除优惠券
  deraYhqDelYhq: {
    method: "post",
    url: "/deraYhq/delYhq",
    config: {},
  },
  // 查询优惠券明细
  getYhqDetail: {
    method: "post",
    url: "/deraYhq/getYhqDetail",
    config: {},
  },
  // 新增优惠券
  deraYhqAddYhq: {
    method: "post",
    url: "/deraYhq/addYhq",
    config: {},
  },
  // 更新优惠券
  deraYhqUpdateYhq: {
    method: "post",
    url: "/deraYhq/updateYhq",
    config: {},
  },
  // 优惠券提交单据
  deraYhqSubmitAudit: {
    method: "post",
    url: "/deraYhq/submitAudit",
    config: {},
  },
  // 查询优惠券任务列表
  getYhqListTask: {
    method: "post",
    url: "/deraYhq/getYhqListTask",
    config: {},
  },
  // 查询优惠券历史列表
  getYhqListHistory: {
    method: "post",
    url: "/deraYhq/getYhqListHistory",
    config: {},
  },
  // 获取商品可用方案
  checkBgmAblePlan: {
    method: "post",
    url: "/sellPlan/checkBgmAblePlan",
    config: {},
  },
  // 获取商品可参与的方案
  sellPlanCheckBgmPlan: {
    method: "post",
    url: "/sellPlan/checkBgmPlan",
    config: {},
  },
  // 获取全部商品可参与的方案
  sellPlanCheckAllBgmPlan: {
    method: "post",
    url: "/sellPlan/checkAllBgmPlan",
    config: {},
  },
  // 获取整单可参与的方案
  sellPlanCheckOrderPlan: {
    method: "post",
    url: "/sellPlan/checkOrderPlan",
    config: {},
  },
  // 方案商品批号
  getBgmBatchNo: {
    method: "post",
    url: "/deraBgmType/getBgmBatchNo",
    config: {},
  },
  // 计算整单优惠，分摊金额、应用折扣
  calculateOrderPrice: {
    method: "post",
    url: "/sellPlan/calculateOrderPrice",
    config: {},
  },
  // 查询会员优惠券
  getMemYhq: {
    method: "post",
    url: "/deraYhq/getMemYhq",
    config: {},
  },
  // 获取整单可参与的优惠券
  checkOrderYhq: {
    method: "post",
    url: "/sellPlan/checkOrderYhq",
    config: {},
  },
  // 调拨出库复核 复核列表
  moveOutQueryRc: {
    method: "post",
    url: "/dera/moveOut/queryRc",
    config: {},
  },
  // 调拨出库复核 复核新增
  moveOutAddRc: {
    method: "post",
    url: "/dera/moveOut/addRc",
    config: {},
  },
  // 调拨出库记账 批量记账
  moveOutBatchBke: {
    method: "post",
    url: "/dera/moveOut/batchBke",
    config: {},
  },
  // 调拨出库记账历史 记账列表
  moveOutQueryBke: {
    method: "post",
    url: "/dera/moveOut/queryBke",
    config: {},
  },
  // 查询调拨入库列表，初始和驳回单据
  moveInQueryInit: {
    method: "post",
    url: "/dera/moveIn/queryInit",
    config: {},
  },
  // 查询调拨入库列表，任务单据
  moveInQueryTask: {
    method: "post",
    url: "/dera/moveIn/queryTask",
    config: {},
  },
  // 查询调拨入库列表，历史单据
  moveInQueryHis: {
    method: "post",
    url: "/dera/moveIn/queryHis",
    config: {},
  },
  // 添加调拨入库单据
  moveInAdd: {
    method: "post",
    url: "/dera/moveIn/add",
    config: {},
  },
  // 修改调拨入库单据
  moveInModifyMaster: {
    method: "post",
    url: "/dera/moveIn/modifyMaster",
    config: {},
  },
  // 删除调拨入库单据
  moveInDelete: {
    method: "post",
    url: "/dera/moveIn/delete",
    config: {},
  },
  // 提交调拨入库单据
  moveInSubmitAudit: {
    method: "post",
    url: "/dera/moveIn/submitAudit",
    config: {},
  },
  // 提交调拨入库单据
  moveInSubmitAudit: {
    method: "post",
    url: "/dera/moveIn/submitAudit",
    config: {},
  },
  // 查询入库收货单列表
  moveInQueryCa: {
    method: "post",
    url: "/dera/moveIn/queryCa",
    config: {},
  },
  // 删除入库收货单
  moveInDeleteCa: {
    method: "post",
    url: "/dera/moveIn/deleteCa",
    config: {},
  },
  // 提交入库收货单
  moveInSubmitCa: {
    method: "post",
    url: "/dera/moveIn/submitCa",
    config: {},
  },
  // 新增入库收货单
  moveInAddCa: {
    method: "post",
    url: "/dera/moveIn/addCa",
    config: {},
  },
  // 修改入库收货单
  moveInUpdateCa: {
    method: "post",
    url: "/dera/moveIn/updateCa",
    config: {},
  },
  // 查询入库验收单列表
  moveInQueryTo: {
    method: "post",
    url: "/dera/moveIn/queryTo",
    config: {},
  },
  // 查询入库记账单列表
  moveInBkeQueryTo: {
    method: "post",
    url: "/dera/moveIn/bkeQueryTo",
    config: {},
  },
  // 新增入库验收单
  moveInAddTo: {
    method: "post",
    url: "/dera/moveIn/addTo",
    config: {},
  },
  // 修改入库验收单
  moveInUpdateTo: {
    method: "post",
    url: "/dera/moveIn/updateTo",
    config: {},
  },
  // 删除入库验收单
  moveInDeleteTo: {
    method: "post",
    url: "/dera/moveIn/deleteTo",
    config: {},
  },
  // 提交入库验收单
  moveInSubmitTo: {
    method: "post",
    url: "/dera/moveIn/submitTo",
    config: {},
  },
  // 查询入库记账列表
  moveInQueryBke: {
    method: "post",
    url: "/dera/moveIn/queryBke",
    config: {},
  },
  // 入库记账  批量记账
  moveInBatchBke: {
    method: "post",
    url: "/dera/moveIn/batchBke",
    config: {},
  },
  // 新增采购计划
  pisplanorderAddPisPlan: {
    method: "post",
    url: "/pisplanorder/addPisPlan",
    config: {},
  },
  // 修改采购计划
  pisplanorderUpdatePisPlan: {
    method: "post",
    url: "/pisplanorder/updatePisPlan",
    config: {},
  },
  // 删除采购计划
  pisplanorderDelPisPlan: {
    method: "post",
    url: "/pisplanorder/delPisPlan",
    config: {},
  },
  // 采购批量打印查询
  pisplanorderqueryBatchPrintList: {
    method: "post",
    url: "/pisplanorder/queryBatchPrintList",
    config: {},
  },
  // 修改采购计划退补时间
  pisplanorderUpdateRrOrderTime: {
    method: "post",
    url: "/pisplanorder/updateRrOrderTime",
    config: {},
  },
  // 修改销售计划退补时间
  woApplyUpdateRrTime: {
    method: "post",
    url: "/woApply/updateRrTime",
    config: {},
  },
  // 填写销毁回执
  submitReport: {
    method: "post",
    url: "/Desunqua/submitReport",
    config: {},
  },
  // 查询门店请货初始和驳回单据
  applyGoodsQueryInit: {
    method: "post",
    url: "/dera/applyGoods/queryInit",
    config: {},
  },
  // 查询门店请货任务单据
  applyGoodsQueryTask: {
    method: "post",
    url: "/dera/applyGoods/queryTask",
    config: {},
  },
  // 查询门店请货历史单据
  applyGoodsQueryHis: {
    method: "post",
    url: "/dera/applyGoods/queryHis",
    config: {},
  },
  // 添加门店请货单据
  applyGoodsAdd: {
    method: "post",
    url: "/dera/applyGoods/add",
    config: {},
  },
  // 修改门店请货单据
  applyGoodsUpdate: {
    method: "post",
    url: "/dera/applyGoods/update",
    config: {},
  },
  // 删除门店请货单据
  applyGoodsDelete: {
    method: "post",
    url: "/dera/applyGoods/delete",
    config: {},
  },
  // 提交门店请货单据
  applyGoodsSubmit: {
    method: "post",
    url: "/dera/applyGoods/submit",
    config: {},
  },
  // 生成请货单
  applyGoodsgenOrder: {
    method: "post",
    url: "/dera/applyGoods/genOrder",
    config: {},
  },
  // 查询配送出库列表，初始和驳回单据
  deliveryOutQueryInit: {
    method: "post",
    url: "/dera/deliveryOut/queryInit",
    config: {},
  },
  // 查询配送出库列表，任务单据
  deliveryOutQueryTask: {
    method: "post",
    url: "/dera/deliveryOut/queryTask",
    config: {},
  },
  // 查询配送出库列表，历史单据
  deliveryOutQueryHis: {
    method: "post",
    url: "/dera/deliveryOut/queryHis",
    config: {},
  },
  // 添加配送出库单据
  deliveryOutAdd: {
    method: "post",
    url: "/dera/deliveryOut/add",
    config: {},
  },
  // 修改配送出库单据
  deliveryOutUpdate: {
    method: "post",
    url: "/dera/deliveryOut/update",
    config: {},
  },
  // 删除配送出库单据
  deliveryOutDelete: {
    method: "post",
    url: "/dera/deliveryOut/delete",
    config: {},
  },
  //提交配送出库单据
  deliveryOutSubmit: {
    method: "post",
    url: "/dera/deliveryOut/submit",
    config: {},
  },
  //查询当前人员所属门店
  storemastGetCurStore: {
    method: "post",
    url: "/storemast/getCurStore",
    config: {},
  },
  //复核列表
  deliveryOutQueryCheck: {
    method: "post",
    url: "/dera/deliveryOut/queryCheck",
    config: {},
  },
  //复核新增
  deliveryOutAddCheck: {
    method: "post",
    url: "/dera/deliveryOut/addCheck",
    config: {},
  },
  //记账列表
  deliveryOutQueryBke: {
    method: "post",
    url: "/dera/deliveryOut/queryBke",
    config: {},
  },
  //批量记账
  deliveryOutBatchBke: {
    method: "post",
    url: "/dera/deliveryOut/batchBke",
    config: {},
  },
  //总部库存流水页面
  deliveryOutzbStockRecord: {
    method: "post",
    url: "/dera/deliveryOut/zbStockRecord",
    config: {},
  },
  //查询配送入库列表，初始和驳回单据
  deliveryInQueryInit: {
    method: "post",
    url: "/dera/deliveryIn/queryInit",
    config: {},
  },
  //查询配送入库列表，任务单据
  deliveryInQueryTask: {
    method: "post",
    url: "/dera/deliveryIn/queryTask",
    config: {},
  },
  //查询配送入库列表，历史单据
  deliveryInQueryHis: {
    method: "post",
    url: "/dera/deliveryIn/queryHis",
    config: {},
  },
  //添加配送入库单据
  deliveryInAdd: {
    method: "post",
    url: "/dera/deliveryIn/add",
    config: {},
  },
  //修改配送入库单据
  deliveryInModifyMaster: {
    method: "post",
    url: "/dera/deliveryIn/modifyMaster",
    config: {},
  },
  //删除配送入库单据
  deliveryInDelete: {
    method: "post",
    url: "/dera/deliveryIn/delete",
    config: {},
  },
  //提交配送入库单据
  deliveryInSubmitAudit: {
    method: "post",
    url: "/dera/deliveryIn/submitAudit",
    config: {},
  },
  //查询入库收货单列表
  deliveryInQueryCa: {
    method: "post",
    url: "/dera/deliveryIn/queryCa",
    config: {},
  },
  //添加入库收货单
  deliveryInAddCa: {
    method: "post",
    url: "/dera/deliveryIn/addCa",
    config: {},
  },
  //修改入库收货单
  deliveryInUpdateCa: {
    method: "post",
    url: "/dera/deliveryIn/updateCa",
    config: {},
  },
  //删除入库收货单
  deliveryInDeleteCa: {
    method: "post",
    url: "/dera/deliveryIn/deleteCa",
    config: {},
  },
  //提交入库收货单
  deliveryInSubmitCa: {
    method: "post",
    url: "/dera/deliveryIn/submitCa",
    config: {},
  },
  //查询入库验收单列表
  deliveryInQueryTo: {
    method: "post",
    url: "/dera/deliveryIn/queryTo",
    config: {},
  },
  //新增入库验收单
  deliveryInAddTo: {
    method: "post",
    url: "/dera/deliveryIn/addTo",
    config: {},
  },
  //修改入库验收单
  deliveryInUpdateTo: {
    method: "post",
    url: "/dera/deliveryIn/updateTo",
    config: {},
  },
  //提交入库验收单
  deliveryInSubmitTo: {
    method: "post",
    url: "/dera/deliveryIn/submitTo",
    config: {},
  },
  //删除入库验收单
  deliveryInDeleteTo: {
    method: "post",
    url: "/dera/deliveryIn/deleteTo",
    config: {},
  },
  //记账查询入库验收单列表
  deliveryInBkeQueryTo: {
    method: "post",
    url: "/dera/deliveryIn/bkeQueryTo",
    config: {},
  },
  //记账列表
  deliveryInQueryBke: {
    method: "post",
    url: "/dera/deliveryIn/queryBke",
    config: {},
  },
  //批量记账
  deliveryInBatchBke: {
    method: "post",
    url: "/dera/deliveryIn/batchBke",
    config: {},
  },
  //查询退货出库列表，初始和驳回单据
  rejectedOutQueryInit: {
    method: "post",
    url: "/dera/rejectedOut/queryInit",
    config: {},
  },
  //查询退货出库列表，任务单据
  rejectedOutQueryTask: {
    method: "post",
    url: "/dera/rejectedOut/queryTask",
    config: {},
  },
  //查询退货出库列表，历史单据
  rejectedOutQueryHis: {
    method: "post",
    url: "/dera/rejectedOut/queryHis",
    config: {},
  },
  //添加退货出库单据
  rejectedOutAdd: {
    method: "post",
    url: "/dera/rejectedOut/add",
    config: {},
  },
  //修改退货出库单据
  rejectedOutUpdate: {
    method: "post",
    url: "/dera/rejectedOut/update",
    config: {},
  },
  //删除退货出库单据
  rejectedOutDelete: {
    method: "post",
    url: "/dera/rejectedOut/delete",
    config: {},
  },
  //提交退货出库单据
  rejectedOutSubmit: {
    method: "post",
    url: "/dera/rejectedOut/submit",
    config: {},
  },
  //复核列表
  rejectedOutQueryCheck: {
    method: "post",
    url: "/dera/rejectedOut/queryCheck",
    config: {},
  },
  //复核新增
  rejectedOutAddCheck: {
    method: "post",
    url: "/dera/rejectedOut/addCheck",
    config: {},
  },
  //批量记账
  rejectedOutBatchBke: {
    method: "post",
    url: "/dera/rejectedOut/batchBke",
    config: {},
  },
  //记账列表
  rejectedOutQueryBke: {
    method: "post",
    url: "/dera/rejectedOut/queryBke",
    config: {},
  },
  //查询退货入库列表，初始和驳回单据
  rejectedInQueryInit: {
    method: "post",
    url: "/dera/rejectedIn/queryInit",
    config: {},
  },
  //查询退货入库列表，任务单据
  rejectedInQueryTask: {
    method: "post",
    url: "/dera/rejectedIn/queryTask",
    config: {},
  },
  //查询退货入库列表，历史单据
  rejectedInQueryHis: {
    method: "post",
    url: "/dera/rejectedIn/queryHis",
    config: {},
  },
  //添加退货入库单据
  rejectedInAdd: {
    method: "post",
    url: "/dera/rejectedIn/add",
    config: {},
  },
  //修改退货入库单据
  rejectedInModifyMaster: {
    method: "post",
    url: "/dera/rejectedIn/modifyMaster",
    config: {},
  },
  //删除退货入库单据
  rejectedInDelete: {
    method: "post",
    url: "/dera/rejectedIn/delete",
    config: {},
  },
  //提交退货入库单据
  rejectedInSubmitAudit: {
    method: "post",
    url: "/dera/rejectedIn/submitAudit",
    config: {},
  },
  //查询入库收货单列表
  rejectedInQueryCa: {
    method: "post",
    url: "/dera/rejectedIn/queryCa",
    config: {},
  },
  //新增入库收货单
  rejectedInAddCa: {
    method: "post",
    url: "/dera/rejectedIn/addCa",
    config: {},
  },
  //修改入库收货单
  rejectedInUpdateCa: {
    method: "post",
    url: "/dera/rejectedIn/updateCa",
    config: {},
  },
  //删除入库收货单
  rejectedInDeleteCa: {
    method: "post",
    url: "/dera/rejectedIn/deleteCa",
    config: {},
  },
  //提交入库收货单
  rejectedInSubmitCa: {
    method: "post",
    url: "/dera/rejectedIn/submitCa",
    config: {},
  },
  //查询入库验收单列表
  rejectedInQueryTo: {
    method: "post",
    url: "/dera/rejectedIn/queryTo",
    config: {},
  },
  //新增入库验收单
  rejectedInAddTo: {
    method: "post",
    url: "/dera/rejectedIn/addTo",
    config: {},
  },
  //修改入库验收单
  rejectedInUpdateTo: {
    method: "post",
    url: "/dera/rejectedIn/updateTo",
    config: {},
  },
  //删除入库验收单
  rejectedInDeleteTo: {
    method: "post",
    url: "/dera/rejectedIn/deleteTo",
    config: {},
  },
  //提交入库验收单
  rejectedInSubmitTo: {
    method: "post",
    url: "/dera/rejectedIn/submitTo",
    config: {},
  },
  //批量记账
  rejectedInBatchBke: {
    method: "post",
    url: "/dera/rejectedIn/batchBke",
    config: {},
  },
  //记账查询入库验收单列表
  rejectedInBkeQueryTo: {
    method: "post",
    url: "/dera/rejectedIn/bkeQueryTo",
    config: {},
  },
  //记账列表
  rejectedInQueryBke: {
    method: "post",
    url: "/dera/rejectedIn/queryBke",
    config: {},
  },
  //查询请货分摊后结果
  deliveryOutFtList: {
    method: "post",
    url: "/dera/deliveryOut/ftList",
    config: {},
  },
  //查询门店装斗列表
  zdQueryInit: {
    method: "post",
    url: "/dera/zd/queryInit",
    config: {},
  },
  //查询门店装斗历史列表
  zdQueryHis: {
    method: "post",
    url: "/dera/zd/queryHis",
    config: {},
  },
  //添加门店装斗
  zdAdd: {
    method: "post",
    url: "/dera/zd/add",
    config: {},
  },
  //修改门店装斗
  zdUpdate: {
    method: "post",
    url: "/dera/zd/update",
    config: {},
  },
  //删除门店装斗
  zdDelete: {
    method: "post",
    url: "/dera/zd/delete",
    config: {},
  },
  //提交门店装斗
  zdSubmit: {
    method: "post",
    url: "/dera/zd/submit",
    config: {},
  },
  //清斗
  zdQd: {
    method: "post",
    url: "/dera/zd/qd",
    config: {},
  },
  //批量添加门店装斗
  addBatch: {
    method: "post",
    url: "/dera/zd/addBatch",
    config: {},
  },
  //初始化会员价
  initMemPriceGroup: {
    method: "post",
    url: "/priceGroup/initMemPriceGroup",
    config: {},
  },
  //价签打印获取列表
  getStoreBmgList: {
    method: "post",
    url: "/priceGroup/getStoreBmgList",
    config: {},
  },
  //门店打印模板
  updatePrint: {
    method: "post",
    url: "/storemast/updatePrint",
    config: {},
  },
  //收银台打印接口
  retailOrderPrint: {
    method: "post",
    url: "printData/retailOrderPrint",
    config: {},
  },
  //促销回退
  sellPlanRollBack: {
    method: "post",
    url: "sellPlan/rollBack",
    config: {},
  },
  //查询门店装斗复核列表
  zdQueryFh: {
    method: "post",
    url: "/dera/zd/queryFh",
    config: {},
  },
  //查询门店清斗历史列表
  zdQueryQdHis: {
    method: "post",
    url: "/dera/zd/queryQdHis",
    config: {},
  },
  //装斗复核
  zdFh: {
    method: "post",
    url: "/dera/zd/zdFh",
    config: {},
  },
  //查询当前班次数据
  getSummaryByBcCode: {
    method: "post",
    url: "/retail/getSummaryByBcCode",
    config: {},
  },
  //交班
  submitBc: {
    method: "post",
    url: "/retail/submitBc",
    config: {},
  },
  //更新会员卡基础信息
  fixMemberInfo: {
    method: "post",
    url: "/member/fixMemberInfo",
    config: {},
  },
  //收款台直接拆分商品
  directSplit: {
    method: "post",
    url: "/split/directSplit",
    config: {},
  },
  //查询店间调拨初始单据
  storeMoveQueryInit: {
    method: "post",
    url: "/dera/storeMove/queryInit",
    config: {},
  },
  //添加店间调拨单据
  storeMoveAdd: {
    method: "post",
    url: "/dera/storeMove/add",
    config: {},
  },
  //删除店间调拨单据
  storeMoveDelete: {
    method: "post",
    url: "/dera/storeMove/delete",
    config: {},
  },
  //修改店间调拨单据
  storeMoveUpdate: {
    method: "post",
    url: "/dera/storeMove/update",
    config: {},
  },
  //提交店间调拨单据
  storeMoveSubmit: {
    method: "post",
    url: "/dera/storeMove/submit",
    config: {},
  },
  //查询店间调拨历史单据
  storeMoveQueryHis: {
    method: "post",
    url: "/dera/storeMove/queryHis",
    config: {},
  },
  //查询货架列表
  storeShelfGetShelfList: {
    method: "post",
    url: "/storeShelf/getShelfList",
    config: {},
  },
  //查询绑定商品列表
  storeShelfGetBindList: {
    method: "post",
    url: "/storeShelf/getBindList",
    config: {},
  },
  //新增货架
  storeShelfAddShelf: {
    method: "post",
    url: "/storeShelf/addShelf",
    config: {},
  },
  //修改货架
  storeShelfUpdateShelf: {
    method: "post",
    url: "/storeShelf/updateShelf",
    config: {},
  },
  //货架绑定商品
  storeShelfAddBind: {
    method: "post",
    url: "/storeShelf/addBind",
    config: {},
  },
  //解除商品绑定
  storeShelfDelBind: {
    method: "post",
    url: "/storeShelf/delBind",
    config: {},
  },
  //删除货架
  storeShelfDelShelf: {
    method: "post",
    url: "/storeShelf/delShelf",
    config: {},
  },
  //获取养护历史
  storeShelfGetCuringHis: {
    method: "post",
    url: "/storeShelf/getCuringHis",
    config: {},
  },
  //获取待养护列表
  storeShelfGetUnCuringList: {
    method: "post",
    url: "/storeShelf/getUnCuringList",
    config: {},
  },
  //养护登记
  storeShelfAddCuring: {
    method: "post",
    url: "/storeShelf/addCuring",
    config: {},
  },
  //更新养护配置
  storeShelfUpdateCuringSetting: {
    method: "post",
    url: "/storeShelf/updateCuringSetting",
    config: {},
  },
  //获取养护配置
  storeShelfGetCuringSetting: {
    method: "post",
    url: "/storeShelf/getCuringSetting",
    config: {},
  },
  //生成拆零品种
  storeShelfGeneralSpBgm: {
    method: "post",
    url: "/splitSingle/generalSpBgm",
    config: {},
  },
  //收款台直接拆分商品
  splitSingleDirectSplit: {
    method: "post",
    url: "/splitSingle/directSplit",
    config: {},
  },
  //查询商品拆分列表，初始和驳回单据
  splitSingleQueryInit: {
    method: "post",
    url: "/splitSingle/queryInit",
    config: {},
  },
  //查询商品拆分列表，任务单据
  splitSingleQueryTask: {
    method: "post",
    url: "/splitSingle/queryTask",
    config: {},
  },
  //查询商品拆分列表，历史单据
  splitSingleQueryHis: {
    method: "post",
    url: "/splitSingle/queryHis",
    config: {},
  },
  //添加商品拆分单据
  splitSingleAddSplit: {
    method: "post",
    url: "/splitSingle/addSplit",
    config: {},
  },
  //修改商品拆分单据
  splitSingleModifyMaster: {
    method: "post",
    url: "/splitSingle/modifyMaster",
    config: {},
  },
  //删除商品拆分单据
  splitSingleDelete: {
    method: "post",
    url: "/splitSingle/delete",
    config: {},
  },
  //提交商品拆分单据
  splitSingleSubmitAudit: {
    method: "post",
    url: "/splitSingle/submitAudit",
    config: {},
  },
  //回退（合并）
  splitSingleMerge: {
    method: "post",
    url: "/splitSingle/merge",
    config: {},
  },
  //积分维护查询列表
  bgmPointQuery: {
    method: "post",
    url: "/bgmPoint/query",
    config: {},
  },
  //积分维护新增
  bgmPointAdd: {
    method: "post",
    url: "/bgmPoint/add",
    config: {},
  },
  //积分维护修改
  bgmPointUpdate: {
    method: "post",
    url: "/bgmPoint/update",
    config: {},
  },
  //积分维护删除
  bgmPointDelete: {
    method: "post",
    url: "/bgmPoint/del",
    config: {},
  },
  //其他入库   查询列表
  pisOtherQuery: {
    method: "post",
    url: "/pisOther/query",
    config: {},
  },
  //其他入库   查询历史列表
  pisOtherQueryHis: {
    method: "post",
    url: "/pisOther/queryHis",
    config: {},
  },
  //其他入库   新增
  pisOtherAdd: {
    method: "post",
    url: "/pisOther/add",
    config: {},
  },
  //其他入库   修改
  pisOtherUpdate: {
    method: "post",
    url: "/pisOther/modifyMaster",
    config: {},
  },
  //其他入库   删除
  pisOtherDelete: {
    method: "post",
    url: "/pisOther/delete",
    config: {},
  },
  //其他入库   提交审核
  pisOtherSubmitAudit: {
    method: "post",
    url: "/pisOther/submitAudit",
    config: {},
  },
  //积分兑换   提交审核
  memRedeemRedeem: {
    method: "post",
    url: "/memRedeem/redeem",
    config: {},
  },
  //方案查询商品列表（包含其他类型商品）
  deraBgmTypeGetOtherBgmListByType: {
    method: "post",
    url: "/deraBgmType/getOtherBgmListByType",
    config: {},
  },
  //积分兑换   
  memRedeemRedeemHis: {
    method: "post",
    url: "/memRedeem/redeemHis",
    config: {},
  },
  //导入会员卡列表   
  memberImportExcel: {
    method: "post",
    url: "/member/importExcel",
    config: {},
  },
  //库存分布查询   
  deraBgmTypeBgsDistribute: {
    method: "post",
    url: "/deraBgmType/bgsDistributeAll",
    config: {},
  },
  //收款台查询会员卡   
  memberDeskQueryMem: {
    method: "post",
    url: "/member/deskQueryMem",
    config: {},
  },
  //查询采购库存退货单待提交列表   
  RgApplyQueryStockOneStep: {
    method: "post",
    url: "/RgApply/queryStockOneStep",
    config: {},
  },
  //库存采退一步新增   
  RgApplyAddStockRgOneStep: {
    method: "post",
    url: "/RgApply/addStockRgOneStep",
    config: {},
  },
  //获取商品列表可参与的调价方案   
  sellPlanCheckBgmTjPlan: {
    method: "post",
    url: "/sellPlan/checkBgmTjPlan",
    config: {},
  },
  //修改商品条码   
  retailChangeBarCode: {
    method: "post",
    url: "/retail/changeBarCode",
    config: {},
  },
  //查询最近单据   
  retailQueryNear: {
    method: "post",
    url: "/retail/queryNear",
    config: {},
  },
  //获取单据明细信息   
  retailGetDetailPrintById: {
    method: "post",
    url: "/retail/getDetailPrintById",
    config: {},
  },
  //修改积分   
  memRedeemPointChange: {
    method: "post",
    url: "/memRedeem/pointChange",
    config: {},
  },
  //获取按键映射   
  cashdeskGetKeyMap: {
    method: "post",
    url: "/cashdesk/getKeyMap",
    config: {},
  },
  //获取按键列表   
  cashdeskGetKeyList: {
    method: "post",
    url: "/cashdesk/getKeyList",
    config: {},
  },
  //更新按键映射   
  cashdeskUpdateKeyMap: {
    method: "post",
    url: "/cashdesk/updateKeyMap",
    config: {},
  },
  //初始化拆零数据   
  splitSingleInitSplit: {
    method: "post",
    url: "/splitSingle/initSplit ",
    config: {},
  },
  //初始化加密校验   
  memberInitCheck: {
    method: "post",
    url: "/member/initCheck",
    config: {},
  },
  //导入促销方案
  sellPlanImportExcel: {
    method: "post",
    url: "/sellPlan/importExcel",
    config: {},
  },
  //导入促销参与商品
  sellPlanImportCLCXExcel: {
    method: "post",
    url: "/sellPlan/importCLCXExcel",
    config: {},
  },
  //获取卤药品种
  priceGroupGetLyBgm: {
    method: "post",
    url: "/priceGroup/getLyBgm",
    config: {},
  },
  //查询配送出库单带票和不带票
  deliveryOutGetMagType: {
    method: "post",
    url: "/dera/deliveryOut/getMagType",
    config: {},
  },
  //查询业务商品最大编码
  BusinessGoodQueryMaxCode: {
    method: "post",
    url: "/BusinessGood/queryMaxCode",
    config: {},
  },
  //查询业务商品最大编码
  stockStatisticsQueryStoreStockHistory: {
    method: "post",
    url: "/stockStatistics/queryStoreStockHistory",
    config: {},
  },
  //获取直退品种
  priceGroupGetZtBgm: {
    method: "post",
    url: "/priceGroup/getZtBgm",
    config: {},
  },
  //单商品库存分布查询
  deraBgmTypeBgsDistributeByBgmCode: {
    method: "post",
    url: "/deraBgmType/bgsDistributeByBgmCode",
    config: {},
  },
  //消耗单确认列表 
  consumeAdminQueryWaitconfirm: {
    method: "post",
    url: "/consumeAdmin/queryWaitconfirm",
    config: {},
  },
  //获取当前库存 
  getStockList: {
    method: "post",
    url: "/ext/priceManage/getStockList",
    config: {},
  },
  //获取平台列表 
  getPlatformList: {
    method: "post",
    url: "/ext/priceManage/getPlatformList",
    config: {},
  },
  //维护价格策略 
  changePriceInfo: {
    method: "post",
    url: "/ext/priceManage/changePriceInfo",
    config: {},
  },
  //设置加价 
  changePriceInfoByRate: {
    method: "post",
    url: "/ext/priceManage/changePriceInfoByRate",
    config: {},
  },
  //查询对应价格策略 
  getPriceInfo: {
    method: "post",
    url: "/ext/priceManage/getPriceInfo",
    config: {},
  },
  //查询组织绑定商品列表接口
  bgmRelationgetRelationList: {
    method: "post",
    url: "/ext/bgmRelation/getRelationList",
    config: {},
  },
  //新增组织绑定商品
  bgmRelationaddRelation: {
    method: "post",
    url: "/ext/bgmRelation/addRelation",
    config: {},
  },
  //删除组织绑定商品
  bgmRelationdelRelation: {
    method: "post",
    url: "/ext/bgmRelation/delRelation",
    config: {},
  },
  //查询不合格详细 
  RegUnquaQueryDetail: {
    method: "post",
    url: "/RegUnqua/queryDetail",
    config: {},
  },
  //查询不合格详细 
  LossunquaQueryDetail: {
    method: "post",
    url: "/Lossunqua/queryDetail",
    config: {},
  },
  //不合格销毁列表 
  DesunquaQueryDetail: {
    method: "post",
    url: "/Desunqua/queryDetail",
    config: {},
  },
  //外部订单池查询列表SPD 
  orderpoolQuerySpd: {
    method: "post",
    url: "/orderpool/querySpd",
    config: {},
  },
  //tab2外部订单池查询列表SPD
  orderpoolQuerySpd2: {
    method: "post",
    url: "/orderpool/querySettleList",
    config: {},
  },
  //外部订单池查询列表SPD明细
  orderpoolQuerySpdDetail: {
    method: "post",
    url: "/orderpool/queryDetail",
    config: {},
  },
  //tab2外部订单池查询列表SPD明细
  orderpoolQuerySpdDetail2: {
    method: "post",
    url: "/orderpool/querySettleDetailList",
    config: {},
  },
  //外部订单绑定单位SPD
  orderpoolBindUnitSpd: {
    method: "post",
    url: "/orderpool/bindUnitSpd",
    config: {},
  },
  //外部订单明细绑定商品
  orderpoolBindBgmSpd: {
    method: "post",
    url: "/orderpool/bindBgmSpd",
    config: {},
  },
  //积分预计算
  retailPointPreCheck: {
    method: "post",
    url: "/retail/pointPreCheck",
    config: {},
  },
  // 接口
  pageFormText: {
    method: "post",
    url: "/jurconfig/jur",
    config: {},
  },
  // spd订单绑定客户双击
  orderbindCmSpd: {
    method: "post",
    url: "/orderpool/bindCmSpd",
    config: {},
  },
  // 查询付款状态
  orderMsggetByOrderKey: {
    method: "post",
    url: "/orderMsg/getByOrderKey",
    config: {},
  },
  // 线上支付退款查询---查询
  retailgetWebRejHis: {
    method: "post",
    url: "/retail/getWebRejHis",
    config: {},
  },
  // 线上支付退款查询---检查线上退款状态
  retailcheckWebRejState: {
    method: "post",
    url: "/retail/checkWebRejState",
    config: {},
  },
  //获取单个门店配置
  retailWebgetSingleStoreConfig: {
    method: "post",
    url: "/retailWeb/getSingleStoreConfig",
    config: {},
  },
  //设置门店默认配置
  retailWebsetStoreDefaultConfig: {
    method: "post",
    url: "/retailWeb/setStoreDefaultConfig",
    config: {},
  },
  //获取线上店铺信息
  retailWebgetWebShopInfo: {
    method: "post",
    url: "/retailWeb/getWebShopInfo",
    config: {},
  },
  //设置线上店铺信息
  retailWebsetWebShopInfo: {
    method: "post",
    url: "/retailWeb/setWebShopInfo",
    config: {},
  },
  //获取上单销售员
  storemastgetLaseSalesPerson: {
    method: "post",
    url: "/storemast/getLaseSalesPerson",
    config: {},
  },
  //模拟生成打印数据
  printDataretailOrderPrePrint: {
    method: "post",
    url: "/printData/retailOrderPrePrint",
    config: {},
  },
  //获取交班单打印数据
  printDataretailBcPrint: {
    method: "post",
    url: "/printData/retailBcPrint",
    config: {},
  },
  //取消订单支付
  orderMsgcancelOrder: {
    method: "post",
    url: "/orderMsg/cancelOrder",
    config: {},
  },

  //新增草稿 
  draftAddDraft: {
    method: "post",
    url: "/draft/addDraft",
    config: {},
  },
  //查询草稿列表 
  draftGetList: {
    method: "post",
    url: "/draft/getList",
    config: {},
  },
  //删除 
  draftDelById: {
    method: "post",
    url: "/draft/delById",
    config: {},
  },
  //门店价格维护--查询
  priceGroupgetStorePriceList: {
    method: "post",
    url: "/priceGroup/getStorePriceList",
    config: {},
  },
  //门店价格维护--新增
  priceGroupaddStorePrice: {
    method: "post",
    url: "/priceGroup/addStorePrice",
    config: {},
  },
  //门店价格维护--修改
  priceGroupupdateStorePrice: {
    method: "post",
    url: "/priceGroup/updateStorePrice",
    config: {},
  },
  //门店价格维护--删除
  priceGroupdelStorePrice: {
    method: "post",
    url: "/priceGroup/delStorePrice",
    config: {},
  },
  //提取O2O订单--查询
  retailWebqueryO2OOrder: {
    method: "post",
    url: "/retailWeb/queryO2OOrder",
    config: {},
  },
  //导入零售记录
  retailimportRetailExcel: {
    method: "post",
    url: "retail/importRetailExcel",
    config: {},
  },
  //获取请货方案列表
  deragetGenPlanList: {
    method: "post",
    url: "dera/applyGoods/getGenPlanList",
    config: {},
  },
  //提生成单据信息，在请货新增页面使用
  deragetGenOrderDetail: {
    method: "post",
    url: "dera/applyGoods/getGenOrderDetail",
    config: {},
  },
  //提成等级--查询
  deraGrossRulequeryGrossRule: {
    method: "post",
    url: "deraGrossRule/queryGrossRule",
    config: {},
  },
  //提成等级--保存
  deraGrossRulesaveGrossRule: {
    method: "post",
    url: "deraGrossRule/saveGrossRule",
    config: {},
  },
    //价格拦截检验
  consumeAdminPriceIntercept: {
    method: "post",
    url: "consumeAdmin/priceIntercept",
    config: {},
  },
  //修改供应商地址状态 
  gspSupplierUpdateAddressState: {
    method: "post",
    url: "/gspSupplier/updateAddressState",
    config: {},
  },
  //修改客户地址状态 
  gspCustomerUpdateAddressState: {
    method: "post",
    url: "/gspCustomer/updateAddressState",
    config: {},
  },

  //检验是否需要首次登录修改密码 
  LoginCheckChangePwd: {
    method: "post",
    url: "/Login/checkChangePwd",
    config: {},
  },
  // 促销 导出方案历史
  sellPlanExportPlanListHistory: {
    method: "get",
    url: "/sellPlan/exportPlanListHistory",
    config: {},
  },
  // 导出价格组下商品 
  priceGroupExportWebRetailOrderDetail: {
    method: "get",
    url: "/priceGroup/exportWebRetailOrderDetail",
    config: {},
  },
  // 导出单据明细 
  psdocumentsExportDetail: {
    method: "get",
    url: "/psdocuments/exportDetail",
    config: {responseType: 'blob'},
  },
  // 导出单据明细 
  RgApplyExportDetailData: {
    method: "post",
    url: "/RgApply/exportDetailData",
    config: {responseType: 'blob'},
  },
  sudrawbillExportSudrawbill: {
    method: "post",
    url: "/sudrawbill/exportSudrawbill",
    config: {
      responseType: 'blob'
    },
  },
  //客户销售状态调整
  cusmasterModifySuState: {
    method: "post",
    url: "/cusmaster/modifySuState",
    config: {
    },
  },
  //供应商采购状态调整
  supplierModifyPuState: {
    method: "post",
    url: "/supplier/modifyPuState",
    config: {
    },
  },
    //获取拒收确认列表
  rejectedInBackConformList: {
    method: "post",
    url: "/dera/rejectedIn/backConformList",
    config: {
    },
  },
    //拒收确认
  rejectedInBackConform: {
    method: "post",
    url: "/dera/rejectedIn/backConform",
    config: {
    },
  },
  //查询预出库单失败记录
  pwoapplyQueryDataflowFailed: {
    method: "post",
    url: "/pwoapply/queryDataflowFailed",
    config: {
    },
  },
  //重试预出库单数据流
  pwoapplyRetryDataflow: {
    method: "post",
    url: "/pwoapply/retryDataflow",
    config: {
    },
  },
  //查询消耗单失败记录
  consumeAdminQueryConsumeDataflowFailed: {
    method: "post",
    url: "/consumeAdmin/queryConsumeDataflowFailed",
    config: {
    },
  },
  //重试消耗单数据流
  consumeAdminRetryConsumeDataflow: {
    method: "post",
    url: "/consumeAdmin/retryConsumeDataflow",
    config: {
    },
  },
  //查询回库单失败记录
  consumeAdminQueryReturnDataflowFailed: {
    method: "post",
    url: "/consumeAdmin/queryReturnDataflowFailed",
    config: {
    },
  },
  //重试回库单数据流
  consumeAdminRetryReturnDataflow: {
    method: "post",
    url: "/consumeAdmin/retryReturnDataflow",
    config: {
    },
  },
  //查询费用核算详情
  queryMoneyAccountingDetail: {
    method: "post",
    url: "/highvalue/queryMoneyAccountingDetail",
    config: {
    },
  },
  //查询WMS异常收货待审核任务
  recependQueryTask: {
    method: "post",
    url: "/recepend/queryTask",
    config: {
    },
  },
  //查询WMS异常收货历史列表
  recependQueryHis: {
    method: "post",
    url: "/recepend/queryHis",
    config: {
    },
  },
  //查询WMS异常收货明细
  recependDetail: {
    method: "post",
    url: "/recepend/detail",
    config: {
    },
  },
  //提交WMS异常收货审核
  recependSubmit: {
    method: "post",
    url: "/recepend/submit",
    config: {
    },
  },
}

// 对象导出去
export default API_LIST
